import { jsx as r, jsxs as m, Fragment as G } from "react/jsx-runtime";
import ae, { forwardRef as et, createElement as Le, useState as N, useRef as te, useEffect as $, useMemo as le, useCallback as de, useLayoutEffect as Yo } from "react";
import ge from "react-dom";
import { useQueryClient as mo, useQuery as Jo } from "@tanstack/react-query";
function mi(e) {
  return `$${e.toFixed(2)}`;
}
function gi(e) {
  return new Date(e).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric"
  });
}
function ui(e) {
  const t = new Date(e), n = (/* @__PURE__ */ new Date()).getTime() - t.getTime(), a = Math.floor(n / (1e3 * 60 * 60 * 24));
  return a === 0 ? "Today" : a === 1 ? "Yesterday" : a < 7 ? `${a} days ago` : t.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric"
  });
}
function hi(e, t) {
  return t > 0 ? Math.round(e * 100 / t) : 0;
}
function yi(e) {
  return e.toLowerCase().replace(/[^\w\s-]/g, "").replace(/\s+/g, "-").replace(/--+/g, "-").substring(0, 50);
}
function bi(e) {
  return {
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700
  }[e] || 400;
}
function fi(e, t) {
  return e.length <= t ? e : e.slice(0, t - 3) + "...";
}
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xo = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), Uo = (e) => e.replace(
  /^([A-Z])|[\s-_]+(\w)/g,
  (t, o, n) => n ? n.toUpperCase() : o.toLowerCase()
), at = (e) => {
  const t = Uo(e);
  return t.charAt(0).toUpperCase() + t.slice(1);
}, go = (...e) => e.filter((t, o, n) => !!t && t.trim() !== "" && n.indexOf(t) === o).join(" ").trim(), Zo = (e) => {
  for (const t in e)
    if (t.startsWith("aria-") || t === "role" || t === "title")
      return !0;
};
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var qo = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vo = et(
  ({
    color: e = "currentColor",
    size: t = 24,
    strokeWidth: o = 2,
    absoluteStrokeWidth: n,
    className: a = "",
    children: l,
    iconNode: d,
    ...p
  }, c) => Le(
    "svg",
    {
      ref: c,
      ...qo,
      width: t,
      height: t,
      stroke: e,
      strokeWidth: n ? Number(o) * 24 / Number(t) : o,
      className: go("lucide", a),
      ...!l && !Zo(p) && { "aria-hidden": "true" },
      ...p
    },
    [
      ...d.map(([u, s]) => Le(u, s)),
      ...Array.isArray(l) ? l : [l]
    ]
  )
);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ee = (e, t) => {
  const o = et(
    ({ className: n, ...a }, l) => Le(Vo, {
      ref: l,
      iconNode: t,
      className: go(
        `lucide-${Xo(at(e))}`,
        `lucide-${e}`,
        n
      ),
      ...a
    })
  );
  return o.displayName = at(e), o;
};
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ko = [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]], Ce = ee("check", Ko);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _o = [["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]], tt = ee("chevron-right", _o);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const er = [
  ["path", { d: "M21.801 10A10 10 0 1 1 17 3.335", key: "yps3ct" }],
  ["path", { d: "m9 11 3 3L22 4", key: "1pflzl" }]
], tr = ee("circle-check-big", er);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const or = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "m9 9 6 6", key: "z0biqf" }]
], rr = ee("circle-x", or);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nr = [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "12", cy: "5", r: "1", key: "gxeob9" }],
  ["circle", { cx: "12", cy: "19", r: "1", key: "lyex9k" }]
], ar = ee("ellipsis-vertical", nr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ir = [
  ["path", { d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", key: "1357e3" }],
  ["path", { d: "M3 3v5h5", key: "1xhq8a" }],
  ["path", { d: "M12 7v5l4 2", key: "1fdv2h" }]
], lr = ee("history", ir);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sr = [
  ["path", { d: "M12 2v4", key: "3427ic" }],
  ["path", { d: "m16.2 7.8 2.9-2.9", key: "r700ao" }],
  ["path", { d: "M18 12h4", key: "wj9ykh" }],
  ["path", { d: "m16.2 16.2 2.9 2.9", key: "1bxg5t" }],
  ["path", { d: "M12 18v4", key: "jadmvz" }],
  ["path", { d: "m4.9 19.1 2.9-2.9", key: "bwix9q" }],
  ["path", { d: "M2 12h4", key: "j09sii" }],
  ["path", { d: "m4.9 4.9 2.9 2.9", key: "giyufr" }]
], cr = ee("loader", sr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dr = [
  ["path", { d: "m16 17 5-5-5-5", key: "1bji2h" }],
  ["path", { d: "M21 12H9", key: "dn1m92" }],
  ["path", { d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4", key: "1uf3rs" }]
], it = ee("log-out", dr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pr = [
  ["path", { d: "M15 3h6v6", key: "1q9fwt" }],
  ["path", { d: "m21 3-7 7", key: "1l2asr" }],
  ["path", { d: "m3 21 7-7", key: "tjx5ai" }],
  ["path", { d: "M9 21H3v-6", key: "wtvkvv" }]
], mr = ee("maximize-2", pr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gr = [
  ["path", { d: "m14 10 7-7", key: "oa77jy" }],
  ["path", { d: "M20 10h-6V4", key: "mjg0md" }],
  ["path", { d: "m3 21 7-7", key: "tjx5ai" }],
  ["path", { d: "M4 14h6v6", key: "rmj7iw" }]
], ur = ee("minimize-2", gr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hr = [
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["line", { x1: "8", x2: "16", y1: "21", y2: "21", key: "1svkeh" }],
  ["line", { x1: "12", x2: "12", y1: "17", y2: "21", key: "vw1qmm" }]
], yr = ee("monitor", hr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const br = [
  [
    "path",
    {
      d: "M12 22a1 1 0 0 1 0-20 10 9 0 0 1 10 9 5 5 0 0 1-5 5h-2.25a1.75 1.75 0 0 0-1.4 2.8l.3.4a1.75 1.75 0 0 1-1.4 2.8z",
      key: "e79jfc"
    }
  ],
  ["circle", { cx: "13.5", cy: "6.5", r: ".5", fill: "currentColor", key: "1okk4w" }],
  ["circle", { cx: "17.5", cy: "10.5", r: ".5", fill: "currentColor", key: "f64h9f" }],
  ["circle", { cx: "6.5", cy: "12.5", r: ".5", fill: "currentColor", key: "qy21gx" }],
  ["circle", { cx: "8.5", cy: "7.5", r: ".5", fill: "currentColor", key: "fotxhn" }]
], lt = ee("palette", br);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fr = [
  [
    "path",
    {
      d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
      key: "1a8usu"
    }
  ],
  ["path", { d: "m15 5 4 4", key: "1mk7zo" }]
], uo = ee("pencil", fr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xr = [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "M12 5v14", key: "s699le" }]
], ot = ee("plus", xr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cr = [
  ["path", { d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", key: "1357e3" }],
  ["path", { d: "M3 3v5h5", key: "1xhq8a" }]
], kr = ee("rotate-ccw", Cr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vr = [
  ["path", { d: "m21 21-4.34-4.34", key: "14j7rj" }],
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }]
], ho = ee("search", vr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wr = [
  [
    "path",
    {
      d: "M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915",
      key: "1i5ecw"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
], st = ee("settings", wr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sr = [
  ["rect", { width: "14", height: "20", x: "5", y: "2", rx: "2", ry: "2", key: "1yt0o3" }],
  ["path", { d: "M12 18h.01", key: "mhygvu" }]
], Br = ee("smartphone", Sr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zr = [
  ["path", { d: "M12 3v12", key: "1x0j5s" }],
  ["path", { d: "m17 8-5-5-5 5", key: "7q97r8" }],
  ["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4", key: "ih7n3h" }]
], yo = ee("upload", zr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fr = [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
], ue = ee("x", Fr), i = {
  // Primary colors
  primary: "#031425",
  white: "#fff",
  // Grays
  gray_light: "#e8e8ed",
  gray_medium: "#7e8fa8",
  gray_dark: "#3a3a3a",
  gray_border: "#bec7d3",
  // Blues
  blue: "#5572b7",
  blue_dark: "#181d56",
  blue_light: "#f6f8fa",
  // Greens
  green: "#71c285",
  green_light: "#9ee0d0",
  // Reds
  red: "#ff534a",
  red_light: "#ffeeed",
  // Yellows
  yellow: "#ffbd32",
  yellow_light: "#fff8ea",
  // Background colors
  bg_light: "#f7f8f9",
  bg_white: "#ffffff",
  // Glassmorphism & Modern UI
  glass_bg: "rgba(255, 255, 255, 0.85)",
  glass_bg_strong: "rgba(255, 255, 255, 0.95)",
  border_subtle: "rgba(255, 255, 255, 0.6)",
  border_glass: "rgba(0, 0, 0, 0.06)",
  shadow_soft: "rgba(0, 0, 0, 0.04)",
  shadow_medium: "rgba(0, 0, 0, 0.08)",
  overlay_light: "rgba(255, 255, 255, 0.5)"
}, Tr = {
  sm: {
    padding: "6px 14px",
    fontSize: "12px",
    borderRadius: "8px",
    gap: "5px"
  },
  md: {
    padding: "10px 18px",
    fontSize: "13px",
    borderRadius: "10px",
    gap: "6px"
  },
  lg: {
    padding: "12px 24px",
    fontSize: "14px",
    borderRadius: "12px",
    gap: "8px"
  }
}, Er = {
  sm: {
    padding: "6px",
    fontSize: "12px",
    borderRadius: "8px",
    width: "28px",
    height: "28px"
  },
  md: {
    padding: "8px",
    fontSize: "13px",
    borderRadius: "10px",
    width: "34px",
    height: "34px"
  },
  lg: {
    padding: "10px",
    fontSize: "14px",
    borderRadius: "12px",
    width: "42px",
    height: "42px"
  }
}, Pr = (e, t, o) => {
  switch (e) {
    case "primary":
      return {
        background: o ? i.blue_dark : t ? `linear-gradient(135deg, ${i.blue_dark} 0%, #252b6e 100%)` : `linear-gradient(135deg, ${i.blue_dark} 0%, #1f2463 100%)`,
        color: i.white,
        border: "none",
        boxShadow: t ? "0 4px 14px rgba(24, 29, 86, 0.35)" : "0 2px 8px rgba(24, 29, 86, 0.2)",
        transform: t && !o ? "translateY(-1px)" : "none"
      };
    case "secondary":
      return {
        background: o ? i.gray_border : i.gray_light,
        color: i.primary,
        border: "none",
        boxShadow: "none",
        transform: "none"
      };
    case "danger":
      return {
        background: o ? "linear-gradient(135deg, #e63e37 0%, #d13530 100%)" : t ? `linear-gradient(135deg, ${i.red} 0%, #e63e37 100%)` : `linear-gradient(135deg, ${i.red} 0%, #e63e37 100%)`,
        color: i.white,
        border: "none",
        boxShadow: t ? "0 4px 12px rgba(255, 83, 74, 0.35)" : "0 2px 6px rgba(255, 83, 74, 0.25)",
        transform: t && !o ? "translateY(-1px)" : "none"
      };
    case "ghost":
      return {
        background: o ? "rgba(0, 0, 0, 0.08)" : t ? "rgba(0, 0, 0, 0.04)" : "transparent",
        color: i.primary,
        border: "none",
        boxShadow: "none",
        transform: "none"
      };
    case "outline":
      return {
        background: o ? i.blue_light : t ? "rgba(24, 29, 86, 0.04)" : i.white,
        color: i.blue_dark,
        border: `2px solid ${i.blue_dark}`,
        boxShadow: "none",
        transform: t && !o ? "translateY(-1px)" : "none"
      };
    case "icon":
      return {
        background: o ? "rgba(0, 0, 0, 0.1)" : t ? "rgba(0, 0, 0, 0.05)" : "transparent",
        color: i.gray_medium,
        border: "none",
        boxShadow: "none",
        transform: "none"
      };
    default:
      return {};
  }
}, U = et(
  ({
    variant: e = "primary",
    size: t = "md",
    leftIcon: o,
    rightIcon: n,
    isLoading: a = !1,
    pill: l = !1,
    disabled: d,
    children: p,
    style: c,
    ...u
  }, s) => {
    const [g, y] = N(!1), [k, f] = N(!1), b = d || a, h = e === "icon" ? Er[t] : Tr[t], w = l ? "200px" : h.borderRadius, B = {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      fontWeight: 600,
      cursor: b ? "not-allowed" : "pointer",
      opacity: b ? 0.5 : 1,
      transition: "all 0.2s ease",
      outline: "none",
      whiteSpace: "nowrap",
      fontFamily: "inherit",
      ...h,
      borderRadius: w,
      ...Pr(
        e,
        !b && g,
        !b && k
      ),
      ...c
    };
    return /* @__PURE__ */ r(
      "button",
      {
        ref: s,
        disabled: b,
        style: B,
        onMouseEnter: () => y(!0),
        onMouseLeave: () => {
          y(!1), f(!1);
        },
        onMouseDown: () => f(!0),
        onMouseUp: () => f(!1),
        ...u,
        children: a ? /* @__PURE__ */ r(Ir, { size: t }) : /* @__PURE__ */ m(G, { children: [
          o && /* @__PURE__ */ r(
            "span",
            {
              style: {
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center"
              },
              children: o
            }
          ),
          p,
          n && /* @__PURE__ */ r(
            "span",
            {
              style: {
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center"
              },
              children: n
            }
          )
        ] })
      }
    );
  }
);
U.displayName = "Button";
const Ir = ({ size: e }) => {
  const t = e === "sm" ? 12 : e === "md" ? 14 : 16;
  return /* @__PURE__ */ m(
    "svg",
    {
      width: t,
      height: t,
      viewBox: "0 0 24 24",
      fill: "none",
      style: {
        animation: "bc-button-spin 1s linear infinite"
      },
      children: [
        /* @__PURE__ */ r("style", { children: `
          @keyframes bc-button-spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        ` }),
        /* @__PURE__ */ r(
          "circle",
          {
            cx: "12",
            cy: "12",
            r: "10",
            stroke: "currentColor",
            strokeWidth: "3",
            strokeLinecap: "round",
            strokeDasharray: "32",
            strokeDashoffset: "12"
          }
        )
      ]
    }
  );
}, bo = () => typeof window > "u" ? !1 : window.self !== window.top, Re = () => {
  var e, t;
  return typeof window > "u" ? document.body : window.self !== window.top && ((t = (e = window.parent) == null ? void 0 : e.document) != null && t.body) ? window.parent.document.body : document.body;
}, je = () => {
  var e;
  return typeof window > "u" ? document : window.self !== window.top && ((e = window.parent) != null && e.document) ? window.parent.document : document;
}, Mr = async () => {
  if (typeof window > "u") return !0;
  try {
    const t = (await fetch(window.location.href, { method: "HEAD" })).headers.get("Content-Security-Policy");
    return !(t != null && t.includes("frame-ancestors 'none'"));
  } catch {
    return !0;
  }
}, Ar = () => {
  const [e, t] = N({ x: 0, y: 0 }), [o, n] = N(!1), a = te({ x: 0, y: 0 }), l = (d) => {
    n(!0), a.current = {
      x: d.clientX - e.x,
      y: d.clientY - e.y
    };
  };
  return $(() => {
    const d = (c) => {
      o && t({
        x: c.clientX - a.current.x,
        y: c.clientY - a.current.y
      });
    }, p = () => {
      n(!1);
    };
    if (o) {
      const c = je();
      return c.addEventListener("mousemove", d), c.addEventListener("mouseup", p), () => {
        c.removeEventListener("mousemove", d), c.removeEventListener("mouseup", p);
      };
    }
  }, [o]), { dragOffset: e, isDragging: o, handleMouseDown: l };
}, ke = ({
  title: e,
  message: t,
  confirmLabel: o = "Save",
  cancelLabel: n = "Discard",
  onConfirm: a,
  onCancel: l,
  isLoading: d = !1
}) => {
  const p = /* @__PURE__ */ m(G, { children: [
    /* @__PURE__ */ r("style", { children: `
        .confirm-dialog-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000010;
        }

        .confirm-dialog-container {
          background: ${i.white};
          border-radius: 12px;
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
          max-width: 400px;
          width: 90%;
          padding: 24px;
        }

        .confirm-dialog-title {
          margin: 0 0 12px;
          font-size: 18px;
          font-weight: 600;
          color: ${i.primary};
        }

        .confirm-dialog-message {
          margin: 0 0 24px;
          font-size: 14px;
          color: ${i.gray_medium};
          line-height: 1.5;
        }

        .confirm-dialog-actions {
          display: flex;
          gap: 12px;
          justify-content: flex-end;
        }
      ` }),
    /* @__PURE__ */ r("div", { className: "confirm-dialog-overlay", onClick: l, children: /* @__PURE__ */ m(
      "div",
      {
        className: "confirm-dialog-container",
        onClick: (c) => c.stopPropagation(),
        children: [
          /* @__PURE__ */ r("h3", { className: "confirm-dialog-title", children: e }),
          /* @__PURE__ */ r("p", { className: "confirm-dialog-message", children: t }),
          /* @__PURE__ */ m("div", { className: "confirm-dialog-actions", children: [
            /* @__PURE__ */ r(
              U,
              {
                variant: "ghost",
                size: "sm",
                onClick: l,
                disabled: d,
                children: n
              }
            ),
            /* @__PURE__ */ r(
              U,
              {
                variant: "primary",
                size: "sm",
                onClick: a,
                isLoading: d,
                disabled: d,
                children: o
              }
            )
          ] })
        ]
      }
    ) })
  ] });
  return ge.createPortal(p, Re());
}, Nr = ({ value: e, onChange: t }) => {
  const [o, n] = N(e || "");
  return $(() => {
    n(e || "");
  }, [e]), /* @__PURE__ */ r(
    "input",
    {
      type: "text",
      value: o,
      onChange: (l) => {
        const d = l.target.value;
        n(d), t(d);
      },
      className: "edit-panel-input",
      style: {
        width: "100%",
        padding: "12px 14px",
        border: `1px solid ${i.border_glass}`,
        borderRadius: "10px",
        fontSize: "13px",
        color: i.primary,
        boxSizing: "border-box",
        transition: "all 0.15s ease",
        background: i.white,
        outline: "none"
      }
    }
  );
}, Hr = ({
  value: e,
  onChange: t,
  field: o
}) => {
  var n, a;
  return /* @__PURE__ */ r(
    "select",
    {
      value: e ?? ((a = (n = o.options) == null ? void 0 : n[0]) == null ? void 0 : a.value) ?? "",
      onChange: (l) => t(l.target.value),
      className: "edit-panel-select",
      style: {
        width: "100%",
        padding: "12px 14px",
        border: `1px solid ${i.border_glass}`,
        borderRadius: "10px",
        fontSize: "13px",
        color: i.primary,
        boxSizing: "border-box",
        transition: "all 0.15s ease",
        background: i.white,
        cursor: "pointer",
        outline: "none",
        appearance: "none",
        backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%237e8fa8' d='M6 8L1 3h10z'/%3E%3C/svg%3E")`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "right 12px center",
        paddingRight: "36px"
      },
      children: (o.options ?? []).map((l) => /* @__PURE__ */ r("option", { value: l.value, children: l.label }, l.value))
    }
  );
};
function We() {
  return (We = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var o = arguments[t];
      for (var n in o) Object.prototype.hasOwnProperty.call(o, n) && (e[n] = o[n]);
    }
    return e;
  }).apply(this, arguments);
}
function fo(e, t) {
  if (e == null) return {};
  var o, n, a = {}, l = Object.keys(e);
  for (n = 0; n < l.length; n++) t.indexOf(o = l[n]) >= 0 || (a[o] = e[o]);
  return a;
}
function Ge(e) {
  var t = te(e), o = te(function(n) {
    t.current && t.current(n);
  });
  return t.current = e, o.current;
}
var ve = function(e, t, o) {
  return t === void 0 && (t = 0), o === void 0 && (o = 1), e > o ? o : e < t ? t : e;
}, xe = function(e) {
  return "touches" in e;
}, Qe = function(e) {
  return e && e.ownerDocument.defaultView || self;
}, ct = function(e, t, o) {
  var n = e.getBoundingClientRect(), a = xe(t) ? function(l, d) {
    for (var p = 0; p < l.length; p++) if (l[p].identifier === d) return l[p];
    return l[0];
  }(t.touches, o) : t;
  return { left: ve((a.pageX - (n.left + Qe(e).pageXOffset)) / n.width), top: ve((a.pageY - (n.top + Qe(e).pageYOffset)) / n.height) };
}, dt = function(e) {
  !xe(e) && e.preventDefault();
}, xo = ae.memo(function(e) {
  var t = e.onMove, o = e.onKey, n = fo(e, ["onMove", "onKey"]), a = te(null), l = Ge(t), d = Ge(o), p = te(null), c = te(!1), u = le(function() {
    var k = function(h) {
      dt(h), (xe(h) ? h.touches.length > 0 : h.buttons > 0) && a.current ? l(ct(a.current, h, p.current)) : b(!1);
    }, f = function() {
      return b(!1);
    };
    function b(h) {
      var w = c.current, B = Qe(a.current), T = h ? B.addEventListener : B.removeEventListener;
      T(w ? "touchmove" : "mousemove", k), T(w ? "touchend" : "mouseup", f);
    }
    return [function(h) {
      var w = h.nativeEvent, B = a.current;
      if (B && (dt(w), !function(S, z) {
        return z && !xe(S);
      }(w, c.current) && B)) {
        if (xe(w)) {
          c.current = !0;
          var T = w.changedTouches || [];
          T.length && (p.current = T[0].identifier);
        }
        B.focus(), l(ct(B, w, p.current)), b(!0);
      }
    }, function(h) {
      var w = h.which || h.keyCode;
      w < 37 || w > 40 || (h.preventDefault(), d({ left: w === 39 ? 0.05 : w === 37 ? -0.05 : 0, top: w === 40 ? 0.05 : w === 38 ? -0.05 : 0 }));
    }, b];
  }, [d, l]), s = u[0], g = u[1], y = u[2];
  return $(function() {
    return y;
  }, [y]), ae.createElement("div", We({}, n, { onTouchStart: s, onMouseDown: s, className: "react-colorful__interactive", ref: a, onKeyDown: g, tabIndex: 0, role: "slider" }));
}), rt = function(e) {
  return e.filter(Boolean).join(" ");
}, Co = function(e) {
  var t = e.color, o = e.left, n = e.top, a = n === void 0 ? 0.5 : n, l = rt(["react-colorful__pointer", e.className]);
  return ae.createElement("div", { className: l, style: { top: 100 * a + "%", left: 100 * o + "%" } }, ae.createElement("div", { className: "react-colorful__pointer-fill", style: { backgroundColor: t } }));
}, ie = function(e, t, o) {
  return t === void 0 && (t = 0), o === void 0 && (o = Math.pow(10, t)), Math.round(o * e) / o;
}, Or = function(e) {
  return jr($e(e));
}, $e = function(e) {
  return e[0] === "#" && (e = e.substring(1)), e.length < 6 ? { r: parseInt(e[0] + e[0], 16), g: parseInt(e[1] + e[1], 16), b: parseInt(e[2] + e[2], 16), a: e.length === 4 ? ie(parseInt(e[3] + e[3], 16) / 255, 2) : 1 } : { r: parseInt(e.substring(0, 2), 16), g: parseInt(e.substring(2, 4), 16), b: parseInt(e.substring(4, 6), 16), a: e.length === 8 ? ie(parseInt(e.substring(6, 8), 16) / 255, 2) : 1 };
}, Rr = function(e) {
  return Lr(Dr(e));
}, Wr = function(e) {
  var t = e.s, o = e.v, n = e.a, a = (200 - t) * o / 100;
  return { h: ie(e.h), s: ie(a > 0 && a < 200 ? t * o / 100 / (a <= 100 ? a : 200 - a) * 100 : 0), l: ie(a / 2), a: ie(n, 2) };
}, Ye = function(e) {
  var t = Wr(e);
  return "hsl(" + t.h + ", " + t.s + "%, " + t.l + "%)";
}, Dr = function(e) {
  var t = e.h, o = e.s, n = e.v, a = e.a;
  t = t / 360 * 6, o /= 100, n /= 100;
  var l = Math.floor(t), d = n * (1 - o), p = n * (1 - (t - l) * o), c = n * (1 - (1 - t + l) * o), u = l % 6;
  return { r: ie(255 * [n, p, d, d, c, n][u]), g: ie(255 * [c, n, n, p, d, d][u]), b: ie(255 * [d, d, c, n, n, p][u]), a: ie(a, 2) };
}, ze = function(e) {
  var t = e.toString(16);
  return t.length < 2 ? "0" + t : t;
}, Lr = function(e) {
  var t = e.r, o = e.g, n = e.b, a = e.a, l = a < 1 ? ze(ie(255 * a)) : "";
  return "#" + ze(t) + ze(o) + ze(n) + l;
}, jr = function(e) {
  var t = e.r, o = e.g, n = e.b, a = e.a, l = Math.max(t, o, n), d = l - Math.min(t, o, n), p = d ? l === t ? (o - n) / d : l === o ? 2 + (n - t) / d : 4 + (t - o) / d : 0;
  return { h: ie(60 * (p < 0 ? p + 6 : p)), s: ie(l ? d / l * 100 : 0), v: ie(l / 255 * 100), a };
}, Gr = ae.memo(function(e) {
  var t = e.hue, o = e.onChange, n = rt(["react-colorful__hue", e.className]);
  return ae.createElement("div", { className: n }, ae.createElement(xo, { onMove: function(a) {
    o({ h: 360 * a.left });
  }, onKey: function(a) {
    o({ h: ve(t + 360 * a.left, 0, 360) });
  }, "aria-label": "Hue", "aria-valuenow": ie(t), "aria-valuemax": "360", "aria-valuemin": "0" }, ae.createElement(Co, { className: "react-colorful__hue-pointer", left: t / 360, color: Ye({ h: t, s: 100, v: 100, a: 1 }) })));
}), Qr = ae.memo(function(e) {
  var t = e.hsva, o = e.onChange, n = { backgroundColor: Ye({ h: t.h, s: 100, v: 100, a: 1 }) };
  return ae.createElement("div", { className: "react-colorful__saturation", style: n }, ae.createElement(xo, { onMove: function(a) {
    o({ s: 100 * a.left, v: 100 - 100 * a.top });
  }, onKey: function(a) {
    o({ s: ve(t.s + 100 * a.left, 0, 100), v: ve(t.v - 100 * a.top, 0, 100) });
  }, "aria-label": "Color", "aria-valuetext": "Saturation " + ie(t.s) + "%, Brightness " + ie(t.v) + "%" }, ae.createElement(Co, { className: "react-colorful__saturation-pointer", top: 1 - t.v / 100, left: t.s / 100, color: Ye(t) })));
}), ko = function(e, t) {
  if (e === t) return !0;
  for (var o in e) if (e[o] !== t[o]) return !1;
  return !0;
}, $r = function(e, t) {
  return e.toLowerCase() === t.toLowerCase() || ko($e(e), $e(t));
};
function Yr(e, t, o) {
  var n = Ge(o), a = N(function() {
    return e.toHsva(t);
  }), l = a[0], d = a[1], p = te({ color: t, hsva: l });
  $(function() {
    if (!e.equal(t, p.current.color)) {
      var u = e.toHsva(t);
      p.current = { hsva: u, color: t }, d(u);
    }
  }, [t, e]), $(function() {
    var u;
    ko(l, p.current.hsva) || e.equal(u = e.fromHsva(l), p.current.color) || (p.current = { hsva: l, color: u }, n(u));
  }, [l, e, n]);
  var c = de(function(u) {
    d(function(s) {
      return Object.assign({}, s, u);
    });
  }, []);
  return [l, c];
}
var Jr = typeof window < "u" ? Yo : $, Xr = function() {
  return typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : void 0;
}, pt = /* @__PURE__ */ new Map(), Ur = function(e) {
  Jr(function() {
    var t = e.current ? e.current.ownerDocument : document;
    if (t !== void 0 && !pt.has(t)) {
      var o = t.createElement("style");
      o.innerHTML = `.react-colorful{position:relative;display:flex;flex-direction:column;width:200px;height:200px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:default}.react-colorful__saturation{position:relative;flex-grow:1;border-color:transparent;border-bottom:12px solid #000;border-radius:8px 8px 0 0;background-image:linear-gradient(0deg,#000,transparent),linear-gradient(90deg,#fff,hsla(0,0%,100%,0))}.react-colorful__alpha-gradient,.react-colorful__pointer-fill{content:"";position:absolute;left:0;top:0;right:0;bottom:0;pointer-events:none;border-radius:inherit}.react-colorful__alpha-gradient,.react-colorful__saturation{box-shadow:inset 0 0 0 1px rgba(0,0,0,.05)}.react-colorful__alpha,.react-colorful__hue{position:relative;height:24px}.react-colorful__hue{background:linear-gradient(90deg,red 0,#ff0 17%,#0f0 33%,#0ff 50%,#00f 67%,#f0f 83%,red)}.react-colorful__last-control{border-radius:0 0 8px 8px}.react-colorful__interactive{position:absolute;left:0;top:0;right:0;bottom:0;border-radius:inherit;outline:none;touch-action:none}.react-colorful__pointer{position:absolute;z-index:1;box-sizing:border-box;width:28px;height:28px;transform:translate(-50%,-50%);background-color:#fff;border:2px solid #fff;border-radius:50%;box-shadow:0 2px 4px rgba(0,0,0,.2)}.react-colorful__interactive:focus .react-colorful__pointer{transform:translate(-50%,-50%) scale(1.1)}.react-colorful__alpha,.react-colorful__alpha-pointer{background-color:#fff;background-image:url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill-opacity=".05"><path d="M8 0h8v8H8zM0 8h8v8H0z"/></svg>')}.react-colorful__saturation-pointer{z-index:3}.react-colorful__hue-pointer{z-index:2}`, pt.set(t, o);
      var n = Xr();
      n && o.setAttribute("nonce", n), t.head.appendChild(o);
    }
  }, []);
}, Zr = function(e) {
  var t = e.className, o = e.colorModel, n = e.color, a = n === void 0 ? o.defaultColor : n, l = e.onChange, d = fo(e, ["className", "colorModel", "color", "onChange"]), p = te(null);
  Ur(p);
  var c = Yr(o, a, l), u = c[0], s = c[1], g = rt(["react-colorful", t]);
  return ae.createElement("div", We({}, d, { ref: p, className: g }), ae.createElement(Qr, { hsva: u, onChange: s }), ae.createElement(Gr, { hue: u.h, onChange: s, className: "react-colorful__last-control" }));
}, qr = { defaultColor: "000", toHsva: Or, fromHsva: function(e) {
  return Rr({ h: e.h, s: e.s, v: e.v, a: 1 });
}, equal: $r }, Vr = function(e) {
  return ae.createElement(Zr, We({}, e, { colorModel: qr }));
};
const mt = (e) => {
  const t = e.startsWith("#") ? e : `#${e}`, o = t.slice(0, 7).padEnd(7, "0"), n = t.slice(7, 9) || "ff", a = parseInt(n, 16), l = Math.round(a / 255 * 100);
  return { hex: o, opacity: l };
}, ye = (e, t) => {
  const o = Math.round(t / 100 * 255).toString(16).padStart(2, "0");
  return `${(e.startsWith("#") ? e : `#${e}`).slice(0, 7)}${o}`;
}, gt = (e) => {
  const t = e.replace(/^#/, "");
  return /^[0-9A-Fa-f]{6}$/i.test(t) ? `#${t.toLowerCase()}` : /^[0-9A-Fa-f]{8}$/i.test(t) ? `#${t.toLowerCase()}` : null;
}, vo = ({
  value: e,
  onChange: t,
  className: o
}) => {
  const { hex: n, opacity: a } = mt(
    e || "#000000ff"
  ), [l, d] = N(n), [p, c] = N(a), [u, s] = N(
    a < 100 ? e || "#000000ff" : n
  );
  $(() => {
    const { hex: b, opacity: h } = mt(
      e || "#000000ff"
    );
    d(b), c(h), s(h < 100 ? e || "#000000ff" : b);
  }, [e]);
  const g = (b) => {
    d(b), s(p < 100 ? ye(b, p) : b), t(ye(b, p));
  }, y = (b) => {
    const h = b.target.value;
    s(h);
    const w = gt(h);
    if (w)
      if (w.length === 9) {
        const B = w.slice(0, 7), T = w.slice(7, 9), S = parseInt(T, 16), z = Math.round(S / 255 * 100);
        d(B), c(z), t(w);
      } else
        d(w), t(ye(w, p));
  }, k = () => {
    const b = gt(u);
    if (b)
      if (b.length === 9)
        s(b);
      else {
        const h = ye(b, p);
        s(p < 100 ? h : b);
      }
    else {
      const h = ye(l, p);
      s(p < 100 ? h : l);
    }
  }, f = (b) => {
    const h = parseInt(b.target.value, 10);
    c(h);
    const w = ye(l, h);
    t(w), s(h < 100 ? w : l);
  };
  return /* @__PURE__ */ m("div", { className: `bc-color-picker ${o || ""}`, children: [
    /* @__PURE__ */ r("style", { children: `
        .bc-color-picker {
          width: 200px;
        }

        .bc-color-picker .react-colorful {
          width: 100%;
          height: auto;
        }

        .bc-color-picker .react-colorful__saturation {
          border-radius: 8px;
          height: 150px;
        }

        .bc-color-picker .react-colorful__hue {
          height: 14px;
          border-radius: 7px;
          margin-top: 16px;
        }

        .bc-color-picker .react-colorful__pointer {
          width: 20px;
          height: 20px;
        }

        .bc-color-picker-hex-input {
          width: 100%;
          margin-top: 16px;
          padding: 8px 10px;
          border: 1px solid ${i.border_glass};
          border-radius: 8px;
          font-size: 13px;
          color: ${i.primary};
          font-family: 'SF Mono', 'Menlo', 'Monaco', 'Courier New', monospace;
          background: ${i.bg_light};
          outline: none;
          box-sizing: border-box;
          text-align: center;
          transition: all 0.15s ease;
        }

        .bc-color-picker-hex-input:focus {
          border-color: ${i.blue};
          box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.12);
          background: ${i.white};
        }

        .bc-color-picker-opacity-container {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-top: 12px;
        }

        .bc-color-picker-opacity-slider {
          flex: 1;
          height: 14px;
          -webkit-appearance: none;
          appearance: none;
          background: linear-gradient(to right, white 0%, ${l} 100%);
          border-radius: 7px;
          outline: none;
          cursor: pointer;
        }

        .bc-color-picker-opacity-slider::-webkit-slider-thumb {
          -webkit-appearance: none;
          appearance: none;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background: ${i.white};
          border: 2px solid ${i.white};
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
          cursor: pointer;
          transition: transform 0.1s ease;
        }

        .bc-color-picker-opacity-slider::-webkit-slider-thumb:hover {
          transform: scale(1.1);
        }

        .bc-color-picker-opacity-slider::-moz-range-thumb {
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background: ${i.white};
          border: 2px solid ${i.white};
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
          cursor: pointer;
        }

        .bc-color-picker-opacity-value {
          min-width: 36px;
          font-size: 12px;
          font-weight: 500;
          color: ${i.gray_medium};
          text-align: right;
          user-select: none;
        }
      ` }),
    /* @__PURE__ */ r(Vr, { color: l, onChange: g }),
    /* @__PURE__ */ r(
      "input",
      {
        type: "text",
        value: u,
        onChange: y,
        onBlur: k,
        placeholder: "#000000 or #000000ff",
        className: "bc-color-picker-hex-input",
        maxLength: 9
      }
    ),
    /* @__PURE__ */ m("div", { className: "bc-color-picker-opacity-container", children: [
      /* @__PURE__ */ r(
        "input",
        {
          type: "range",
          min: "0",
          max: "100",
          value: p,
          onChange: f,
          className: "bc-color-picker-opacity-slider",
          style: {
            background: `linear-gradient(to right, white 0%, ${l} 100%)`
          }
        }
      ),
      /* @__PURE__ */ r("span", { className: "bc-color-picker-opacity-value", children: p })
    ] })
  ] });
}, Kr = "data:image/png;base64,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", Je = ({
  color: e,
  size: t = 32,
  borderRadius: o = 4,
  className: n,
  style: a
}) => /* @__PURE__ */ m(
  "div",
  {
    className: n,
    style: {
      position: "relative",
      width: t,
      height: t,
      borderRadius: o,
      overflow: "hidden",
      ...a
    },
    children: [
      /* @__PURE__ */ r(
        "div",
        {
          style: {
            position: "absolute",
            inset: 0,
            backgroundImage: `url(${Kr})`,
            backgroundSize: "100% 100%",
            backgroundRepeat: "repeat",
            borderRadius: "inherit"
          }
        }
      ),
      /* @__PURE__ */ r(
        "div",
        {
          style: {
            position: "absolute",
            inset: 0,
            backgroundColor: e,
            display: "block",
            borderRadius: "inherit"
          }
        }
      )
    ]
  }
), _r = (e) => typeof e == "object" && e !== null && "type" in e && "value" in e && (e.type === "theme" || e.type === "custom"), P = (e) => ({
  type: "theme",
  value: e
}), M = (e) => ({
  type: "custom",
  value: e
}), be = (e) => {
  if (!e) return "#000000ff";
  const t = e.startsWith("#") ? e : `#${e}`;
  return t.length === 9 ? t : t.length === 7 ? `${t}ff` : t.padEnd(9, "f").slice(0, 9);
}, ut = (e) => {
  const t = e.replace(/^#/, "");
  return /^[0-9A-Fa-f]{6}$/i.test(t) ? `#${t.toLowerCase()}` : /^[0-9A-Fa-f]{8}$/i.test(t) ? `#${t.toLowerCase()}` : null;
}, en = ({
  value: e,
  onChange: t,
  field: o,
  themeColors: n,
  openColorPicker: a,
  setOpenColorPicker: l
}) => {
  const p = _r(e) && e.type === "theme" ? e.value : "", c = le(() => {
    if (!e) return "#000000ff";
    if (typeof e == "string")
      return be(e);
    if (e.type === "custom")
      return be(e.value);
    if (e.type === "theme") {
      const x = n[e.value];
      return x ? be(x) : "#000000ff";
    }
    return "#000000ff";
  }, [e, n]), u = () => "#" + Math.floor(Math.random() * 16777215).toString(16).padStart(6, "0"), s = (x) => {
    if (x === "") {
      const L = u();
      t({ type: "custom", value: L });
    } else
      t({ type: "theme", value: x });
  }, g = (x) => {
    t({ type: "custom", value: x });
  }, y = a === o.key, k = c, f = te(null), b = te(null), [h, w] = ae.useState(!1), B = (x) => {
    const L = be(x);
    return L.length === 9 && L.slice(7, 9).toLowerCase() === "ff" ? L.slice(0, 7) : L;
  }, [T, S] = N(() => B(k));
  $(() => {
    S(B(c));
  }, [c]);
  const z = (x) => {
    const L = x.target.value;
    S(L);
    const Y = ut(L);
    if (Y) {
      const I = be(Y);
      g(I);
    }
  }, O = () => {
    const x = ut(T);
    if (!x)
      S(B(k));
    else {
      const L = be(x);
      S(B(L));
    }
  }, R = 300;
  return $(() => {
    if (y && b.current) {
      const x = b.current.getBoundingClientRect(), Y = window.innerHeight - x.bottom, I = x.top;
      w(Y < R && I > Y);
    }
  }, [y]), $(() => {
    if (!y) return;
    const x = (L) => {
      f.current && !f.current.contains(L.target) && l(null);
    };
    return document.addEventListener("mousedown", x, !0), () => {
      document.removeEventListener("mousedown", x, !0);
    };
  }, [y, l]), /* @__PURE__ */ m(
    "div",
    {
      style: {
        display: "flex",
        gap: "10px",
        alignItems: "center"
      },
      children: [
        /* @__PURE__ */ m(
          "select",
          {
            value: p,
            onChange: (x) => s(x.target.value),
            className: "edit-panel-select",
            style: {
              flex: 1,
              padding: "12px 14px",
              border: `1px solid ${i.border_glass}`,
              borderRadius: "10px",
              fontSize: "13px",
              color: i.primary,
              boxSizing: "border-box",
              transition: "all 0.15s ease",
              background: i.white,
              cursor: "pointer",
              maxWidth: "110px",
              outline: "none",
              appearance: "none",
              backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%237e8fa8' d='M6 8L1 3h10z'/%3E%3C/svg%3E")`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "right 10px center",
              paddingRight: "30px"
            },
            children: [
              /* @__PURE__ */ r("option", { value: "", children: "Custom" }),
              Object.keys(n).map((x) => /* @__PURE__ */ r("option", { value: x, children: x }, x))
            ]
          }
        ),
        /* @__PURE__ */ m("div", { ref: f, style: { position: "relative" }, children: [
          /* @__PURE__ */ r(
            "button",
            {
              ref: b,
              type: "button",
              onClick: () => l(y ? null : o.key),
              className: "edit-panel-color-swatch",
              style: {
                width: "42px",
                height: "42px",
                border: `2px solid ${i.border_glass}`,
                borderRadius: "10px",
                cursor: "pointer",
                padding: "3px",
                transition: "all 0.15s ease",
                backgroundColor: i.white,
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              },
              "aria-label": "Open color picker",
              children: /* @__PURE__ */ r(
                Je,
                {
                  color: k,
                  style: { width: "100%", height: "100%" },
                  borderRadius: 6
                }
              )
            }
          ),
          y && /* @__PURE__ */ r(
            "div",
            {
              className: "edit-panel-color-popover",
              style: {
                position: "absolute",
                ...h ? { bottom: "calc(100% + 8px)" } : { top: "calc(100% + 8px)" },
                left: "50%",
                transform: "translateX(-50%)",
                zIndex: 10,
                backgroundColor: i.white,
                borderRadius: "12px",
                padding: "12px",
                boxShadow: `0 8px 24px ${i.shadow_medium}, 0 0 0 1px ${i.border_glass}`
              },
              onClick: (x) => x.stopPropagation(),
              children: /* @__PURE__ */ r(
                vo,
                {
                  value: k,
                  onChange: g
                }
              )
            }
          )
        ] }),
        /* @__PURE__ */ r(
          "input",
          {
            type: "text",
            value: T,
            onChange: z,
            onBlur: O,
            className: "edit-panel-color-text",
            placeholder: "#000000 or #000000ff",
            maxLength: 9,
            style: {
              width: "100px",
              padding: "12px 10px",
              border: `1px solid ${i.border_glass}`,
              borderRadius: "10px",
              fontSize: "12px",
              color: i.primary,
              fontFamily: "'SF Mono', 'Menlo', 'Monaco', 'Courier New', monospace",
              background: i.white,
              outline: "none",
              transition: "all 0.15s ease",
              cursor: "text"
            },
            onFocus: (x) => x.target.select()
          }
        )
      ]
    }
  );
}, tn = ({
  value: e,
  onChange: t,
  field: o
}) => /* @__PURE__ */ r(
  "input",
  {
    type: "number",
    value: e || 0,
    min: o.min,
    max: o.max,
    step: o.step || 1,
    onChange: (n) => t(parseFloat(n.target.value)),
    className: "edit-panel-input",
    style: {
      width: "100%",
      padding: "12px 14px",
      border: `1px solid ${i.border_glass}`,
      borderRadius: "10px",
      fontSize: "13px",
      color: i.primary,
      boxSizing: "border-box",
      transition: "all 0.15s ease",
      background: i.white,
      outline: "none"
    }
  }
), on = ({ value: e, onChange: t }) => {
  const o = !!e;
  return /* @__PURE__ */ r(
    "button",
    {
      type: "button",
      role: "switch",
      "aria-checked": o,
      onClick: () => t(!o),
      className: "edit-panel-toggle",
      style: {
        width: "48px",
        height: "28px",
        borderRadius: "14px",
        border: "none",
        padding: "2px",
        cursor: "pointer",
        transition: "all 0.2s ease",
        background: o ? i.blue : i.gray_light,
        display: "flex",
        alignItems: "center",
        justifyContent: o ? "flex-end" : "flex-start"
      },
      children: /* @__PURE__ */ r(
        "span",
        {
          style: {
            width: "24px",
            height: "24px",
            borderRadius: "12px",
            background: i.white,
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.15)",
            transition: "all 0.2s ease"
          }
        }
      )
    }
  );
}, rn = ({
  value: e,
  onChange: t,
  themeFonts: o
}) => /* @__PURE__ */ m(
  "select",
  {
    value: e || "inherit",
    onChange: (n) => t(n.target.value),
    className: "edit-panel-select",
    style: {
      width: "100%",
      padding: "12px 14px",
      border: `1px solid ${i.border_glass}`,
      borderRadius: "10px",
      fontSize: "13px",
      color: i.primary,
      boxSizing: "border-box",
      transition: "all 0.15s ease",
      background: i.white,
      cursor: "pointer",
      outline: "none",
      appearance: "none",
      backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%237e8fa8' d='M6 8L1 3h10z'/%3E%3C/svg%3E")`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "right 12px center",
      paddingRight: "36px"
    },
    children: [
      /* @__PURE__ */ r("option", { value: "inherit", children: "Inherit (System Font)" }),
      Object.entries(o).map(([n, a]) => /* @__PURE__ */ r("option", { value: n, children: a.name }, n))
    ]
  }
), nn = ({
  value: e,
  onChange: t,
  themeIcons: o
}) => /* @__PURE__ */ m(
  "select",
  {
    value: e || "default",
    onChange: (n) => t(n.target.value),
    className: "edit-panel-select",
    style: {
      width: "100%",
      padding: "12px 14px",
      border: `1px solid ${i.border_glass}`,
      borderRadius: "10px",
      fontSize: "13px",
      color: i.primary,
      boxSizing: "border-box",
      transition: "all 0.15s ease",
      background: i.white,
      cursor: "pointer",
      outline: "none",
      appearance: "none",
      backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%237e8fa8' d='M6 8L1 3h10z'/%3E%3C/svg%3E")`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "right 12px center",
      paddingRight: "36px"
    },
    children: [
      /* @__PURE__ */ r("option", { value: "default", children: "Default" }),
      Object.entries(o).map(([n, a]) => /* @__PURE__ */ r("option", { value: n, children: a.name }, n))
    ]
  }
), wo = ({
  displayName: e,
  fields: t,
  values: o,
  initialValues: n,
  onChange: a,
  onClose: l,
  onReset: d,
  screenPosition: p,
  onSave: c,
  isSaving: u = !1,
  themeColors: s = {},
  themeFonts: g = {},
  themeIcons: y = {}
}) => {
  const { dragOffset: k, isDragging: f, handleMouseDown: b } = Ar(), h = te(null), [w, B] = N(null), [T, S] = N(!1), z = le(() => n ? JSON.stringify(o) !== JSON.stringify(n) : !1, [o, n]), O = () => {
    z ? S(!0) : l();
  }, R = () => {
    S(!1), l();
  }, x = async () => {
    c && c(), S(!1);
  };
  $(() => {
    if (!w) return;
    const C = je(), E = (F) => {
      const X = F.target;
      !X.closest(".edit-panel-color-popover") && !X.closest(".edit-panel-color-swatch") && B(null);
    };
    return C.addEventListener("mousedown", E, !0), () => {
      C.removeEventListener("mousedown", E, !0);
    };
  }, [w]), $(() => {
    if (!bo()) return;
    const C = je(), E = "edit-panel-styles";
    if (!C.getElementById(E)) {
      const F = C.createElement("style");
      F.id = E, F.textContent = `
        @keyframes edit-panel-slideIn {
          from {
            opacity: 0;
            transform: translateY(-8px) scale(0.98);
          }
          to {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }
      `, C.head.appendChild(F);
    }
    return () => {
      const F = C.getElementById(E);
      F && F.remove();
    };
  }, []);
  const L = le(() => {
    const C = [], E = {};
    return t.forEach((F) => {
      if (F.group)
        E[F.group] || (E[F.group] = []), E[F.group].push(F);
      else {
        const X = F.key.match(/^elementStyles\.([^.]+)\./);
        if (X) {
          const H = X[1];
          E[H] || (E[H] = []), E[H].push(F);
        } else
          C.push(F);
      }
    }), { baseFields: C, groups: E };
  }, [t]), Y = (C) => ({
    h1: "H1",
    h2: "H2",
    h3: "H3",
    h4: "H4",
    h5: "H5",
    h6: "H6",
    p: "Paragraph",
    strong: "Bold",
    em: "Italic",
    code: "Code",
    blockquote: "Blockquote",
    ul: "Unordered List",
    ol: "Ordered List",
    li: "List Item",
    table: "Table",
    thead: "Table Header",
    tbody: "Table Body",
    tr: "Table Row",
    th: "Header Cell",
    td: "Table Cell",
    // Product Card Carousel groups
    carousel: "Carousel",
    "Card Container": "Card Container",
    title: "Title",
    price: "Price",
    "Retailer Icons": "Retailer Icons",
    image: "Image"
  })[C] || C, I = (C) => {
    const E = o[C.key];
    switch (C.type) {
      case "text":
        return /* @__PURE__ */ r(
          Nr,
          {
            value: E,
            onChange: (F) => a(C.key, F),
            field: C
          }
        );
      case "options":
        return /* @__PURE__ */ r(
          Hr,
          {
            value: E,
            onChange: (F) => a(C.key, F),
            field: C
          }
        );
      case "color":
        return /* @__PURE__ */ r(
          en,
          {
            value: E,
            onChange: (F) => a(C.key, F),
            field: C,
            themeColors: s,
            openColorPicker: w,
            setOpenColorPicker: B
          }
        );
      case "number":
        return /* @__PURE__ */ r(
          tn,
          {
            value: E,
            onChange: (F) => a(C.key, F),
            field: C
          }
        );
      case "toggle":
        return /* @__PURE__ */ r(
          on,
          {
            value: E,
            onChange: (F) => a(C.key, F),
            field: C
          }
        );
      case "font":
        return /* @__PURE__ */ r(
          rn,
          {
            value: E,
            onChange: (F) => a(C.key, F),
            field: C,
            themeFonts: g
          }
        );
      case "icon":
        return /* @__PURE__ */ r(
          nn,
          {
            value: E,
            onChange: (F) => a(C.key, F),
            field: C,
            themeIcons: y
          }
        );
      default:
        return null;
    }
  }, D = /* @__PURE__ */ m(G, { children: [
    /* @__PURE__ */ r("style", { children: `
        @keyframes edit-panel-slideIn {
          from {
            opacity: 0;
            transform: translateY(-8px) scale(0.98);
          }
          to {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }

        .edit-panel-close {
          transition: all 0.15s ease;
        }

        .edit-panel-close:hover {
          background-color: ${i.overlay_light};
          color: ${i.primary};
          transform: scale(1.1);
        }

        .edit-panel-input:focus,
        .edit-panel-select:focus {
          border-color: ${i.blue};
          box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.12);
        }

        .edit-panel-input:hover:not(:focus),
        .edit-panel-select:hover:not(:focus) {
          border-color: ${i.gray_border};
        }

        .edit-panel-color-text:focus {
          border-color: ${i.blue};
          box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.12);
          background: ${i.white};
        }

        .edit-panel-color-swatch:hover {
          border-color: ${i.gray_border};
          transform: scale(1.05);
        }

        /* ColorPicker popover styles are now in the ColorPicker component */

        .drag-handle {
          cursor: ${f ? "grabbing" : "grab"};
          transition: background-color 0.15s ease;
        }

        .drag-handle:hover {
          background-color: ${i.overlay_light};
        }

        .edit-panel-save-button {
          background: linear-gradient(135deg, ${i.blue} 0%, ${i.blue_dark} 100%);
          color: ${i.white};
          border: none;
          padding: 10px 18px;
          border-radius: 10px;
          font-size: 12px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.15s ease;
          box-shadow: 0 2px 8px rgba(85, 114, 183, 0.25);
          letter-spacing: 0.3px;
        }

        .edit-panel-save-button:hover:not(:disabled) {
          transform: translateY(-1px);
          box-shadow: 0 4px 16px rgba(85, 114, 183, 0.35);
        }

        .edit-panel-save-button:active:not(:disabled) {
          transform: translateY(0);
        }

        .edit-panel-save-button:disabled {
          opacity: 0.6;
          cursor: not-allowed;
          transform: none;
        }

        /* Custom scrollbar */
        .edit-panel-content::-webkit-scrollbar {
          width: 6px;
        }

        .edit-panel-content::-webkit-scrollbar-track {
          background: transparent;
        }

        .edit-panel-content::-webkit-scrollbar-thumb {
          background: ${i.gray_border};
          border-radius: 3px;
        }

        .edit-panel-content::-webkit-scrollbar-thumb:hover {
          background: ${i.gray_medium};
        }
      ` }),
    /* @__PURE__ */ m(
      "div",
      {
        ref: h,
        style: {
          position: "fixed",
          top: p.y + k.y,
          left: p.x + k.x,
          background: i.glass_bg_strong,
          backdropFilter: "blur(24px)",
          WebkitBackdropFilter: "blur(24px)",
          border: `1px solid ${i.border_subtle}`,
          borderRadius: "20px",
          boxShadow: `
            0 8px 40px ${i.shadow_medium},
            0 20px 60px ${i.shadow_soft},
            0 0 0 1px ${i.border_glass}
          `,
          zIndex: 999999,
          width: "620px",
          maxWidth: "620px",
          maxHeight: "450px",
          display: "flex",
          flexDirection: "column",
          fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
          animation: "edit-panel-slideIn 0.2s ease-out"
        },
        onClick: (C) => C.stopPropagation(),
        onMouseDown: (C) => C.stopPropagation(),
        children: [
          /* @__PURE__ */ m(
            "div",
            {
              className: "drag-handle",
              onMouseDown: b,
              style: {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "16px 20px",
                borderBottom: `1px solid ${i.border_glass}`,
                borderRadius: "20px 20px 0 0",
                userSelect: "none"
              },
              children: [
                /* @__PURE__ */ m(
                  "div",
                  {
                    style: {
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                      flex: 1
                    },
                    children: [
                      /* @__PURE__ */ r(
                        "div",
                        {
                          style: {
                            display: "grid",
                            gridTemplateColumns: "repeat(2, 1fr)",
                            gap: "3px",
                            opacity: 0.3
                          },
                          children: [...Array(6)].map((C, E) => /* @__PURE__ */ r(
                            "div",
                            {
                              style: {
                                width: "4px",
                                height: "4px",
                                background: i.gray_medium,
                                borderRadius: "1px"
                              }
                            },
                            E
                          ))
                        }
                      ),
                      /* @__PURE__ */ r(
                        "h3",
                        {
                          style: {
                            fontSize: "13px",
                            fontWeight: 600,
                            color: i.primary,
                            margin: 0,
                            letterSpacing: "0.2px"
                          },
                          children: e || "Edit Properties"
                        }
                      )
                    ]
                  }
                ),
                /* @__PURE__ */ m("div", { style: { display: "flex", gap: "8px", alignItems: "center" }, children: [
                  z && d && /* @__PURE__ */ r(
                    U,
                    {
                      variant: "ghost",
                      size: "sm",
                      onClick: d,
                      disabled: u,
                      "aria-label": "Reset changes",
                      leftIcon: /* @__PURE__ */ r(kr, { size: 14 }),
                      children: "Reset"
                    }
                  ),
                  z && c && /* @__PURE__ */ r(
                    U,
                    {
                      variant: "primary",
                      size: "sm",
                      onClick: c,
                      disabled: u,
                      isLoading: u,
                      "aria-label": "Save changes",
                      type: "submit",
                      children: "Save"
                    }
                  ),
                  /* @__PURE__ */ r(
                    U,
                    {
                      variant: "icon",
                      size: "md",
                      onClick: O,
                      "aria-label": "Close",
                      children: /* @__PURE__ */ r(ue, { size: 18 })
                    }
                  )
                ] })
              ]
            }
          ),
          /* @__PURE__ */ r(
            "div",
            {
              className: "edit-panel-content",
              style: {
                padding: "20px 24px 24px",
                overflowY: "auto",
                overflowX: "hidden",
                flex: 1
              },
              children: /* @__PURE__ */ m(
                "div",
                {
                  style: {
                    display: "flex",
                    flexDirection: "column",
                    gap: "24px"
                  },
                  children: [
                    L.baseFields.length > 0 && /* @__PURE__ */ r(
                      "div",
                      {
                        style: {
                          display: "grid",
                          gridTemplateColumns: "1fr 1fr",
                          gap: "20px"
                        },
                        children: L.baseFields.map((C) => /* @__PURE__ */ m(
                          "div",
                          {
                            style: {
                              minWidth: 0
                            },
                            children: [
                              /* @__PURE__ */ r(
                                "label",
                                {
                                  style: {
                                    display: "block",
                                    fontSize: "11px",
                                    fontWeight: 600,
                                    color: i.gray_medium,
                                    marginBottom: "8px",
                                    textTransform: "uppercase",
                                    letterSpacing: "0.5px"
                                  },
                                  children: C.label
                                }
                              ),
                              I(C)
                            ]
                          },
                          C.key
                        ))
                      }
                    ),
                    Object.entries(L.groups).map(
                      ([C, E]) => /* @__PURE__ */ m("div", { children: [
                        /* @__PURE__ */ r(
                          "h4",
                          {
                            style: {
                              fontSize: "12px",
                              fontWeight: 700,
                              color: i.primary,
                              margin: "0 0 16px 0",
                              paddingBottom: "8px",
                              borderBottom: `2px solid ${i.border_glass}`,
                              textTransform: "uppercase",
                              letterSpacing: "0.5px"
                            },
                            children: Y(C)
                          }
                        ),
                        /* @__PURE__ */ r(
                          "div",
                          {
                            style: {
                              display: "grid",
                              gridTemplateColumns: "1fr 1fr",
                              gap: "20px"
                            },
                            children: E.map((F) => /* @__PURE__ */ m(
                              "div",
                              {
                                style: {
                                  minWidth: 0
                                },
                                children: [
                                  /* @__PURE__ */ r(
                                    "label",
                                    {
                                      style: {
                                        display: "block",
                                        fontSize: "11px",
                                        fontWeight: 600,
                                        color: i.gray_medium,
                                        marginBottom: "8px",
                                        textTransform: "uppercase",
                                        letterSpacing: "0.5px"
                                      },
                                      children: F.label
                                    }
                                  ),
                                  I(F)
                                ]
                              },
                              F.key
                            ))
                          }
                        )
                      ] }, C)
                    )
                  ]
                }
              )
            }
          )
        ]
      }
    )
  ] });
  return /* @__PURE__ */ m(G, { children: [
    ge.createPortal(D, Re()),
    T && /* @__PURE__ */ r(
      ke,
      {
        title: "Unsaved Changes",
        message: "You have unsaved changes. Would you like to save them before closing?",
        confirmLabel: "Save",
        cancelLabel: "Discard",
        onConfirm: x,
        onCancel: R,
        isLoading: u
      }
    )
  ] });
}, se = {
  THEME_ID: "bc_themeId",
  EDIT_MODE: "bc_editMode",
  EDIT_THEME_TOKEN: "bc_editThemeToken"
}, an = (e, t, o) => {
  try {
    e ? localStorage.setItem(se.THEME_ID, e) : localStorage.removeItem(se.THEME_ID), localStorage.setItem(se.EDIT_MODE, String(t)), o ? localStorage.setItem(se.EDIT_THEME_TOKEN, o) : localStorage.removeItem(se.EDIT_THEME_TOKEN);
  } catch (n) {
    console.error("Failed to save theme params to localStorage:", n);
  }
}, ln = () => {
  try {
    return {
      themeId: localStorage.getItem(se.THEME_ID),
      editMode: localStorage.getItem(se.EDIT_MODE) === "true",
      editThemeToken: localStorage.getItem(se.EDIT_THEME_TOKEN)
    };
  } catch (e) {
    return console.error("Failed to read theme params from localStorage:", e), {
      themeId: null,
      editMode: !1,
      editThemeToken: null
    };
  }
}, sn = () => {
  try {
    localStorage.removeItem(se.THEME_ID), localStorage.removeItem(se.EDIT_MODE), localStorage.removeItem(se.EDIT_THEME_TOKEN);
  } catch (e) {
    console.error("Failed to clear theme params from localStorage:", e);
  }
}, cn = () => {
  try {
    const e = new URLSearchParams(window.location.search), t = e.get("themeId"), o = e.get("editMode") === "true", n = e.get("editThemeToken");
    t && an(t, o, n);
  } catch (e) {
    console.error("Failed to sync URL to storage:", e);
  }
}, dn = () => {
  try {
    const e = new URL(window.location.href);
    e.searchParams.delete("themeId"), e.searchParams.delete("editMode"), e.searchParams.delete("editThemeToken"), window.history.replaceState({}, "", e.toString());
  } catch (e) {
    console.error("Failed to clear URL params:", e);
  }
}, xi = (e, t, o) => {
  try {
    const n = new URL(window.location.href);
    e ? (n.searchParams.set("themeId", e), n.searchParams.set("editMode", String(t)), o ? n.searchParams.set("editThemeToken", o) : n.searchParams.delete("editThemeToken")) : (n.searchParams.delete("themeId"), n.searchParams.delete("editMode"), n.searchParams.delete("editThemeToken")), window.history.replaceState({}, "", n.toString());
  } catch (n) {
    console.error("Failed to update URL params:", n);
  }
}, ht = () => {
  const e = new URLSearchParams(window.location.search), t = e.get("themeId"), o = e.get("editMode"), n = e.get("editThemeToken"), a = e.get("origin"), l = ln();
  return {
    themeId: t || l.themeId,
    editMode: o === "true" || o === null && l.editMode,
    editThemeToken: n || l.editThemeToken,
    origin: a
  };
}, we = () => {
  const [e, t] = N(ht);
  return $(() => {
    const o = setTimeout(() => {
      const n = ht();
      t((a) => a.themeId !== n.themeId || a.editMode !== n.editMode || a.editThemeToken !== n.editThemeToken || a.origin !== n.origin ? n : a);
    }, 0);
    return () => clearTimeout(o);
  }, []), e;
}, So = () => we().editMode, Xe = "bc-widget-panel-opened", Bo = (e) => {
  const t = new CustomEvent(Xe, {
    detail: { widgetId: e },
    bubbles: !0
  });
  document.dispatchEvent(t);
}, zo = (e) => {
  const t = (o) => {
    e(o.detail.widgetId);
  };
  return document.addEventListener(Xe, t), () => {
    document.removeEventListener(Xe, t);
  };
}, pn = (e, t = 32, o = 4) => {
  const n = window.innerWidth, a = window.innerHeight, l = n < 768, d = e.left, p = n - e.right, c = e.top, u = a - e.bottom, s = t + o, g = d >= s, y = p >= s, k = c >= s, f = u >= s;
  let b = "top-left", h = {};
  return l ? y && k ? (b = "top-right", h = {
    top: e.top - o,
    left: e.right - t + o
  }) : y && f ? (b = "bottom-right", h = {
    top: e.bottom - t + o,
    left: e.right - t + o
  }) : g && k ? (b = "top-left", h = {
    top: e.top - o,
    left: e.left - o
  }) : g && f ? (b = "bottom-left", h = {
    top: e.bottom - t + o,
    left: e.left - o
  }) : (b = "top-right", h = {
    top: e.top + o,
    left: e.right - t - o
  }) : g && k ? (b = "top-left", h = {
    top: e.top - o,
    left: e.left - o
  }) : y && k ? (b = "top-right", h = {
    top: e.top - o,
    left: e.right - t + o
  }) : g && f ? (b = "bottom-left", h = {
    top: e.bottom - t + o,
    left: e.left - o
  }) : y && f ? (b = "bottom-right", h = {
    top: e.bottom - t + o,
    left: e.right - t + o
  }) : (b = "top-left", h = {
    top: e.top + o,
    left: e.left + o
  }), { position: b, style: h };
}, K = ({
  children: e,
  widgetId: t,
  displayName: o,
  editFields: n,
  editValues: a,
  onEditChange: l,
  onSave: d,
  isSaving: p = !1,
  themeColors: c = {},
  themeFonts: u = {},
  themeIcons: s = {}
}) => {
  const [g, y] = N(!1), [k, f] = N({ x: 0, y: 0 }), [b, h] = N(null), [w, B] = N(!1), [T, S] = N(
    null
  ), [z, O] = N(!1), [R, x] = N(!1), L = te(null), Y = te(null), I = So(), D = (z || R) && !g, C = de(() => {
    if (Y.current) {
      const W = Y.current.getBoundingClientRect(), { style: J } = pn(W);
      S(J);
    }
  }, []);
  $(() => {
    if (!I || !D) {
      S(null);
      return;
    }
    C();
    const W = () => C();
    return window.addEventListener("scroll", W, !0), window.addEventListener("resize", W), () => {
      window.removeEventListener("scroll", W, !0), window.removeEventListener("resize", W);
    };
  }, [I, D, C]);
  const E = de(() => b ? JSON.stringify(a) !== JSON.stringify(b) : !1, [a, b]);
  if ($(() => t ? zo((J) => {
    J !== t && g && (E() ? B(!0) : y(!1));
  }) : void 0, [t, g, E]), !I)
    return /* @__PURE__ */ r(G, { children: e });
  const F = () => {
    if (L.current) {
      const W = L.current.getBoundingClientRect(), J = window.innerWidth, re = window.innerHeight, ne = 620, _ = 450, Z = 10, oe = re - W.bottom, Be = W.top, Qo = J - W.left, $o = W.right;
      let me;
      oe >= _ + Z ? me = W.bottom + Z : Be >= _ + Z ? me = W.top - _ - Z : oe >= Be ? me = Math.max(Z, re - _ - Z) : me = Math.max(Z, W.top - _ - Z);
      let he;
      Qo >= ne ? he = W.left : $o >= ne ? he = W.right - ne : he = Math.max(
        Z,
        Math.min(J - ne - Z, W.left)
      ), he = Math.max(Z, Math.min(he, J - ne - Z)), me = Math.max(Z, Math.min(me, re - _ - Z)), f({ x: he, y: me });
    }
    h({ ...a }), y(!0), t && Bo(t);
  }, X = () => {
    b && Object.keys(b).forEach((W) => {
      l(W, b[W]);
    });
  }, H = () => {
    d && d(), h({ ...a });
  }, j = () => {
    B(!1), y(!1);
  }, A = () => {
    H(), B(!1), y(!1);
  }, Q = () => {
    if (!T) return null;
    const W = /* @__PURE__ */ r(
      "button",
      {
        ref: L,
        style: {
          position: "fixed",
          top: T.top,
          left: T.left,
          width: 32,
          height: 32,
          background: R ? i.blue_light : i.white,
          border: `1px solid ${R ? i.blue : i.gray_border}`,
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
          transition: "background 0.2s, border-color 0.2s, transform 0.2s",
          transform: R ? "scale(1.05)" : "scale(1)",
          zIndex: 999998,
          padding: 0
        },
        onMouseDown: (J) => {
          J.stopPropagation();
        },
        onClick: (J) => {
          J.stopPropagation(), J.preventDefault(), F();
        },
        onMouseEnter: () => x(!0),
        onMouseLeave: () => x(!1),
        "aria-label": "Edit widget",
        children: /* @__PURE__ */ r(uo, { size: 16, color: i.gray_dark })
      }
    );
    return ge.createPortal(W, document.body);
  };
  return /* @__PURE__ */ m(G, { children: [
    /* @__PURE__ */ r("style", { children: `
        .widget-wrapper {
          position: relative;
          display: inline-block;
          width: 100%;
        }

        .widget-wrapper.widget-hovered {
          outline: 1px dashed ${i.blue};
        }

        .widget-wrapper.widget-editing {
          outline: 2px dashed ${i.blue};
        }
      ` }),
    /* @__PURE__ */ m(
      "div",
      {
        ref: Y,
        className: `widget-wrapper${g ? " widget-editing" : D ? " widget-hovered" : ""}`,
        onMouseEnter: () => O(!0),
        onMouseLeave: () => O(!1),
        children: [
          e,
          g && /* @__PURE__ */ r(
            wo,
            {
              widgetId: t,
              displayName: o,
              fields: n,
              values: a,
              initialValues: b || void 0,
              onChange: l,
              onClose: () => y(!1),
              onReset: X,
              screenPosition: k,
              onSave: H,
              isSaving: p,
              themeColors: c,
              themeFonts: u,
              themeIcons: s
            }
          ),
          w && /* @__PURE__ */ r(
            ke,
            {
              title: "Unsaved Changes",
              message: "You have unsaved changes. Would you like to save them before closing?",
              confirmLabel: "Save",
              cancelLabel: "Discard",
              onConfirm: A,
              onCancel: j,
              isLoading: p
            }
          )
        ]
      }
    ),
    D && Q()
  ] });
};
function mn() {
  const e = Array.from(
    document.getElementsByTagName("script")
  ).filter((a) => a.hasAttribute("data-api-domain"));
  if (e.length > 0)
    return e[e.length - 1];
  if (document.currentScript)
    return document.currentScript;
  const t = Array.from(document.getElementsByTagName("script")), o = t.find((a) => {
    const l = a.src;
    return l && l.includes("bc-widgets");
  });
  if (o)
    return o;
  const n = t.find((a) => {
    const l = a.src;
    return l && (l.includes("bc-checkout-shop-app") || l.includes("brandclub-checkout-shop-app"));
  });
  return n || (t.length > 0 ? t[t.length - 1] : null);
}
const Fo = (() => {
  const e = mn();
  if (e != null && e.hasAttribute("data-api-domain")) {
    const o = e.getAttribute("data-api-domain");
    if (o)
      return o.startsWith("http://") || o.startsWith("https://") ? o : `https://${o}`;
  }
  const t = e == null ? void 0 : e.src;
  if (t)
    try {
      return `https://${new URL(t).hostname}`;
    } catch {
    }
  return typeof window < "u" ? (console.warn(
    "[bc-widgets] Could not determine script domain, using window.location.origin as fallback. Consider adding data-api-domain attribute to script tag."
  ), window.location.origin) : "";
})(), ce = `${Fo}/api-rewards`;
Fo.replace(/^https?:\/\//, "");
const To = {
  // Core colors
  primary: "#181d56",
  secondary: "#ffffff",
  tertiary: "#7e8fa8",
  accent: "#ffffff",
  background: "#ffffff",
  transparent: "#00000000",
  // Text colors
  textPrimary: "#181d56",
  textSecondary: "#181d56",
  textTertiary: "#7e8fa8",
  // Semantic colors
  link: "#5572b7",
  success: "#71c285",
  error: "#ff534a",
  warning: "#ffbd32",
  info: "#5572b7"
}, gn = Object.keys(To), Me = (e) => {
  if (!e) return "#000000ff";
  const t = e.startsWith("#") ? e : `#${e}`;
  return t.length === 9 ? t : t.length === 7 ? `${t}ff` : t.padEnd(9, "f").slice(0, 9);
}, yt = (e) => {
  const t = Me(e);
  return t.length === 9 && t.slice(7, 9).toLowerCase() === "ff" ? t.slice(0, 7) : t;
}, bt = (e) => {
  const t = Me(e || "#000000");
  return t.length === 9 && t.slice(7, 9).toLowerCase() === "ff" ? t.slice(0, 7) : t;
}, ft = ({
  themeColors: e,
  isExpanded: t,
  onToggle: o,
  isLoading: n,
  isAddingColor: a,
  setIsAddingColor: l,
  newColorKey: d,
  setNewColorKey: p,
  newColorValue: c,
  setNewColorValue: u,
  onAddColor: s,
  onUpdateColor: g,
  onRenameColor: y,
  onDeleteColor: k
}) => {
  const [f, b] = N(null), h = te({}), [w, B] = N({
    top: 0,
    left: 0,
    openAbove: !1
  }), [T, S] = N(null), [z, O] = N(null), [R, x] = N(null), L = te({}), [Y, I] = N({
    top: 0,
    left: 0
  }), D = 300;
  $(() => {
    if (f && h.current[f]) {
      const A = h.current[f].getBoundingClientRect(), W = window.innerHeight - A.bottom, J = A.top, re = W < D && J > W;
      B({
        top: re ? A.top - 8 : A.bottom + 8,
        left: A.left + A.width / 2,
        openAbove: re
      });
    }
  }, [f]), $(() => {
    if (!f) return;
    const A = (Q) => {
      const W = Q.target;
      !W.closest(".bc-theme-color-popover") && !W.closest(".bc-theme-color-swatch") && b(null);
    };
    return document.addEventListener("mousedown", A), () => {
      document.removeEventListener("mousedown", A);
    };
  }, [f]), $(() => {
    if (R && L.current[R]) {
      const A = L.current[R].getBoundingClientRect();
      I({
        top: A.bottom + 4,
        left: A.right
      });
    }
  }, [R]), $(() => {
    if (!R) return;
    const A = (Q) => {
      const W = Q.target;
      !W.closest(".bc-theme-color-dropdown") && !W.closest(".bc-theme-color-menu-btn") && x(null);
    };
    return document.addEventListener("mousedown", A), () => {
      document.removeEventListener("mousedown", A);
    };
  }, [R]);
  const C = (A, Q) => {
    S(A), O({ name: A, value: Me(Q) }), x(null), b(null);
  }, E = () => {
    S(null), O(null), b(null);
  }, F = async (A) => {
    if (!z) return;
    const { name: Q, value: W } = z, J = yt(W);
    if (!/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/.test(J))
      return;
    Q.trim() && Q.trim() !== A && y && await y(A, Q.trim());
    const ne = yt(e[A]);
    if (J !== ne) {
      const _ = Q.trim() || A;
      await g(_, J);
    }
    S(null), O(null), b(null);
  }, X = (A) => {
    z && O({ ...z, value: A });
  }, H = (A) => {
    z && O({ ...z, name: A });
  }, j = (A, Q, W, J) => {
    const re = f === A, ne = Me(Q), _ = J && !n;
    return /* @__PURE__ */ m(G, { children: [
      _ ? /* @__PURE__ */ r(
        "button",
        {
          ref: (Z) => {
            h.current[A] = Z;
          },
          type: "button",
          onClick: () => b(re ? null : A),
          className: "bc-theme-color-swatch",
          style: {
            width: "32px",
            height: "32px",
            border: `2px solid ${i.border_glass}`,
            borderRadius: "6px",
            cursor: "pointer",
            padding: "2px",
            transition: "all 0.15s ease",
            backgroundColor: i.white,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0
          },
          "aria-label": "Open color picker",
          children: /* @__PURE__ */ r(
            Je,
            {
              color: ne,
              style: { width: "100%", height: "100%" },
              borderRadius: 4
            }
          )
        }
      ) : /* @__PURE__ */ r(
        "div",
        {
          style: {
            width: "32px",
            height: "32px",
            border: `2px solid ${i.border_glass}`,
            borderRadius: "6px",
            padding: "2px",
            backgroundColor: i.white,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0
          },
          children: /* @__PURE__ */ r(
            Je,
            {
              color: ne,
              style: { width: "100%", height: "100%" },
              borderRadius: 4
            }
          )
        }
      ),
      re && _ && ge.createPortal(
        /* @__PURE__ */ r(
          "div",
          {
            className: "bc-theme-color-popover",
            style: {
              position: "fixed",
              top: w.top,
              left: w.left,
              transform: w.openAbove ? "translate(-50%, -100%)" : "translateX(-50%)",
              zIndex: 1000002,
              backgroundColor: i.white,
              borderRadius: "12px",
              padding: "12px",
              boxShadow: `0 8px 24px ${i.shadow_medium}, 0 0 0 1px ${i.border_glass}`
            },
            onClick: (Z) => Z.stopPropagation(),
            children: /* @__PURE__ */ r(vo, { value: ne, onChange: W })
          }
        ),
        document.body
      )
    ] });
  };
  return /* @__PURE__ */ m("div", { className: "bc-theme-editor-section", children: [
    /* @__PURE__ */ r("style", { children: `
        .bc-theme-color-swatch:hover:not(:disabled) {
          border-color: ${i.gray_border};
          transform: scale(1.05);
        }
        .bc-theme-color-menu-btn:hover:not(:disabled) {
          background: ${i.gray_light} !important;
        }
        .bc-theme-editor-row-container {
          display: flex;
          flex-direction: column;
        }
      ` }),
    /* @__PURE__ */ m("div", { className: "bc-theme-editor-section-header", onClick: o, children: [
      /* @__PURE__ */ m("h3", { className: "bc-theme-editor-section-title", children: [
        "Colors",
        /* @__PURE__ */ r("span", { className: "bc-theme-editor-section-count", children: Object.keys(e).length })
      ] }),
      /* @__PURE__ */ r(
        tt,
        {
          size: 16,
          className: `bc-theme-editor-section-chevron ${t ? "expanded" : ""}`
        }
      )
    ] }),
    t && /* @__PURE__ */ r("div", { className: "bc-theme-editor-section-content", children: n && Object.keys(e).length === 0 ? /* @__PURE__ */ r("div", { className: "bc-theme-editor-loading", children: "Loading colors..." }) : /* @__PURE__ */ m("div", { className: "bc-theme-editor-list", children: [
      Object.entries(e).map(([A, Q]) => {
        const W = T === A, J = gn.includes(A), re = R === A, ne = W && z ? z.name : A, _ = bt(W && z ? z.value : Q), Z = W && z ? z.value : Q;
        return /* @__PURE__ */ m("div", { className: "bc-theme-editor-row-container", children: [
          /* @__PURE__ */ m("div", { className: "bc-theme-editor-row", children: [
            /* @__PURE__ */ r(
              "input",
              {
                type: "text",
                className: "bc-theme-editor-input",
                value: ne,
                onChange: (oe) => W && H(oe.target.value),
                readOnly: !W,
                disabled: n,
                style: { cursor: W ? "text" : "default" }
              }
            ),
            j(
              A,
              Z,
              X,
              W
              // only editable when in edit mode
            ),
            W ? /* @__PURE__ */ r(
              "input",
              {
                type: "text",
                className: "bc-theme-editor-input",
                value: _,
                onChange: (oe) => {
                  const Be = oe.target.value;
                  z && O({ ...z, value: Be });
                },
                disabled: n,
                placeholder: "#000000 or #000000ff",
                maxLength: 9,
                style: {
                  width: "85px",
                  textAlign: "right",
                  fontFamily: "'SF Mono', 'Menlo', 'Monaco', 'Courier New', monospace"
                }
              }
            ) : /* @__PURE__ */ r(
              "span",
              {
                className: "bc-theme-editor-color-value",
                style: { cursor: "default" },
                children: _
              }
            ),
            !W && /* @__PURE__ */ r(
              "button",
              {
                ref: (oe) => {
                  L.current[A] = oe;
                },
                className: "bc-theme-color-menu-btn",
                onClick: () => x(re ? null : A),
                disabled: n,
                "aria-label": "Color options",
                style: {
                  background: "transparent",
                  border: "none",
                  cursor: "pointer",
                  padding: "4px",
                  borderRadius: "4px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: i.gray_medium,
                  transition: "all 0.15s ease"
                },
                children: /* @__PURE__ */ r(ar, { size: 16 })
              }
            ),
            re && ge.createPortal(
              /* @__PURE__ */ m(
                "div",
                {
                  className: "bc-theme-color-dropdown",
                  style: {
                    position: "fixed",
                    top: Y.top,
                    left: Y.left,
                    transform: "translateX(-100%)",
                    zIndex: 1000003,
                    backgroundColor: i.white,
                    borderRadius: "8px",
                    padding: "4px",
                    boxShadow: `0 4px 12px ${i.shadow_medium}, 0 0 0 1px ${i.border_glass}`,
                    minWidth: "100px"
                  },
                  onClick: (oe) => oe.stopPropagation(),
                  children: [
                    /* @__PURE__ */ r(
                      "button",
                      {
                        className: "bc-theme-dropdown-item",
                        onClick: () => C(A, Q),
                        style: {
                          display: "block",
                          width: "100%",
                          padding: "8px 12px",
                          border: "none",
                          background: "transparent",
                          textAlign: "left",
                          cursor: "pointer",
                          borderRadius: "4px",
                          fontSize: "13px",
                          color: i.primary,
                          transition: "background 0.15s ease"
                        },
                        onMouseEnter: (oe) => oe.currentTarget.style.background = i.gray_light,
                        onMouseLeave: (oe) => oe.currentTarget.style.background = "transparent",
                        children: "Edit"
                      }
                    ),
                    /* @__PURE__ */ r(
                      "button",
                      {
                        className: "bc-theme-dropdown-item",
                        onClick: () => {
                          x(null), k(A);
                        },
                        disabled: J,
                        style: {
                          display: "block",
                          width: "100%",
                          padding: "8px 12px",
                          border: "none",
                          background: "transparent",
                          textAlign: "left",
                          cursor: J ? "not-allowed" : "pointer",
                          borderRadius: "4px",
                          fontSize: "13px",
                          color: J ? i.gray_medium : i.red,
                          opacity: J ? 0.5 : 1,
                          transition: "background 0.15s ease"
                        },
                        onMouseEnter: (oe) => {
                          J || (oe.currentTarget.style.background = i.gray_light);
                        },
                        onMouseLeave: (oe) => oe.currentTarget.style.background = "transparent",
                        children: "Delete"
                      }
                    )
                  ]
                }
              ),
              document.body
            )
          ] }),
          W && /* @__PURE__ */ m(
            "div",
            {
              className: "bc-theme-editor-row-actions",
              style: {
                display: "flex",
                gap: "8px",
                marginTop: "8px",
                marginLeft: "auto",
                justifyContent: "flex-end"
              },
              children: [
                /* @__PURE__ */ r(
                  U,
                  {
                    variant: "primary",
                    size: "sm",
                    leftIcon: /* @__PURE__ */ r(Ce, { size: 12 }),
                    onClick: () => F(A),
                    disabled: n,
                    children: "Save"
                  }
                ),
                /* @__PURE__ */ r(
                  U,
                  {
                    variant: "secondary",
                    size: "sm",
                    onClick: E,
                    disabled: n,
                    children: "Cancel"
                  }
                )
              ]
            }
          )
        ] }, A);
      }),
      a ? /* @__PURE__ */ m("div", { className: "bc-theme-editor-row", children: [
        /* @__PURE__ */ r(
          "input",
          {
            type: "text",
            className: "bc-theme-editor-input",
            placeholder: "Color name",
            value: d,
            onChange: (A) => p(A.target.value),
            disabled: n,
            autoFocus: !0
          }
        ),
        j(
          "__new_color__",
          c,
          u,
          !0
          // new color is editable
        ),
        /* @__PURE__ */ r(
          U,
          {
            variant: "primary",
            size: "sm",
            leftIcon: /* @__PURE__ */ r(Ce, { size: 12 }),
            onClick: s,
            disabled: n || !d.trim(),
            children: "Save"
          }
        ),
        /* @__PURE__ */ r(
          U,
          {
            variant: "secondary",
            size: "sm",
            onClick: () => {
              l(!1), p(""), u("#000000ff");
            },
            disabled: n,
            children: "Cancel"
          }
        )
      ] }) : /* @__PURE__ */ r(
        U,
        {
          variant: "ghost",
          size: "sm",
          leftIcon: /* @__PURE__ */ r(ot, { size: 12 }),
          onClick: () => l(!0),
          disabled: n,
          children: "Add Color"
        }
      )
    ] }) })
  ] });
}, un = (e) => {
  const t = {};
  let o = !1;
  for (const [n, a] of Object.entries(e))
    typeof a == "string" && a.startsWith("#") ? (t[n] = { type: "custom", value: a }, o = !0) : t[n] = a;
  return { migrated: t, needsMigration: o };
}, hn = (e) => {
  const t = {};
  for (const [o, n] of Object.entries(To))
    o in e || (t[o] = n);
  return t;
}, Eo = (e) => {
  if (!e) return { processedTheme: e, needsUpdate: !1 };
  let t = !1;
  const o = { ...e };
  o.config || (o.config = {});
  const n = o.config.colors || {}, a = hn(n);
  if (Object.keys(a).length > 0 && (o.config.colors = { ...n, ...a }, t = !0), o.config.widgetConfig) {
    const l = {};
    for (const [d, p] of Object.entries(
      o.config.widgetConfig
    )) {
      const { migrated: c, needsMigration: u } = un(
        p
      );
      l[d] = c, u && (t = !0);
    }
    o.config.widgetConfig = l;
  }
  return { processedTheme: o, needsUpdate: t };
}, Po = async (e, t) => {
  try {
    console.log(
      `Theme ${e} needs migration. Will be migrated on next save.`
    );
  } catch (o) {
    console.error(`Failed to migrate theme ${e}:`, o);
  }
}, yn = async (e) => {
  const t = await fetch(
    `${ce}/brand-app-widget-theme/by-theme-id?appThemeId=${e}`
  );
  if (!t.ok)
    throw new Error("Failed to fetch widget theme");
  const o = await t.json(), { processedTheme: n, needsUpdate: a } = Eo(o);
  return a && Po(e, n.config), n;
}, bn = async (e) => {
  const t = await fetch(
    `${ce}/brand-app-widget-theme/published-by-app-id?appId=${e}`
  );
  if (!t.ok)
    throw new Error("Failed to fetch published widget theme");
  const o = await t.json(), { processedTheme: n, needsUpdate: a } = Eo(o);
  return a && (n != null && n.appThemeId) && Po(
    n.appThemeId,
    n.config
  ), n;
}, fn = async ({
  themeId: e,
  widgetId: t,
  widgetState: o,
  editThemeToken: n
}) => {
  const a = await fetch(
    `${ce}/brand-app-widget-theme/update-widget-config`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        widgetId: t,
        widgetState: o,
        editThemeToken: n
      })
    }
  );
  if (!a.ok) {
    let l = "Failed to update widget config";
    try {
      l = (await a.json()).message || l;
    } catch {
    }
    throw new Error(l);
  }
  return a.json();
}, xt = async ({
  themeId: e,
  colorKey: t,
  colorValue: o,
  editThemeToken: n
}) => {
  const a = await fetch(
    `${ce}/brand-app-widget-theme/set-theme-color`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        colorKey: t,
        colorValue: o,
        editThemeToken: n
      })
    }
  );
  if (!a.ok) {
    let l = "Failed to set theme color";
    try {
      l = (await a.json()).message || l;
    } catch {
    }
    throw new Error(l);
  }
  return a.json();
}, xn = async ({
  themeId: e,
  colorKey: t,
  editThemeToken: o
}) => {
  const n = await fetch(
    `${ce}/brand-app-widget-theme/delete-theme-color`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        colorKey: t,
        editThemeToken: o
      })
    }
  );
  if (!n.ok) {
    let a = "Failed to delete theme color";
    try {
      a = (await n.json()).message || a;
    } catch {
    }
    throw new Error(a);
  }
  return n.json();
}, Cn = async ({
  themeId: e,
  oldColorKey: t,
  newColorKey: o,
  editThemeToken: n
}) => {
  const a = await fetch(
    `${ce}/brand-app-widget-theme/rename-theme-color`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        oldColorKey: t,
        newColorKey: o,
        editThemeToken: n
      })
    }
  );
  if (!a.ok) {
    let l = "Failed to rename theme color";
    try {
      l = (await a.json()).message || l;
    } catch {
    }
    throw new Error(l);
  }
  return a.json();
}, Ct = async ({
  themeId: e,
  fileName: t,
  contentType: o,
  assetType: n,
  editThemeToken: a
}) => {
  const l = await fetch(
    `${ce}/brand-app-widget-theme/generate-asset-upload-url`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        fileName: t,
        contentType: o,
        assetType: n,
        editThemeToken: a
      })
    }
  );
  if (!l.ok) {
    let p = "Failed to generate upload URL";
    try {
      const c = await l.json();
      p = c.errorMessage || c.message || p;
    } catch {
    }
    throw new Error(p);
  }
  const d = await l.json();
  if (d.status === "failed")
    throw new Error(d.errorMessage || "Failed to generate upload URL");
  return {
    signedUploadUrl: d.signedUploadUrl,
    objectPublicUrl: d.objectPublicUrl
  };
}, kt = async ({
  file: e,
  signedUploadUrl: t
}) => {
  if (!(await fetch(t, {
    method: "PUT",
    body: e,
    headers: {
      "Content-Type": e.type
    }
  })).ok)
    throw new Error("Failed to upload file to S3");
}, kn = async ({
  themeId: e,
  fontKey: t,
  fontValue: o,
  editThemeToken: n
}) => {
  const a = await fetch(
    `${ce}/brand-app-widget-theme/set-theme-font`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        fontKey: t,
        fontValue: o,
        editThemeToken: n
      })
    }
  );
  if (!a.ok) {
    let l = "Failed to set theme font";
    try {
      l = (await a.json()).message || l;
    } catch {
    }
    throw new Error(l);
  }
  return a.json();
}, vn = async ({
  themeId: e,
  fontKey: t,
  editThemeToken: o
}) => {
  const n = await fetch(
    `${ce}/brand-app-widget-theme/delete-theme-font`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        fontKey: t,
        editThemeToken: o
      })
    }
  );
  if (!n.ok) {
    let a = "Failed to delete theme font";
    try {
      a = (await n.json()).message || a;
    } catch {
    }
    throw new Error(a);
  }
  return n.json();
}, wn = async ({
  themeId: e,
  iconKey: t,
  iconValue: o,
  editThemeToken: n
}) => {
  const a = await fetch(
    `${ce}/brand-app-widget-theme/set-theme-icon`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        iconKey: t,
        iconValue: o,
        editThemeToken: n
      })
    }
  );
  if (!a.ok) {
    let l = "Failed to set theme icon";
    try {
      l = (await a.json()).message || l;
    } catch {
    }
    throw new Error(l);
  }
  return a.json();
}, Sn = async ({
  themeId: e,
  iconKey: t,
  editThemeToken: o
}) => {
  const n = await fetch(
    `${ce}/brand-app-widget-theme/delete-theme-icon`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        iconKey: t,
        editThemeToken: o
      })
    }
  );
  if (!n.ok) {
    let a = "Failed to delete theme icon";
    try {
      a = (await n.json()).message || a;
    } catch {
    }
    throw new Error(a);
  }
  return n.json();
}, Ae = ["bc-widget-theme"], Io = "bc-theme-updated";
let De = null, vt = !1;
const Bn = (e) => {
  De = e, $(() => {
    if (vt) return;
    vt = !0;
    const t = (o) => {
      var a;
      if (o.origin !== window.location.origin || ((a = o.data) == null ? void 0 : a.type) !== Io || !De) return;
      const { themeId: n } = o.data.payload;
      De.refetchQueries({
        queryKey: [...Ae, n]
      });
    };
    window.addEventListener("message", t);
  }, []);
}, Se = () => {
  const e = we(), t = mo();
  return Bn(t), Jo({
    queryKey: [...Ae, e.themeId],
    queryFn: async () => {
      if (e.themeId)
        return yn(e.themeId);
      const o = window.location.hostname;
      return bn(o);
    },
    staleTime: 5 * 60 * 1e3
    // 5 minutes
  });
}, nt = () => {
  var n;
  const { data: e, isLoading: t, refetch: o } = Se();
  return {
    themeColors: ((n = e == null ? void 0 : e.config) == null ? void 0 : n.colors) || {},
    isLoading: t,
    refreshThemeColors: async () => {
      await o();
    }
  };
}, Mo = () => {
  var n;
  const { data: e, isLoading: t, refetch: o } = Se();
  return {
    themeFonts: ((n = e == null ? void 0 : e.config) == null ? void 0 : n.fonts) || {},
    isLoading: t,
    refreshThemeFonts: async () => {
      await o();
    }
  };
}, Ao = () => {
  var n;
  const { data: e, isLoading: t, refetch: o } = Se();
  return {
    themeIcons: ((n = e == null ? void 0 : e.config) == null ? void 0 : n.icons) || {},
    isLoading: t,
    refreshThemeIcons: async () => {
      await o();
    }
  };
}, zn = (e, t) => {
  var l, d;
  const { data: o, isLoading: n } = Se(), a = e ? (d = (l = o == null ? void 0 : o.config) == null ? void 0 : l.widgetConfig) == null ? void 0 : d[e] : void 0;
  return {
    ...t,
    ...a,
    isLoading: n
  };
}, Fn = (e) => {
  const t = mo(), o = we();
  return { updateWidgetConfig: (l, d) => {
    e && t.setQueryData(
      [...Ae, o.themeId],
      (p) => {
        var c, u, s;
        return p ? {
          ...p,
          config: {
            ...p == null ? void 0 : p.config,
            widgetConfig: {
              ...(c = p == null ? void 0 : p.config) == null ? void 0 : c.widgetConfig,
              [e]: {
                ...(s = (u = p == null ? void 0 : p.config) == null ? void 0 : u.widgetConfig) == null ? void 0 : s[e],
                [l]: d
              }
            }
          }
        } : {
          config: {
            widgetConfig: {
              [e]: {
                [l]: d
              }
            }
          }
        };
      }
    );
  }, getWidgetState: () => {
    var d, p;
    if (!e) return;
    const l = t.getQueryData([
      ...Ae,
      o.themeId
    ]);
    return (p = (d = l == null ? void 0 : l.config) == null ? void 0 : d.widgetConfig) == null ? void 0 : p[e];
  } };
}, No = (e, t, o = "#000000") => e ? typeof e == "string" ? e : e.type === "custom" ? e.value : t[e.value] ?? o : o, Tn = (e) => (t, o = "#000000") => No(t, e, o), Ci = () => {
  const { themeColors: e } = nt();
  return de(
    (o, n = "#000000") => No(o, e, n),
    [e]
  );
};
function q(e, t, o) {
  const { isLoading: n, ...a } = zn(
    e,
    t
  ), l = a, [d, p] = N(!1), { themeColors: c } = nt(), { themeFonts: u } = Mo(), { themeIcons: s } = Ao(), g = le(
    () => Tn(c),
    [c]
  ), y = we(), { updateWidgetConfig: k, getWidgetState: f } = Fn(e), b = le(() => {
    const S = {};
    return o.forEach((z) => {
      S[z.key] = z.type;
    }), S;
  }, [o]), h = de(
    (S, z) => {
      const O = b[S];
      let R = z;
      switch (O) {
        case "toggle":
          typeof z == "string" && (R = z === "true");
          break;
        case "number":
          if (typeof z == "string" && z !== "") {
            const x = parseFloat(z);
            isNaN(x) || (R = x);
          }
          break;
        case "options":
          typeof z == "string" && (z === "true" ? R = !0 : z === "false" ? R = !1 : /^\d+$/.test(z) && (R = parseInt(z, 10)));
          break;
      }
      k(S, R);
    },
    [b, k]
  ), w = !!(y.themeId && y.editThemeToken && e), B = de(async () => {
    if (!y.themeId || !y.editThemeToken || !e) {
      console.warn("Cannot save: missing themeId or editThemeToken");
      return;
    }
    p(!0);
    try {
      const S = f() || l;
      await fn({
        themeId: y.themeId,
        widgetId: e,
        widgetState: S,
        editThemeToken: y.editThemeToken
      });
    } catch (S) {
      console.error("Failed to save widget config:", S), alert(`Failed to save: ${S.message}`);
    } finally {
      p(!1);
    }
  }, [y, e, f, l]), T = de(() => {
    const S = { ...l };
    return o.forEach((z) => {
      const O = S[z.key];
      z.type === "options" && (typeof O == "boolean" ? S[z.key] = O ? "true" : "false" : typeof O == "number" && (S[z.key] = String(O)));
    }), S;
  }, [l, o]);
  return {
    state: l,
    isLoading: n,
    isSaving: d,
    handleEditChange: h,
    handleSave: B,
    themeColors: c,
    themeFonts: u,
    themeIcons: s,
    resolveColor: g,
    canSave: w,
    getEditValues: T
  };
}
const fe = [
  { label: "Normal", value: "400" },
  { label: "Medium", value: "500" },
  { label: "Semibold", value: "600" },
  { label: "Bold", value: "700" },
  { label: "Extra Bold", value: "800" },
  { label: "Black", value: "900" }
], V = [
  { label: "Normal", value: "normal" },
  { label: "Medium", value: "medium" },
  { label: "Semibold", value: "semibold" },
  { label: "Bold", value: "bold" },
  { label: "Extra Bold", value: "800" },
  // CSS doesn't have keyword for 800, use numeric
  { label: "Black", value: "900" }
  // CSS doesn't have keyword for 900, use numeric
];
fe.slice(
  0,
  4
);
const En = fe.slice(1, 4), Pn = fe.slice(0, 3), In = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const o = document.createElement("link");
  o.rel = "stylesheet", o.href = e, document.head.appendChild(o);
}, Mn = {
  // Border styling
  borderColor: M("#DCDDDC"),
  borderColorFocus: M("#DCDDDC"),
  borderRadiusSingleLine: 100,
  // pill shape
  borderRadiusMultiLine: 20,
  // rounded
  borderWidth: 1,
  // Submit button
  submitButtonBgColor: P("textPrimary"),
  submitButtonBgColorHover: P("textPrimary"),
  submitButtonIconColor: P("textPrimary"),
  submitButtonSize: 24,
  submitButtonBorderRadius: 14,
  // Action icons (attachment, mic)
  iconColor: P("textPrimary"),
  iconColorHover: P("tertiary"),
  iconSize: 24,
  micActiveColor: P("error"),
  microphoneIcon: "default",
  // Textarea typography
  fontSize: 16,
  fontWeight: "medium",
  fontFamily: "inherit",
  textColor: P("textPrimary"),
  placeholderColor: M("#9CA3AF"),
  // Layout
  paddingX: 12,
  paddingY: 12,
  maxWidth: 768,
  // Visibility toggles
  showAttachmentButton: !0,
  showMicrophoneButton: !0
}, wt = [
  // Border styling group
  { key: "borderColor", label: "Border Color", type: "color" },
  { key: "borderColorFocus", label: "Border Color (Focus)", type: "color" },
  {
    key: "borderRadiusSingleLine",
    label: "Border Radius (Single Line)",
    type: "number",
    min: 0,
    max: 100,
    step: 1
  },
  {
    key: "borderRadiusMultiLine",
    label: "Border Radius (Multi Line)",
    type: "number",
    min: 0,
    max: 50,
    step: 1
  },
  {
    key: "borderWidth",
    label: "Border Width",
    type: "number",
    min: 0,
    max: 5,
    step: 1
  },
  // Submit button group
  { key: "submitButtonBgColor", label: "Submit Button Color", type: "color" },
  {
    key: "submitButtonBgColorHover",
    label: "Submit Button Hover Color",
    type: "color"
  },
  {
    key: "submitButtonIconColor",
    label: "Submit Button Icon Color",
    type: "color"
  },
  {
    key: "submitButtonSize",
    label: "Submit Button Size",
    type: "number",
    min: 16,
    max: 48,
    step: 2
  },
  {
    key: "submitButtonBorderRadius",
    label: "Submit Button Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 1
  },
  // Action icons group
  { key: "iconColor", label: "Icon Color", type: "color" },
  { key: "iconColorHover", label: "Icon Hover Color", type: "color" },
  {
    key: "iconSize",
    label: "Icon Size",
    type: "number",
    min: 16,
    max: 48,
    step: 2
  },
  { key: "micActiveColor", label: "Mic Active Color", type: "color" },
  { key: "microphoneIcon", label: "Microphone Icon", type: "icon" },
  // Typography group
  {
    key: "fontSize",
    label: "Font Size",
    type: "number",
    min: 12,
    max: 24,
    step: 1
  },
  {
    key: "fontWeight",
    label: "Font Weight",
    type: "options",
    options: V
  },
  {
    key: "fontFamily",
    label: "Font Family",
    type: "font"
  },
  { key: "textColor", label: "Text Color", type: "color" },
  { key: "placeholderColor", label: "Placeholder Color", type: "color" },
  // Layout group
  {
    key: "paddingX",
    label: "Horizontal Padding",
    type: "number",
    min: 0,
    max: 32,
    step: 2
  },
  {
    key: "paddingY",
    label: "Vertical Padding",
    type: "number",
    min: 0,
    max: 32,
    step: 2
  },
  {
    key: "maxWidth",
    label: "Max Width",
    type: "number",
    min: 300,
    max: 1200,
    step: 50
  },
  // Visibility toggles
  {
    key: "showAttachmentButton",
    label: "Show Attachment Button",
    type: "options",
    options: [
      { label: "Yes", value: "true" },
      { label: "No", value: "false" }
    ]
  },
  {
    key: "showMicrophoneButton",
    label: "Show Microphone Button",
    type: "options",
    options: [
      { label: "Yes", value: "true" },
      { label: "No", value: "false" }
    ]
  }
], ki = ({
  initialState: e = {},
  widgetId: t,
  displayName: o,
  children: n
}) => {
  const {
    state: a,
    isLoading: l,
    isSaving: d,
    handleEditChange: p,
    handleSave: c,
    themeColors: u,
    themeFonts: s,
    themeIcons: g,
    resolveColor: y,
    canSave: k,
    getEditValues: f
  } = q(
    t,
    { ...Mn, ...e },
    wt
  ), b = a.fontFamily, h = b && b !== "inherit" ? s[b] : null, w = h && h.format === "google" ? h.url : null;
  if ($(() => {
    w && In(w);
  }, [w]), l)
    return /* @__PURE__ */ r(G, {});
  const B = h ? h.format === "system" ? h.url : `"${h.name}", sans-serif` : "inherit", T = h && h.format !== "system" && h.format !== "google", S = `chat-input-${t || "default"}`, z = `
    ${T ? `
      @font-face {
        font-family: "${h.name}";
        src: url("${h.url}") format("${h.format}");
        font-display: swap;
      }
    ` : ""}
    ${B !== "inherit" ? `.${S} { font-family: ${B} !important; }` : ""}
  `.trim(), O = {
    ...a,
    fontFamilyCss: B
  }, R = /* @__PURE__ */ m(G, { children: [
    z && /* @__PURE__ */ r("style", { children: z }),
    n(O, g, y)
  ] });
  return /* @__PURE__ */ r(
    K,
    {
      widgetId: t,
      displayName: o,
      editFields: wt,
      editValues: f(),
      onEditChange: p,
      onSave: k ? c : void 0,
      isSaving: d,
      themeColors: u,
      themeFonts: s,
      themeIcons: g,
      children: R
    }
  );
}, St = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const o = document.createElement("link");
  o.rel = "stylesheet", o.href = e, document.head.appendChild(o);
}, An = {
  // Headings - decreasing sizes with bold weight
  h1: {
    fontSize: 28,
    fontWeight: "700",
    lineHeight: 1.3,
    marginTop: 16,
    marginBottom: 12,
    color: P("textPrimary")
  },
  h2: {
    fontSize: 24,
    fontWeight: "700",
    lineHeight: 1.35,
    marginTop: 14,
    marginBottom: 10,
    color: P("textPrimary")
  },
  h3: {
    fontSize: 20,
    fontWeight: "600",
    lineHeight: 1.4,
    marginTop: 12,
    marginBottom: 8,
    color: P("textPrimary")
  },
  h4: {
    fontSize: 18,
    fontWeight: "600",
    lineHeight: 1.4,
    marginTop: 10,
    marginBottom: 6
  },
  h5: {
    fontSize: 16,
    fontWeight: "600",
    lineHeight: 1.4,
    marginTop: 8,
    marginBottom: 4
  },
  // Text elements
  p: {
    fontSize: 16,
    fontWeight: "500",
    lineHeight: 1.6,
    marginTop: 0,
    marginBottom: 12,
    color: P("textPrimary")
  },
  strong: { fontWeight: "600" },
  em: { fontWeight: "500" },
  code: { fontSize: 14, fontWeight: "500", lineHeight: 1.4 },
  blockquote: {
    fontSize: 16,
    fontWeight: "500",
    lineHeight: 1.6,
    marginTop: 8,
    marginBottom: 8,
    color: P("textPrimary")
  },
  // Lists
  ul: { marginTop: 8, marginBottom: 12 },
  ol: { marginTop: 8, marginBottom: 12 },
  li: {
    fontSize: 16,
    fontWeight: "500",
    lineHeight: 1.6,
    marginBottom: 4,
    color: P("textPrimary")
  },
  // Tables
  table: { fontSize: 14, marginTop: 8, marginBottom: 12 },
  thead: { fontWeight: "600" },
  tbody: { fontWeight: "500" },
  tr: {},
  th: {
    fontSize: 14,
    fontWeight: "600",
    lineHeight: 1.4,
    color: P("textPrimary")
  },
  td: {
    fontSize: 14,
    fontWeight: "500",
    lineHeight: 1.4,
    color: P("textPrimary")
  }
}, Nn = {
  // Background & Colors (defaults for user message, assistant can override via widgetId)
  bgColor: M("#E8F4FD"),
  // blueWhite-like for user
  textColor: P("textPrimary"),
  // Border radius
  borderRadius: 10,
  borderRadiusShort: 100,
  // pill shape for short messages
  // Typography
  fontSize: 16,
  fontWeight: "500",
  fontFamily: "inherit",
  lineHeight: 1.5,
  // Padding
  paddingX: 16,
  paddingY: 12,
  // Layout
  maxWidth: "70%",
  alignment: "left",
  // Short message threshold
  shortMessageThreshold: 50,
  // Element styles with defaults
  elementStyles: An
}, Fe = (e, t) => {
  const o = `elementStyles.${e}`;
  return [
    {
      key: `${o}.fontFamily`,
      label: `${t} Font`,
      type: "font"
    },
    {
      key: `${o}.fontSize`,
      label: `${t} Font Size`,
      type: "number",
      min: 10,
      max: 48,
      step: 1
    },
    {
      key: `${o}.fontWeight`,
      label: `${t} Font Weight`,
      type: "options",
      options: fe
    },
    {
      key: `${o}.color`,
      label: `${t} Color`,
      type: "color"
    },
    {
      key: `${o}.lineHeight`,
      label: `${t} Line Height`,
      type: "number",
      min: 1,
      max: 2.5,
      step: 0.1
    },
    {
      key: `${o}.marginTop`,
      label: `${t} Margin Top`,
      type: "number",
      min: 0,
      max: 32,
      step: 2
    },
    {
      key: `${o}.marginBottom`,
      label: `${t} Margin Bottom`,
      type: "number",
      min: 0,
      max: 32,
      step: 2
    }
  ];
}, Te = {
  h1: "H1",
  h2: "H2",
  h3: "H3",
  h4: "H4",
  h5: "H5",
  p: "Paragraph",
  strong: "Bold",
  em: "Italic",
  code: "Code",
  blockquote: "Blockquote",
  ul: "Unordered List",
  ol: "Ordered List",
  li: "List Item",
  table: "Table",
  thead: "Table Header",
  tbody: "Table Body",
  tr: "Table Row",
  th: "Header Cell",
  td: "Table Cell"
}, Ho = [
  { key: "bgColor", label: "Background Color", type: "color" },
  { key: "textColor", label: "Text Color", type: "color" },
  {
    key: "borderRadius",
    label: "Border Radius (px)",
    type: "number",
    min: 0,
    max: 24,
    step: 1
  },
  {
    key: "borderRadiusShort",
    label: "Short Msg Radius (px)",
    type: "number",
    min: 0,
    max: 100,
    step: 5
  },
  {
    key: "fontSize",
    label: "Base Font Size (px)",
    type: "number",
    min: 12,
    max: 20,
    step: 1
  },
  {
    key: "fontWeight",
    label: "Base Font Weight",
    type: "options",
    options: Pn
  },
  {
    key: "fontFamily",
    label: "Font Family",
    type: "font"
  },
  {
    key: "lineHeight",
    label: "Base Line Height",
    type: "number",
    min: 1,
    max: 2,
    step: 0.1
  },
  {
    key: "paddingX",
    label: "Horizontal Padding (px)",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  {
    key: "paddingY",
    label: "Vertical Padding (px)",
    type: "number",
    min: 6,
    max: 20,
    step: 2
  },
  {
    key: "maxWidth",
    label: "Max Width",
    type: "options",
    options: [
      { label: "100%", value: "100%" },
      { label: "90%", value: "90%" },
      { label: "80%", value: "80%" },
      { label: "70%", value: "70%" },
      { label: "60%", value: "60%" }
    ]
  },
  {
    key: "alignment",
    label: "Alignment",
    type: "options",
    options: [
      { label: "Left", value: "left" },
      { label: "Right", value: "right" },
      { label: "Center", value: "center" }
    ]
  }
], Hn = ["h1", "h2", "h3"], On = ["p", "blockquote"], Rn = ["li"], Wn = ["th", "td"], Dn = [
  ...Hn.flatMap(
    (e) => Fe(e, Te[e])
  ),
  ...On.flatMap(
    (e) => Fe(e, Te[e])
  ),
  ...Rn.flatMap(
    (e) => Fe(e, Te[e])
  ),
  ...Wn.flatMap(
    (e) => Fe(e, Te[e])
  )
], Ln = [...Ho, ...Dn], jn = (e, t, o, n) => {
  if (!t) return "";
  const a = [], l = [], d = /* @__PURE__ */ new Set();
  for (const [p, c] of Object.entries(t)) {
    if (!c) continue;
    const u = [];
    if (c.fontSize !== void 0 && u.push(`font-size: ${c.fontSize}px !important`), c.fontWeight !== void 0 && u.push(`font-weight: ${c.fontWeight} !important`), c.color && c.color !== "inherit") {
      const s = n(c.color);
      u.push(`color: ${s} !important`);
    }
    if (c.lineHeight !== void 0 && u.push(`line-height: ${c.lineHeight} !important`), c.marginTop !== void 0 && u.push(`margin-top: ${c.marginTop}px !important`), c.marginBottom !== void 0 && u.push(`margin-bottom: ${c.marginBottom}px !important`), c.fontFamily && c.fontFamily !== "inherit") {
      const s = o[c.fontFamily];
      s && (s.format === "system" ? u.push(`font-family: ${s.url} !important`) : (u.push(
        `font-family: "${s.name}", sans-serif !important`
      ), s.format !== "google" && !d.has(s.name) && (l.push(`
              @font-face {
                font-family: "${s.name}";
                src: url("${s.url}") format("${s.format}");
                font-display: swap;
              }
            `), d.add(s.name))));
    }
    u.length > 0 && a.push(`#concierge-mount .${e} .message-content ${p},
#concierge-mount .${e} .message-content .message-markdown ${p},
.${e} .message-content ${p},
.${e} .message-content .message-markdown ${p} {
  ${u.join(`;
  `)};
}`);
  }
  return [...l, ...a].join(`

`);
}, Gn = (e, t, o) => {
  const n = t.split("."), a = { ...e };
  let l = a;
  for (let d = 0; d < n.length - 1; d++) {
    const p = n[d];
    l[p] = { ...l[p] }, l = l[p];
  }
  return l[n[n.length - 1]] = o, a;
}, Qn = (e) => {
  const t = {};
  for (const [o, n] of Object.entries(e))
    if (o === "elementStyles" && typeof n == "object" && n !== null) {
      for (const [a, l] of Object.entries(
        n
      ))
        if (l && typeof l == "object")
          for (const [d, p] of Object.entries(l))
            t[`elementStyles.${a}.${d}`] = p;
    } else
      t[o] = n;
  return t;
}, vi = ({
  initialState: e = {},
  widgetId: t,
  displayName: o,
  children: n
}) => {
  const {
    state: a,
    isLoading: l,
    isSaving: d,
    handleEditChange: p,
    handleSave: c,
    themeColors: u,
    themeFonts: s,
    resolveColor: g,
    canSave: y
  } = q(
    t,
    { ...Nn, ...e },
    Ho
    // Only use base fields for type transformations
  ), k = (I, D) => {
    if (I.includes(".")) {
      const C = Gn(a, I, D), E = I.split(".")[0];
      p(E, C[E]);
    } else
      p(I, D);
  }, f = le(() => Qn(a), [a]), b = a.fontFamily, h = b && b !== "inherit" ? s[b] : null, w = h && h.format === "google" ? h.url : null, B = le(() => {
    const I = [];
    if (a.elementStyles) {
      for (const D of Object.values(a.elementStyles))
        if (D != null && D.fontFamily && D.fontFamily !== "inherit") {
          const C = s[D.fontFamily];
          (C == null ? void 0 : C.format) === "google" && C.url && !I.includes(C.url) && I.push(C.url);
        }
    }
    return I;
  }, [a.elementStyles, s]);
  $(() => {
    w && St(w);
    for (const I of B)
      St(I);
  }, [w, B]);
  const T = `message-bubble-${t || "default"}`, S = le(
    () => jn(
      T,
      a.elementStyles,
      s,
      g
    ),
    [T, a.elementStyles, s, g]
  );
  if (l)
    return /* @__PURE__ */ r(G, {});
  const z = h ? h.format === "system" ? h.url : `"${h.name}", sans-serif` : "inherit", x = [`
    ${h && h.format !== "system" && h.format !== "google" ? `
      @font-face {
        font-family: "${h.name}";
        src: url("${h.url}") format("${h.format}");
        font-display: swap;
      }
    ` : ""}
    ${z !== "inherit" ? `.${T} { font-family: ${z} !important; }` : ""}
  `.trim(), S].filter(Boolean).join(`

`), L = {
    ...a,
    fontFamilyCss: z
  }, Y = /* @__PURE__ */ m("div", { className: T, children: [
    x && /* @__PURE__ */ r("style", { children: x }),
    n(L, g)
  ] });
  return /* @__PURE__ */ r(
    K,
    {
      widgetId: t,
      displayName: o,
      editFields: Ln,
      editValues: f,
      onEditChange: k,
      onSave: y ? c : void 0,
      isSaving: d,
      themeColors: u,
      themeFonts: s,
      children: Y
    }
  );
}, wi = {
  headings: ["h1", "h2", "h3", "h4", "h5"],
  text: ["p", "strong", "em", "code", "blockquote"],
  lists: ["ul", "ol", "li"],
  tables: ["table", "thead", "tbody", "tr", "th", "td"]
}, $n = {
  // Container
  containerBgColor: M("#e9ecef"),
  containerPaddingX: 16,
  containerPaddingY: 12,
  containerBorderRadius: 18,
  containerBorderRadiusBottomLeft: 5,
  // Dots
  dotColor: M("#999999"),
  dotSize: 8,
  dotSpacing: 2,
  // Animation
  animationDuration: 1.4,
  // Status text
  statusTextColor: M("#666666"),
  statusFontSize: 12,
  statusMarginTop: 8
}, Bt = [
  // Container
  { key: "containerBgColor", label: "Container Background", type: "color" },
  {
    key: "containerPaddingX",
    label: "Container Padding X",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  {
    key: "containerPaddingY",
    label: "Container Padding Y",
    type: "number",
    min: 6,
    max: 20,
    step: 2
  },
  {
    key: "containerBorderRadius",
    label: "Container Border Radius",
    type: "number",
    min: 0,
    max: 30,
    step: 2
  },
  {
    key: "containerBorderRadiusBottomLeft",
    label: "Bottom Left Radius",
    type: "number",
    min: 0,
    max: 20,
    step: 1
  },
  // Dots
  { key: "dotColor", label: "Dot Color", type: "color" },
  {
    key: "dotSize",
    label: "Dot Size",
    type: "number",
    min: 4,
    max: 16,
    step: 1
  },
  {
    key: "dotSpacing",
    label: "Dot Spacing",
    type: "number",
    min: 1,
    max: 8,
    step: 1
  },
  // Animation
  {
    key: "animationDuration",
    label: "Animation Duration (s)",
    type: "number",
    min: 0.5,
    max: 3,
    step: 0.1
  },
  // Status text
  { key: "statusTextColor", label: "Status Text Color", type: "color" },
  {
    key: "statusFontSize",
    label: "Status Font Size",
    type: "number",
    min: 10,
    max: 16,
    step: 1
  },
  {
    key: "statusMarginTop",
    label: "Status Margin Top",
    type: "number",
    min: 4,
    max: 16,
    step: 2
  }
], Si = ({
  initialState: e = {},
  widgetId: t,
  displayName: o,
  children: n
}) => {
  const {
    state: a,
    isLoading: l,
    isSaving: d,
    handleEditChange: p,
    handleSave: c,
    themeColors: u,
    resolveColor: s,
    canSave: g
  } = q(
    t,
    { ...$n, ...e },
    Bt
  );
  if (l)
    return /* @__PURE__ */ r(G, {});
  const y = n(a, s);
  return /* @__PURE__ */ r(
    K,
    {
      widgetId: t,
      displayName: o,
      editFields: Bt,
      editValues: a,
      onEditChange: p,
      onSave: g ? c : void 0,
      isSaving: d,
      themeColors: u,
      children: y
    }
  );
}, Yn = {
  // Drawer container
  drawerWidth: 320,
  drawerBgColor: P("secondary"),
  // Header
  headerPaddingX: 12,
  headerPaddingY: 12,
  headerTitleFontSize: 14,
  headerTitleFontWeight: "semibold",
  headerTitleColor: P("textPrimary"),
  headerIconColor: M("#6b7280"),
  headerIconColorHover: M("#111827"),
  headerIconBgColorHover: M("#f3f4f6"),
  // List items
  itemPaddingX: 12,
  itemPaddingY: 10,
  itemBgColor: M("transparent"),
  itemBgColorHover: M("#f9fafb"),
  itemTitleFontSize: 14,
  itemTitleFontWeight: "medium",
  itemTitleColor: M("#111827"),
  itemTitleLineClamp: 2,
  // Timestamp
  showTimestamp: !1,
  timestampFontSize: 12,
  timestampColor: M("#6b7280"),
  timestampMarginTop: 4,
  // Empty state
  emptyStateFontSize: 14,
  emptyStateColor: M("#6b7280"),
  emptyStatePadding: 24,
  // Error state
  errorBgColor: M("#fef2f2"),
  errorTextColor: P("error"),
  errorFontSize: 14,
  errorPadding: 12,
  errorBorderRadius: 8
}, zt = [
  // Drawer container
  {
    key: "drawerWidth",
    label: "Drawer Width",
    type: "number",
    min: 240,
    max: 400,
    step: 20
  },
  { key: "drawerBgColor", label: "Drawer Background", type: "color" },
  // Header
  {
    key: "headerPaddingX",
    label: "Header Padding X",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  {
    key: "headerPaddingY",
    label: "Header Padding Y",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  {
    key: "headerTitleFontSize",
    label: "Header Title Size",
    type: "number",
    min: 12,
    max: 20,
    step: 1
  },
  {
    key: "headerTitleFontWeight",
    label: "Header Title Weight",
    type: "options",
    options: [...V]
  },
  { key: "headerTitleColor", label: "Header Title Color", type: "color" },
  { key: "headerIconColor", label: "Header Icon Color", type: "color" },
  { key: "headerIconColorHover", label: "Header Icon Hover", type: "color" },
  {
    key: "headerIconBgColorHover",
    label: "Header Icon Bg Hover",
    type: "color"
  },
  // List items
  {
    key: "itemPaddingX",
    label: "Item Padding X",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  {
    key: "itemPaddingY",
    label: "Item Padding Y",
    type: "number",
    min: 6,
    max: 20,
    step: 2
  },
  { key: "itemBgColor", label: "Item Background", type: "color" },
  { key: "itemBgColorHover", label: "Item Background (Hover)", type: "color" },
  {
    key: "itemTitleFontSize",
    label: "Item Title Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1
  },
  {
    key: "itemTitleFontWeight",
    label: "Item Title Weight",
    type: "options",
    options: [...V]
  },
  { key: "itemTitleColor", label: "Item Title Color", type: "color" },
  {
    key: "itemTitleLineClamp",
    label: "Item Title Line Clamp",
    type: "number",
    min: 1,
    max: 4,
    step: 1
  },
  // Timestamp
  { key: "showTimestamp", label: "Show Timestamp", type: "toggle" },
  {
    key: "timestampFontSize",
    label: "Timestamp Font Size",
    type: "number",
    min: 10,
    max: 14,
    step: 1
  },
  { key: "timestampColor", label: "Timestamp Color", type: "color" },
  {
    key: "timestampMarginTop",
    label: "Timestamp Margin Top",
    type: "number",
    min: 0,
    max: 12,
    step: 2
  },
  // Empty state
  {
    key: "emptyStateFontSize",
    label: "Empty State Font Size",
    type: "number",
    min: 12,
    max: 16,
    step: 1
  },
  { key: "emptyStateColor", label: "Empty State Color", type: "color" },
  {
    key: "emptyStatePadding",
    label: "Empty State Padding",
    type: "number",
    min: 12,
    max: 48,
    step: 4
  },
  // Error state
  { key: "errorBgColor", label: "Error Background", type: "color" },
  { key: "errorTextColor", label: "Error Text Color", type: "color" },
  {
    key: "errorFontSize",
    label: "Error Font Size",
    type: "number",
    min: 12,
    max: 16,
    step: 1
  },
  {
    key: "errorPadding",
    label: "Error Padding",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  {
    key: "errorBorderRadius",
    label: "Error Border Radius",
    type: "number",
    min: 0,
    max: 16,
    step: 2
  }
], Jn = ({ initialState: e = {}, widgetId: t, displayName: o, children: n }) => {
  const {
    state: a,
    isLoading: l,
    isSaving: d,
    handleEditChange: p,
    handleSave: c,
    themeColors: u,
    resolveColor: s,
    canSave: g
  } = q(
    t,
    { ...Yn, ...e },
    zt
  );
  if (l)
    return /* @__PURE__ */ r(G, {});
  const y = n(a, s);
  return /* @__PURE__ */ r(
    K,
    {
      widgetId: t,
      displayName: o,
      editFields: zt,
      editValues: a,
      onEditChange: p,
      onSave: g ? c : void 0,
      isSaving: d,
      themeColors: u,
      children: y
    }
  );
}, Ft = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const o = document.createElement("link");
  o.rel = "stylesheet", o.href = e, document.head.appendChild(o);
}, Ee = ({ width: e }) => /* @__PURE__ */ r(
  "div",
  {
    style: {
      width: `${e}px`,
      height: "32px",
      borderRadius: "9999px",
      backgroundColor: "#e5e7eb",
      animation: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite"
    }
  }
), Xn = {
  // Title
  showTitle: !0,
  titleText: "Get expert advice on this product",
  titleFontSize: 18,
  titleFontWeight: "semibold",
  titleFontFamily: "inherit",
  titleColor: P("textPrimary"),
  // Container
  containerGap: 16,
  containerMarginTop: 32,
  containerMarginBottom: 16,
  // Suggestion pills
  pillPaddingX: 16,
  pillPaddingY: 12,
  pillBorderRadius: 8,
  pillBorderColor: M("#e5e7eb"),
  pillBorderWidth: 1,
  pillBgColor: M("transparent"),
  pillBgColorHover: M("#f3f4f6"),
  pillTextColor: P("textPrimary"),
  pillFontSize: 14,
  pillFontWeight: "medium",
  pillFontFamily: "inherit"
}, Tt = [
  // Title section
  { key: "showTitle", label: "Show Title", type: "toggle" },
  { key: "titleText", label: "Title Text", type: "text" },
  {
    key: "titleFontSize",
    label: "Title Font Size",
    type: "number",
    min: 14,
    max: 24,
    step: 1
  },
  {
    key: "titleFontWeight",
    label: "Title Font Weight",
    type: "options",
    options: [...V]
  },
  { key: "titleFontFamily", label: "Title Font Family", type: "font" },
  { key: "titleColor", label: "Title Color", type: "color" },
  // Container
  {
    key: "containerGap",
    label: "Gap Between Title and Pills",
    type: "number",
    min: 8,
    max: 32,
    step: 4
  },
  {
    key: "containerMarginTop",
    label: "Container Margin Top",
    type: "number",
    min: 0,
    max: 64,
    step: 4
  },
  {
    key: "containerMarginBottom",
    label: "Container Margin Bottom",
    type: "number",
    min: 0,
    max: 64,
    step: 4
  },
  // Pill styling
  {
    key: "pillPaddingX",
    label: "Pill Padding X",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  {
    key: "pillPaddingY",
    label: "Pill Padding Y",
    type: "number",
    min: 6,
    max: 20,
    step: 2
  },
  {
    key: "pillBorderRadius",
    label: "Pill Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  },
  {
    key: "pillBorderWidth",
    label: "Pill Border Width",
    type: "number",
    min: 0,
    max: 3,
    step: 1
  },
  { key: "pillBorderColor", label: "Pill Border Color", type: "color" },
  { key: "pillBgColor", label: "Pill Background", type: "color" },
  { key: "pillBgColorHover", label: "Pill Hover Background", type: "color" },
  { key: "pillTextColor", label: "Pill Text Color", type: "color" },
  {
    key: "pillFontSize",
    label: "Pill Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1
  },
  {
    key: "pillFontWeight",
    label: "Pill Font Weight",
    type: "options",
    options: [...V]
  },
  { key: "pillFontFamily", label: "Pill Font Family", type: "font" }
], Oo = {
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700
}, Un = ({ color: e = "currentColor" }) => /* @__PURE__ */ r(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "19",
    height: "19",
    viewBox: "0 0 19 19",
    fill: "none",
    style: { flexShrink: 0 },
    children: /* @__PURE__ */ r(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.6375 8.97842L15.9115 8.19942C13.4152 7.49564 11.4643 5.54472 10.7605 3.04842L9.98148 0.32242C9.90136 0.12736 9.71136 0 9.50048 0C9.2896 0 9.09961 0.12736 9.01948 0.32242L8.24048 3.04842C7.5367 5.54472 5.58578 7.49564 3.08948 8.19942L0.36348 8.97842C0.14841 9.03946 0 9.23586 0 9.45942C0 9.68298 0.14841 9.87938 0.36348 9.94042L3.08948 10.7194C5.58578 11.4232 7.53671 13.3741 8.24048 15.8704L9.01948 18.5964C9.08052 18.8115 9.27692 18.9599 9.50048 18.9599C9.72404 18.9599 9.92044 18.8115 9.98148 18.5964L10.7605 15.8704C11.4642 13.3741 13.4152 11.4232 15.9115 10.7194L18.6375 9.94042C18.8526 9.87938 19.001 9.68298 19.001 9.45942C19.001 9.23586 18.8526 9.03946 18.6375 8.97842Z",
        fill: e
      }
    )
  }
), Zn = ({ question: e, onClick: t, state: o, resolveColor: n }) => {
  const [a, l] = N(!1);
  return /* @__PURE__ */ r(
    "button",
    {
      onClick: t,
      onMouseEnter: () => l(!0),
      onMouseLeave: () => l(!1),
      style: {
        padding: `${o.pillPaddingY}px ${o.pillPaddingX}px`,
        borderRadius: `${o.pillBorderRadius}px`,
        border: `${o.pillBorderWidth}px solid ${n(o.pillBorderColor)}`,
        backgroundColor: n(a ? o.pillBgColorHover : o.pillBgColor),
        color: n(o.pillTextColor),
        fontSize: `${o.pillFontSize}px`,
        fontWeight: Oo[o.pillFontWeight] || 500,
        fontFamily: o.pillFontFamilyCss || "inherit",
        cursor: "pointer",
        transition: "background-color 0.15s ease",
        textAlign: "left",
        lineHeight: 1.4
      },
      children: e
    }
  );
}, Bi = ({
  widgetId: e = "conversation-starters",
  displayName: t = "Conversation Starters",
  initialState: o = {},
  questions: n,
  isLoading: a = !1,
  onQuestionClick: l
}) => {
  const {
    state: d,
    isLoading: p,
    isSaving: c,
    handleEditChange: u,
    handleSave: s,
    themeColors: g,
    themeFonts: y,
    resolveColor: k,
    canSave: f
  } = q(
    e,
    { ...Xn, ...o },
    Tt
  ), b = d.pillFontFamily, h = b && b !== "inherit" ? y[b] : null, w = d.titleFontFamily, B = w && w !== "inherit" ? y[w] : null, T = h && h.format === "google" ? h.url : null, S = B && B.format === "google" ? B.url : null;
  if ($(() => {
    T && Ft(T);
  }, [T]), $(() => {
    S && Ft(S);
  }, [S]), p || !a && n.length === 0)
    return null;
  const z = h ? h.format === "system" ? h.url : `"${h.name}", sans-serif` : "inherit", O = B ? B.format === "system" ? B.url : `"${B.name}", sans-serif` : "inherit", R = h && h.format !== "system" && h.format !== "google", x = B && B.format !== "system" && B.format !== "google", L = `conversation-starters-${e || "default"}`, Y = `
    @keyframes pulse {
      0%, 100% { opacity: 1; }
      50% { opacity: 0.5; }
    }
    ${R ? `
      @font-face {
        font-family: "${h.name}";
        src: url("${h.url}") format("${h.format}");
        font-display: swap;
      }
    ` : ""}
    ${x ? `
      @font-face {
        font-family: "${B.name}";
        src: url("${B.url}") format("${B.format}");
        font-display: swap;
      }
    ` : ""}
  `.trim(), I = {
    ...d,
    pillFontFamilyCss: z,
    titleFontFamilyCss: O
  }, D = /* @__PURE__ */ m(G, { children: [
    Y && /* @__PURE__ */ r("style", { children: Y }),
    /* @__PURE__ */ m(
      "div",
      {
        className: L,
        style: {
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: `${d.containerGap}px`,
          marginTop: `${d.containerMarginTop}px`,
          marginBottom: `${d.containerMarginBottom}px`
        },
        children: [
          d.showTitle && /* @__PURE__ */ m(
            "h3",
            {
              style: {
                fontSize: `${d.titleFontSize}px`,
                fontWeight: Oo[d.titleFontWeight] || 600,
                fontFamily: O,
                color: k(d.titleColor),
                margin: 0,
                display: "flex",
                alignItems: "center",
                gap: "8px"
              },
              children: [
                /* @__PURE__ */ r(Un, { color: k(d.titleColor) }),
                d.titleText
              ]
            }
          ),
          a ? /* @__PURE__ */ m(
            "div",
            {
              style: {
                display: "flex",
                flexWrap: "wrap",
                gap: "8px",
                alignItems: "flex-start"
              },
              children: [
                /* @__PURE__ */ r(Ee, { width: 180 }),
                /* @__PURE__ */ r(Ee, { width: 140 }),
                /* @__PURE__ */ r(Ee, { width: 200 }),
                /* @__PURE__ */ r(Ee, { width: 160 })
              ]
            }
          ) : /* @__PURE__ */ r(
            "div",
            {
              style: {
                display: "flex",
                flexWrap: "wrap",
                gap: "8px",
                alignItems: "flex-start",
                width: "100%"
              },
              children: n.map((C, E) => /* @__PURE__ */ r(
                Zn,
                {
                  question: C,
                  onClick: () => l(C),
                  state: I,
                  resolveColor: k
                },
                E
              ))
            }
          )
        ]
      }
    )
  ] });
  return /* @__PURE__ */ r(
    K,
    {
      widgetId: e,
      displayName: t,
      editFields: Tt,
      editValues: d,
      onEditChange: u,
      onSave: f ? s : void 0,
      isSaving: c,
      themeColors: g,
      themeFonts: y,
      children: D
    }
  );
}, qn = {
  // Pill styling (matching Figma design)
  pillBgColor: P("secondary"),
  pillBgColorHover: M("#F6F8FA"),
  pillTextColor: P("textPrimary"),
  pillFontSize: 14,
  pillFontWeight: "500",
  pillBorderRadius: 100,
  // Pill shape
  pillPaddingX: 12,
  pillPaddingY: 12,
  // Border styling
  pillBorderWidth: 1,
  pillBorderColor: P("primary"),
  // Selected state styling
  pillBgColorSelected: P("primary"),
  pillTextColorSelected: P("secondary"),
  pillBorderColorSelected: P("primary"),
  // Container
  containerGap: 8,
  maxWidthDesktop: "100%",
  maxWidthMobile: "100%"
}, Et = [
  // Default state styling
  { key: "pillBgColor", label: "Pill Background", type: "color" },
  { key: "pillBgColorHover", label: "Pill Hover Color", type: "color" },
  { key: "pillTextColor", label: "Pill Text Color", type: "color" },
  // Border styling
  {
    key: "pillBorderWidth",
    label: "Border Width (px)",
    type: "number",
    min: 0,
    max: 3,
    step: 1
  },
  { key: "pillBorderColor", label: "Border Color", type: "color" },
  // Selected state styling
  { key: "pillBgColorSelected", label: "Selected Background", type: "color" },
  { key: "pillTextColorSelected", label: "Selected Text Color", type: "color" },
  {
    key: "pillBorderColorSelected",
    label: "Selected Border Color",
    type: "color"
  },
  // Typography
  {
    key: "pillFontSize",
    label: "Font Size (px)",
    type: "number",
    min: 10,
    max: 18,
    step: 1
  },
  {
    key: "pillFontWeight",
    label: "Font Weight",
    type: "options",
    options: fe
  },
  {
    key: "pillBorderRadius",
    label: "Border Radius (px)",
    type: "number",
    min: 0,
    max: 100,
    step: 4
  },
  {
    key: "pillPaddingX",
    label: "Horizontal Padding (px)",
    type: "number",
    min: 4,
    max: 24,
    step: 2
  },
  {
    key: "pillPaddingY",
    label: "Vertical Padding (px)",
    type: "number",
    min: 2,
    max: 16,
    step: 2
  },
  // Container
  {
    key: "containerGap",
    label: "Gap Between Pills (px)",
    type: "number",
    min: 4,
    max: 16,
    step: 2
  },
  {
    key: "maxWidthDesktop",
    label: "Max Width (Desktop)",
    type: "options",
    options: [
      { label: "100%", value: "100%" },
      { label: "80%", value: "80%" },
      { label: "70%", value: "70%" },
      { label: "60%", value: "60%" }
    ]
  },
  {
    key: "maxWidthMobile",
    label: "Max Width (Mobile)",
    type: "options",
    options: [
      { label: "100%", value: "100%" },
      { label: "90%", value: "90%" },
      { label: "80%", value: "80%" }
    ]
  }
], zi = ({
  initialState: e = {},
  widgetId: t,
  displayName: o,
  children: n
}) => {
  const {
    state: a,
    isLoading: l,
    isSaving: d,
    handleEditChange: p,
    handleSave: c,
    themeColors: u,
    resolveColor: s,
    canSave: g
  } = q(
    t,
    { ...qn, ...e },
    Et
  );
  if (l)
    return /* @__PURE__ */ r(G, {});
  const y = n(a, s);
  return /* @__PURE__ */ r(
    K,
    {
      widgetId: t,
      displayName: o,
      editFields: Et,
      editValues: a,
      onEditChange: p,
      onSave: g ? c : void 0,
      isSaving: d,
      themeColors: u,
      children: y
    }
  );
}, Vn = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const o = document.createElement("link");
  o.rel = "stylesheet", o.href = e, document.head.appendChild(o);
}, Kn = {
  // Background
  backgroundColor: M("transparent"),
  // Title styling
  titleColor: P("textPrimary"),
  titleFontSize: 18,
  titleFontWeight: "semibold",
  titleFontFamily: "inherit",
  // Icon styling (shared defaults)
  iconColor: P("textPrimary"),
  iconColorHover: P("tertiary"),
  iconSize: 20,
  // Individual icon overrides
  homeIconSize: 22,
  homeIconColor: void 0,
  sidebarIconSize: 20,
  sidebarIconColor: void 0,
  composeIconSize: 18,
  composeIconColor: void 0,
  cartIconSize: 22,
  cartIconColor: void 0,
  // Button styling
  buttonSize: 44,
  buttonBorderRadius: 8,
  buttonHoverBgColor: M("#f3f4f6"),
  // Badge styling (cart count)
  badgeBgColor: P("primary"),
  badgeTextColor: P("secondary"),
  badgeFontSize: 12,
  badgeMinWidth: 18,
  // Layout
  height: 56,
  paddingX: 16,
  paddingY: 8,
  maxWidth: 768
}, Pt = [
  // Layout group
  {
    key: "backgroundColor",
    label: "Background",
    type: "color",
    group: "Layout"
  },
  {
    key: "height",
    label: "Height",
    type: "number",
    min: 40,
    max: 80,
    step: 4,
    group: "Layout"
  },
  {
    key: "paddingX",
    label: "Horizontal Padding",
    type: "number",
    min: 0,
    max: 32,
    step: 4,
    group: "Layout"
  },
  {
    key: "paddingY",
    label: "Vertical Padding",
    type: "number",
    min: 0,
    max: 24,
    step: 2,
    group: "Layout"
  },
  {
    key: "maxWidth",
    label: "Max Width",
    type: "number",
    min: 400,
    max: 1200,
    step: 50,
    group: "Layout"
  },
  // Title group
  { key: "titleColor", label: "Color", type: "color", group: "Title" },
  {
    key: "titleFontSize",
    label: "Font Size",
    type: "number",
    min: 14,
    max: 24,
    step: 1,
    group: "Title"
  },
  {
    key: "titleFontWeight",
    label: "Font Weight",
    type: "options",
    options: [...V],
    group: "Title"
  },
  {
    key: "titleFontFamily",
    label: "Font Family",
    type: "font",
    group: "Title"
  },
  // Home Icon group
  {
    key: "homeIconSize",
    label: "Size",
    type: "number",
    min: 16,
    max: 32,
    step: 1,
    group: "Home Icon"
  },
  {
    key: "homeIconColor",
    label: "Color (optional)",
    type: "color",
    group: "Home Icon"
  },
  // Sidebar Icon group
  {
    key: "sidebarIconSize",
    label: "Size",
    type: "number",
    min: 16,
    max: 32,
    step: 1,
    group: "Sidebar Icon"
  },
  {
    key: "sidebarIconColor",
    label: "Color (optional)",
    type: "color",
    group: "Sidebar Icon"
  },
  // Compose Icon group
  {
    key: "composeIconSize",
    label: "Size",
    type: "number",
    min: 16,
    max: 32,
    step: 1,
    group: "Compose Icon"
  },
  {
    key: "composeIconColor",
    label: "Color (optional)",
    type: "color",
    group: "Compose Icon"
  },
  // Cart Icon group
  {
    key: "cartIconSize",
    label: "Size",
    type: "number",
    min: 16,
    max: 32,
    step: 1,
    group: "Cart Icon"
  },
  {
    key: "cartIconColor",
    label: "Color (optional)",
    type: "color",
    group: "Cart Icon"
  },
  // Shared Icons group (default color applies to all without individual override)
  {
    key: "iconColor",
    label: "Default Color",
    type: "color",
    group: "All Icons (Defaults)"
  },
  {
    key: "iconColorHover",
    label: "Hover Color",
    type: "color",
    group: "All Icons (Defaults)"
  },
  // Buttons group
  {
    key: "buttonSize",
    label: "Size",
    type: "number",
    min: 32,
    max: 56,
    step: 4,
    group: "Buttons"
  },
  {
    key: "buttonBorderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 16,
    step: 2,
    group: "Buttons"
  },
  {
    key: "buttonHoverBgColor",
    label: "Hover Background",
    type: "color",
    group: "Buttons"
  },
  // Badge group
  { key: "badgeBgColor", label: "Background", type: "color", group: "Badge" },
  { key: "badgeTextColor", label: "Text Color", type: "color", group: "Badge" },
  {
    key: "badgeFontSize",
    label: "Font Size",
    type: "number",
    min: 10,
    max: 16,
    step: 1,
    group: "Badge"
  },
  {
    key: "badgeMinWidth",
    label: "Min Width",
    type: "number",
    min: 14,
    max: 24,
    step: 2,
    group: "Badge"
  }
], Fi = ({
  initialState: e = {},
  widgetId: t,
  displayName: o,
  children: n
}) => {
  const {
    state: a,
    isLoading: l,
    isSaving: d,
    handleEditChange: p,
    handleSave: c,
    themeColors: u,
    themeFonts: s,
    resolveColor: g,
    canSave: y
  } = q(
    t,
    { ...Kn, ...e },
    Pt
  ), k = a.titleFontFamily, f = k && k !== "inherit" ? s[k] : null, b = f && f.format === "google" ? f.url : null;
  if ($(() => {
    b && Vn(b);
  }, [b]), l)
    return /* @__PURE__ */ r(G, {});
  const h = f ? f.format === "system" ? f.url : `"${f.name}", sans-serif` : "inherit", w = f && f.format !== "system" && f.format !== "google", B = `header-${t || "default"}`, T = `
    ${w ? `
      @font-face {
        font-family: "${f.name}";
        src: url("${f.url}") format("${f.format}");
        font-display: swap;
      }
    ` : ""}
    ${h !== "inherit" ? `.${B} [data-title-text] { font-family: ${h} !important; }` : ""}
  `.trim(), S = {
    ...a,
    titleFontFamilyCss: h
  }, z = /* @__PURE__ */ m(G, { children: [
    T && /* @__PURE__ */ r("style", { children: T }),
    n(S, g)
  ] });
  return /* @__PURE__ */ r(
    K,
    {
      widgetId: t,
      displayName: o,
      editFields: Pt,
      editValues: a,
      onEditChange: p,
      onSave: y ? c : void 0,
      isSaving: d,
      themeColors: u,
      themeFonts: s,
      children: z
    }
  );
}, _n = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const o = document.createElement("link");
  o.rel = "stylesheet", o.href = e, document.head.appendChild(o);
}, It = {
  // Text content
  titleContent: "CONCIERGE",
  titleFontSize: 14,
  titleFontWeight: "bold",
  titleFontFamily: "inherit",
  titleColor: P("textPrimary"),
  titleLetterSpacing: 2,
  titleTextTransform: "uppercase",
  titleTextAlign: "center",
  titleLineHeight: 1,
  // Button colors - default to textPrimary theme color
  closeButtonColor: P("textPrimary"),
  maximizeButtonColor: P("textPrimary"),
  historyButtonColor: P("textPrimary")
}, Mt = [
  // Text content
  { key: "titleContent", label: "Title Text", type: "text" },
  {
    key: "titleFontSize",
    label: "Title Font Size (px)",
    type: "number",
    min: 10,
    max: 24,
    step: 1
  },
  {
    key: "titleFontWeight",
    label: "Title Font Weight",
    type: "options",
    options: [
      { label: "Normal", value: "normal" },
      { label: "Medium", value: "medium" },
      { label: "Semibold", value: "semibold" },
      { label: "Bold", value: "bold" }
    ]
  },
  {
    key: "titleFontFamily",
    label: "Title Font Family",
    type: "font"
  },
  { key: "titleColor", label: "Title Color", type: "color" },
  {
    key: "titleLetterSpacing",
    label: "Title Letter Spacing (px)",
    type: "number",
    min: -2,
    max: 5,
    step: 0.5
  },
  {
    key: "titleTextTransform",
    label: "Title Text Transform",
    type: "options",
    options: [
      { label: "None", value: "none" },
      { label: "Uppercase", value: "uppercase" },
      { label: "Lowercase", value: "lowercase" },
      { label: "Capitalize", value: "capitalize" }
    ]
  },
  {
    key: "titleTextAlign",
    label: "Title Text Alignment",
    type: "options",
    options: [
      { label: "Left", value: "left" },
      { label: "Center", value: "center" },
      { label: "Right", value: "right" }
    ]
  },
  {
    key: "titleLineHeight",
    label: "Title Line Height",
    type: "number",
    min: 0.8,
    max: 2,
    step: 0.1
  },
  // Button colors
  { key: "closeButtonColor", label: "Close Button Color", type: "color" },
  { key: "maximizeButtonColor", label: "Maximize Button Color", type: "color" },
  { key: "historyButtonColor", label: "History Button Color", type: "color" }
], ea = (e) => ({
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700
})[e] || 400, Ti = ({
  showMaximize: e = !0,
  isMaximized: t = !1,
  onMaximize: o,
  onMinimize: n,
  onClose: a,
  onHistoryClick: l,
  title: d = "CONCIERGE",
  widgetId: p = "concierge-widget-header",
  displayName: c = "Concierge Header",
  initialState: u = {}
}) => {
  const {
    state: s,
    isLoading: g,
    isSaving: y,
    handleEditChange: k,
    handleSave: f,
    themeColors: b,
    themeFonts: h,
    resolveColor: w,
    canSave: B
  } = q(
    p,
    {
      ...It,
      titleContent: (d == null ? void 0 : d.toUpperCase()) || It.titleContent,
      ...u
    },
    Mt
  ), T = s.titleFontFamily, S = T && T !== "inherit" ? h[T] : null, z = S && S.format === "google" ? S.url : null;
  if ($(() => {
    z && _n(z);
  }, [z]), g)
    return /* @__PURE__ */ r(
      "div",
      {
        className: "tw:flex tw:items-center tw:justify-between tw:p-4 tw:border-b tw:border-gray-200 tw:bg-white",
        "data-concierge-header": !0
      }
    );
  const O = S ? S.format === "system" ? S.url : `"${S.name}", sans-serif` : "inherit", R = S && S.format !== "system" && S.format !== "google", x = `concierge-header-${p || "default"}`, L = (I) => {
    if (I.startsWith("#")) {
      const D = I.slice(1), C = D.length === 3 ? parseInt(D[0] + D[0], 16) : parseInt(D.slice(0, 2), 16), E = D.length === 3 ? parseInt(D[1] + D[1], 16) : parseInt(D.slice(2, 4), 16), F = D.length === 3 ? parseInt(D[2] + D[2], 16) : parseInt(D.slice(4, 6), 16);
      return `rgba(${C}, ${E}, ${F}, 0.7)`;
    }
    return I.startsWith("rgba") ? I.replace(/,\s*[\d.]+\)$/, ", 0.7)") : I.startsWith("rgb") ? I.replace("rgb", "rgba").replace(")", ", 0.7)") : I;
  }, Y = /* @__PURE__ */ m(G, { children: [
    /* @__PURE__ */ r("style", { children: `
        ${R ? `
          @font-face {
            font-family: "${S.name}";
            src: url("${S.url}") format("${S.format}");
            font-display: swap;
          }
        ` : ""}
        ${O !== "inherit" ? `.${x} [data-title-text] { font-family: ${O} !important; }` : ""}
        .${x} .concierge-maximize-icon {
          color: ${w(s.maximizeButtonColor)};
          transition: color 0.2s ease;
        }
        .${x} .concierge-maximize-icon:hover {
          color: ${L(w(s.maximizeButtonColor))};
        }
        .${x} .concierge-close-icon {
          color: ${w(s.closeButtonColor)};
          transition: color 0.2s ease;
        }
        .${x} .concierge-close-icon:hover {
          color: ${L(w(s.closeButtonColor))};
        }
        .${x} .concierge-history-icon {
          color: ${w(s.historyButtonColor)};
          transition: color 0.2s ease;
        }
        .${x} .concierge-history-icon:hover {
          color: ${L(w(s.historyButtonColor))};
        }
      ` }),
    /* @__PURE__ */ m(
      "div",
      {
        className: `tw:flex tw:items-center tw:justify-between tw:p-4 tw:border-b tw:border-gray-200 tw:bg-white ${x}`,
        "data-concierge-header": !0,
        children: [
          /* @__PURE__ */ m(
            "div",
            {
              className: "tw:flex tw:items-center tw:gap-1",
              style: { minWidth: "80px" },
              children: [
                t && n && /* @__PURE__ */ r(
                  "button",
                  {
                    onClick: n,
                    className: "tw:p-2 tw:rounded-lg tw:transition-colors tw:cursor-pointer tw:border-none tw:bg-transparent tw:group",
                    "aria-label": "Minimize to widget",
                    children: /* @__PURE__ */ r(ur, { className: "tw:w-5 tw:h-5 concierge-maximize-icon" })
                  }
                ),
                !t && e && o && /* @__PURE__ */ r(
                  "button",
                  {
                    onClick: o,
                    className: "tw:p-2 tw:rounded-lg tw:transition-colors tw:cursor-pointer tw:border-none tw:bg-transparent tw:group",
                    "aria-label": "Expand to full view",
                    children: /* @__PURE__ */ r(mr, { className: "tw:w-5 tw:h-5 concierge-maximize-icon" })
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ r(
            "span",
            {
              "data-title-text": !0,
              style: {
                fontSize: `${s.titleFontSize}px`,
                fontWeight: ea(s.titleFontWeight),
                fontFamily: O !== "inherit" ? O : void 0,
                color: w(s.titleColor),
                letterSpacing: `${s.titleLetterSpacing}px`,
                textTransform: s.titleTextTransform,
                textAlign: "center",
                lineHeight: s.titleLineHeight,
                flex: 1
              },
              children: s.titleContent
            }
          ),
          /* @__PURE__ */ m(
            "div",
            {
              className: "tw:flex tw:items-center tw:gap-1 tw:justify-end",
              style: { minWidth: "80px" },
              children: [
                l && /* @__PURE__ */ r(
                  "button",
                  {
                    onClick: l,
                    className: "tw:p-2 tw:rounded-lg tw:transition-colors tw:cursor-pointer tw:border-none tw:bg-transparent tw:group",
                    "aria-label": "View chat history",
                    children: /* @__PURE__ */ r(lr, { className: "tw:w-5 tw:h-5 concierge-history-icon" })
                  }
                ),
                /* @__PURE__ */ r(
                  "button",
                  {
                    onClick: a,
                    className: "tw:p-2 tw:rounded-lg tw:transition-colors tw:cursor-pointer tw:border-none tw:bg-transparent tw:group",
                    "aria-label": "Close",
                    children: /* @__PURE__ */ r(ue, { className: "tw:w-5 tw:h-5 concierge-close-icon" })
                  }
                )
              ]
            }
          )
        ]
      }
    )
  ] });
  return /* @__PURE__ */ r(
    K,
    {
      widgetId: p,
      displayName: c,
      editFields: Mt,
      editValues: s,
      onEditChange: k,
      onSave: B ? f : void 0,
      isSaving: y,
      themeColors: b,
      themeFonts: h,
      children: Y
    }
  );
}, ta = {
  // Position
  position: "bottom-right",
  horizontalOffset: 20,
  verticalOffset: 20,
  // Size
  size: 44,
  // Colors (using theme colors)
  backgroundColor: P("primary"),
  backgroundColorHover: P("primary"),
  iconColor: P("secondary"),
  // Shape
  borderRadius: 50,
  // percentage - 50 = circle
  // Shadow
  shadowColor: P("primary"),
  shadowOpacity: 0.25,
  shadowBlur: 50,
  shadowSpread: -12,
  shadowOffsetY: 25,
  // Icon
  iconSize: 22,
  // Animation
  hoverScale: 1.1,
  animationDuration: 200,
  // Suggested Messages
  showSuggestedMessages: !0,
  suggestedMessages: void 0,
  suggestedMessageRotationMs: 4e3,
  // Suggested Pills Styling
  pillBackgroundColor: "#ffffff",
  pillTextColor: "#1f2937",
  pillBorderRadius: 12,
  pillFontSize: 14,
  pillPaddingX: 16,
  pillPaddingY: 10,
  pillShadowOpacity: 0.12,
  pillsToShow: 2,
  // Header Styling
  pillHeaderText: void 0,
  pillHeaderColor: "#6b7280",
  pillHeaderFontSize: 11
}, At = [
  // Position
  {
    key: "position",
    label: "Position",
    type: "options",
    options: [
      { label: "Bottom Right", value: "bottom-right" },
      { label: "Bottom Left", value: "bottom-left" },
      { label: "Top Right", value: "top-right" },
      { label: "Top Left", value: "top-left" }
    ]
  },
  {
    key: "horizontalOffset",
    label: "Horizontal Offset (px)",
    type: "number",
    min: 8,
    max: 100,
    step: 4
  },
  {
    key: "verticalOffset",
    label: "Vertical Offset (px)",
    type: "number",
    min: 8,
    max: 100,
    step: 4
  },
  // Size
  {
    key: "size",
    label: "Button Size",
    type: "number",
    min: 32,
    max: 72,
    step: 4
  },
  // Colors
  { key: "backgroundColor", label: "Background Color", type: "color" },
  { key: "backgroundColorHover", label: "Hover Background", type: "color" },
  { key: "iconColor", label: "Icon Color", type: "color" },
  // Shape
  {
    key: "borderRadius",
    label: "Border Radius (%)",
    type: "number",
    min: 0,
    max: 50,
    step: 5
  },
  // Shadow
  { key: "shadowColor", label: "Shadow Color", type: "color" },
  {
    key: "shadowOpacity",
    label: "Shadow Opacity",
    type: "number",
    min: 0,
    max: 1,
    step: 0.05
  },
  {
    key: "shadowBlur",
    label: "Shadow Blur",
    type: "number",
    min: 0,
    max: 100,
    step: 5
  },
  {
    key: "shadowSpread",
    label: "Shadow Spread",
    type: "number",
    min: -20,
    max: 20,
    step: 2
  },
  {
    key: "shadowOffsetY",
    label: "Shadow Offset Y",
    type: "number",
    min: 0,
    max: 50,
    step: 5
  },
  // Icon
  {
    key: "iconSize",
    label: "Icon Size",
    type: "number",
    min: 16,
    max: 40,
    step: 2
  },
  // Animation
  {
    key: "hoverScale",
    label: "Hover Scale",
    type: "number",
    min: 1,
    max: 1.3,
    step: 0.05
  },
  {
    key: "animationDuration",
    label: "Animation Duration (ms)",
    type: "number",
    min: 100,
    max: 500,
    step: 50
  },
  // Suggested Messages
  {
    key: "showSuggestedMessages",
    label: "Show Suggested Messages",
    type: "toggle"
  },
  {
    key: "suggestedMessageRotationMs",
    label: "Message Rotation (ms)",
    type: "number",
    min: 2e3,
    max: 1e4,
    step: 500
  },
  {
    key: "pillsToShow",
    label: "Number of Pills",
    type: "number",
    min: 1,
    max: 4,
    step: 1
  },
  // Pill Styling
  { key: "pillBackgroundColor", label: "Pill Background", type: "color" },
  { key: "pillTextColor", label: "Pill Text Color", type: "color" },
  {
    key: "pillBorderRadius",
    label: "Pill Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  },
  {
    key: "pillFontSize",
    label: "Pill Font Size",
    type: "number",
    min: 10,
    max: 18,
    step: 1
  },
  {
    key: "pillPaddingX",
    label: "Pill Padding X",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  {
    key: "pillPaddingY",
    label: "Pill Padding Y",
    type: "number",
    min: 6,
    max: 20,
    step: 2
  },
  {
    key: "pillShadowOpacity",
    label: "Pill Shadow Opacity",
    type: "number",
    min: 0,
    max: 0.5,
    step: 0.02
  },
  // Header Styling
  {
    key: "pillHeaderText",
    label: "Header Text (Override)",
    type: "text"
  },
  { key: "pillHeaderColor", label: "Header Text Color", type: "color" },
  {
    key: "pillHeaderFontSize",
    label: "Header Font Size",
    type: "number",
    min: 9,
    max: 14,
    step: 1
  }
], oa = (e) => {
  const { position: t, horizontalOffset: o, verticalOffset: n, size: a } = e, l = {
    position: "fixed",
    zIndex: 2147483647
    // Max z-index to ensure it's on top
  };
  return t.startsWith("bottom") ? l.bottom = n + a - 8 : l.top = n - 8, t.endsWith("left") ? l.left = o + a - 8 : l.right = o - 8, l;
}, Ei = ({
  initialState: e = {},
  widgetId: t,
  displayName: o,
  children: n
}) => {
  const [a, l] = N(!1), [d, p] = N({ x: 0, y: 0 }), [c, u] = N(null), [s, g] = N(!1), [y, k] = N(!1), f = te(null), b = So(), {
    state: h,
    isLoading: w,
    isSaving: B,
    handleEditChange: T,
    handleSave: S,
    themeColors: z,
    resolveColor: O,
    canSave: R
  } = q(
    t,
    { ...ta, ...e },
    At
  ), x = de(() => c ? JSON.stringify(h) !== JSON.stringify(c) : !1, [h, c]);
  if ($(() => t ? zo((X) => {
    X !== t && a && (x() ? g(!0) : l(!1));
  }) : void 0, [t, a, x]), w)
    return /* @__PURE__ */ r(G, {});
  const L = n(h, O);
  if (!b)
    return /* @__PURE__ */ r(G, { children: L });
  const Y = () => {
    if (f.current) {
      const F = f.current.getBoundingClientRect(), X = window.innerWidth, H = window.innerHeight, j = 620, A = 450, Q = 10, W = H - F.bottom, J = F.top, re = X - F.left, ne = F.right;
      let _;
      W >= A + Q ? _ = F.bottom + Q : J >= A + Q ? _ = F.top - A - Q : W >= J ? _ = Math.max(Q, H - A - Q) : _ = Math.max(Q, F.top - A - Q);
      let Z;
      re >= j ? Z = F.left : ne >= j ? Z = F.right - j : Z = Math.max(
        Q,
        Math.min(X - j - Q, F.left)
      ), Z = Math.max(Q, Math.min(Z, X - j - Q)), _ = Math.max(Q, Math.min(_, H - A - Q)), p({ x: Z, y: _ });
    }
    u({ ...h }), l(!0), t && Bo(t);
  }, I = () => {
    c && Object.keys(c).forEach((F) => {
      T(F, c[F]);
    });
  }, D = () => {
    S && R && S(), u({ ...h });
  }, C = () => {
    g(!1), l(!1);
  }, E = () => {
    D(), g(!1), l(!1);
  };
  return /* @__PURE__ */ m(G, { children: [
    /* @__PURE__ */ r("style", { children: `
        .floating-button-edit-icon {
          width: 32px;
          height: 32px;
          background: ${i.white};
          border: 1px solid ${i.gray_border};
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
          transition: all 0.2s;
          padding: 0;
          opacity: 0;
          pointer-events: none;
        }

        .floating-button-edit-icon.visible {
          opacity: 1;
          pointer-events: auto;
        }

        .floating-button-edit-icon:hover {
          background: ${i.blue_light};
          border-color: ${i.blue};
        }
      ` }),
    /* @__PURE__ */ m(
      "div",
      {
        onMouseEnter: () => k(!0),
        onMouseLeave: () => k(!1),
        style: { display: "contents" },
        children: [
          L,
          /* @__PURE__ */ r(
            "button",
            {
              ref: f,
              className: `floating-button-edit-icon ${y || a ? "visible" : ""}`,
              style: oa(h),
              onMouseDown: (F) => {
                F.stopPropagation();
              },
              onClick: (F) => {
                F.stopPropagation(), F.preventDefault(), Y();
              },
              "aria-label": "Edit widget",
              children: /* @__PURE__ */ r(uo, { size: 16, color: i.gray_dark })
            }
          )
        ]
      }
    ),
    a && /* @__PURE__ */ r(
      wo,
      {
        widgetId: t,
        displayName: o,
        fields: At,
        values: h,
        initialValues: c || void 0,
        onChange: T,
        onClose: () => l(!1),
        onReset: I,
        screenPosition: d,
        onSave: D,
        isSaving: B,
        themeColors: z
      }
    ),
    s && /* @__PURE__ */ r(
      ke,
      {
        title: "Unsaved Changes",
        message: "You have unsaved changes. Would you like to save them before closing?",
        confirmLabel: "Save",
        cancelLabel: "Discard",
        onConfirm: E,
        onCancel: C,
        isLoading: B
      }
    )
  ] });
}, ra = {
  // Icon container
  iconContainerSize: 80,
  iconContainerBgColor: M("#f6f8fa"),
  iconContainerBorderRadius: 50,
  // Icon
  iconSize: 40,
  iconColor: P("textPrimary"),
  // Title
  titleFontSize: 28,
  titleFontWeight: "semibold",
  titleColor: P("textPrimary"),
  titleMarginBottom: 12,
  // Description
  descriptionFontSize: 16,
  descriptionColor: P("textPrimary"),
  descriptionMaxWidth: 500,
  descriptionLineHeight: 1.5,
  descriptionMarginBottom: 32,
  // Suggestions section title
  suggestionsTitleFontSize: 16,
  suggestionsTitleFontWeight: "medium",
  suggestionsTitleColor: P("textPrimary"),
  suggestionsTitleMarginBottom: 16,
  // Suggestion pills
  suggestionPillPaddingX: 16,
  suggestionPillPaddingY: 10,
  suggestionPillBorderRadius: 20,
  suggestionPillBorderColor: M("#e5e7eb"),
  suggestionPillBgColor: M("transparent"),
  suggestionPillBgColorHover: M("#f3f4f6"),
  suggestionPillTextColor: P("textPrimary"),
  suggestionPillFontSize: 14,
  suggestionPillGap: 8,
  // Container
  containerPadding: 20
}, Nt = [
  // Icon container
  {
    key: "iconContainerSize",
    label: "Icon Container Size",
    type: "number",
    min: 40,
    max: 120,
    step: 8
  },
  {
    key: "iconContainerBgColor",
    label: "Icon Container Background",
    type: "color"
  },
  {
    key: "iconContainerBorderRadius",
    label: "Icon Container Radius (%)",
    type: "number",
    min: 0,
    max: 50,
    step: 5
  },
  // Icon
  {
    key: "iconSize",
    label: "Icon Size",
    type: "number",
    min: 20,
    max: 80,
    step: 4
  },
  { key: "iconColor", label: "Icon Color", type: "color" },
  // Title
  {
    key: "titleFontSize",
    label: "Title Font Size",
    type: "number",
    min: 20,
    max: 40,
    step: 2
  },
  {
    key: "titleFontWeight",
    label: "Title Font Weight",
    type: "options",
    options: [...V]
  },
  { key: "titleColor", label: "Title Color", type: "color" },
  {
    key: "titleMarginBottom",
    label: "Title Margin Bottom",
    type: "number",
    min: 0,
    max: 32,
    step: 4
  },
  // Description
  {
    key: "descriptionFontSize",
    label: "Description Font Size",
    type: "number",
    min: 12,
    max: 24,
    step: 1
  },
  { key: "descriptionColor", label: "Description Color", type: "color" },
  {
    key: "descriptionMaxWidth",
    label: "Description Max Width",
    type: "number",
    min: 300,
    max: 700,
    step: 50
  },
  {
    key: "descriptionLineHeight",
    label: "Description Line Height",
    type: "number",
    min: 1,
    max: 2,
    step: 0.1
  },
  {
    key: "descriptionMarginBottom",
    label: "Description Margin Bottom",
    type: "number",
    min: 16,
    max: 64,
    step: 4
  },
  // Suggestions section title
  {
    key: "suggestionsTitleFontSize",
    label: "Suggestions Title Size",
    type: "number",
    min: 12,
    max: 24,
    step: 1
  },
  {
    key: "suggestionsTitleFontWeight",
    label: "Suggestions Title Weight",
    type: "options",
    options: [...V]
  },
  {
    key: "suggestionsTitleColor",
    label: "Suggestions Title Color",
    type: "color"
  },
  {
    key: "suggestionsTitleMarginBottom",
    label: "Suggestions Title Margin",
    type: "number",
    min: 8,
    max: 32,
    step: 4
  },
  // Suggestion pills
  {
    key: "suggestionPillPaddingX",
    label: "Pill Padding X",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  {
    key: "suggestionPillPaddingY",
    label: "Pill Padding Y",
    type: "number",
    min: 6,
    max: 16,
    step: 2
  },
  {
    key: "suggestionPillBorderRadius",
    label: "Pill Border Radius",
    type: "number",
    min: 0,
    max: 30,
    step: 2
  },
  {
    key: "suggestionPillBorderColor",
    label: "Pill Border Color",
    type: "color"
  },
  { key: "suggestionPillBgColor", label: "Pill Background", type: "color" },
  {
    key: "suggestionPillBgColorHover",
    label: "Pill Background (Hover)",
    type: "color"
  },
  { key: "suggestionPillTextColor", label: "Pill Text Color", type: "color" },
  {
    key: "suggestionPillFontSize",
    label: "Pill Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1
  },
  {
    key: "suggestionPillGap",
    label: "Pill Gap",
    type: "number",
    min: 4,
    max: 16,
    step: 2
  },
  // Container
  {
    key: "containerPadding",
    label: "Container Padding",
    type: "number",
    min: 0,
    max: 40,
    step: 4
  }
], Pi = ({
  initialState: e = {},
  widgetId: t,
  displayName: o,
  children: n
}) => {
  const {
    state: a,
    isLoading: l,
    isSaving: d,
    handleEditChange: p,
    handleSave: c,
    themeColors: u,
    resolveColor: s,
    canSave: g
  } = q(
    t,
    { ...ra, ...e },
    Nt
  );
  if (l)
    return /* @__PURE__ */ r(G, {});
  const y = n(a, s);
  return /* @__PURE__ */ r(
    K,
    {
      widgetId: t,
      displayName: o,
      editFields: Nt,
      editValues: a,
      onEditChange: p,
      onSave: g ? c : void 0,
      isSaving: d,
      themeColors: u,
      children: y
    }
  );
}, na = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const o = document.createElement("link");
  o.rel = "stylesheet", o.href = e, document.head.appendChild(o);
}, aa = {
  // Carousel gap
  carouselGap: 16,
  // Card container
  cardBorderRadius: 10,
  // "Explore now" pill
  pillBgColor: M("rgba(255, 255, 255, 0.6)"),
  pillBorderColor: M("#ffffff"),
  pillTextColor: M("#031425"),
  pillPaddingX: 12,
  pillPaddingY: 6,
  pillBorderRadius: 50,
  // Arrow button
  arrowBgColor: M("rgba(255, 255, 255, 0.6)"),
  arrowBorderColor: M("#ffffff"),
  arrowIconColor: M("#031425"),
  // Title
  titleColor: M("#031425"),
  titleFontWeight: "semibold",
  titleFontFamily: "inherit"
}, Ht = [
  // Carousel gap
  {
    key: "carouselGap",
    label: "Gap Between Cards",
    type: "number",
    min: 8,
    max: 32,
    step: 4
  },
  // Card container
  {
    key: "cardBorderRadius",
    label: "Card Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  },
  // "Explore now" pill
  { key: "pillBgColor", label: "Pill Background", type: "color" },
  { key: "pillBorderColor", label: "Pill Border Color", type: "color" },
  { key: "pillTextColor", label: "Pill Text Color", type: "color" },
  {
    key: "pillPaddingX",
    label: "Pill Padding X",
    type: "number",
    min: 8,
    max: 20,
    step: 2
  },
  {
    key: "pillPaddingY",
    label: "Pill Padding Y",
    type: "number",
    min: 4,
    max: 12,
    step: 2
  },
  {
    key: "pillBorderRadius",
    label: "Pill Border Radius",
    type: "number",
    min: 4,
    max: 50,
    step: 2
  },
  // Arrow button
  { key: "arrowBgColor", label: "Arrow Background", type: "color" },
  { key: "arrowBorderColor", label: "Arrow Border Color", type: "color" },
  { key: "arrowIconColor", label: "Arrow Icon Color", type: "color" },
  // Title
  { key: "titleColor", label: "Title Color", type: "color" },
  {
    key: "titleFontWeight",
    label: "Title Font Weight",
    type: "options",
    options: [...V]
  },
  {
    key: "titleFontFamily",
    label: "Title Font Family",
    type: "font"
  }
], Ii = ({
  initialState: e = {},
  widgetId: t,
  displayName: o,
  children: n
}) => {
  const {
    state: a,
    isLoading: l,
    isSaving: d,
    handleEditChange: p,
    handleSave: c,
    themeColors: u,
    themeFonts: s,
    resolveColor: g,
    canSave: y,
    getEditValues: k
  } = q(
    t,
    { ...aa, ...e },
    Ht
  ), f = a.titleFontFamily, b = f && f !== "inherit" ? s[f] : null, h = b && b.format === "google" ? b.url : null;
  if ($(() => {
    h && na(h);
  }, [h]), l)
    return /* @__PURE__ */ r(G, {});
  const w = b ? b.format === "system" ? b.url : `"${b.name}", sans-serif` : "inherit", B = b && b.format !== "system" && b.format !== "google", T = `trending-card-${t || "default"}`, S = `
    ${B ? `
      @font-face {
        font-family: "${b.name}";
        src: url("${b.url}") format("${b.format}");
        font-display: swap;
      }
    ` : ""}
    ${w !== "inherit" ? `.${T} [data-title-text] { font-family: ${w} !important; }` : ""}
  `.trim(), z = {
    ...a,
    titleFontFamilyCss: w
  }, O = /* @__PURE__ */ m(G, { children: [
    S && /* @__PURE__ */ r("style", { children: S }),
    n(z, g)
  ] });
  return /* @__PURE__ */ r(
    K,
    {
      widgetId: t,
      displayName: o,
      editFields: Ht,
      editValues: k(),
      onEditChange: p,
      onSave: y ? c : void 0,
      isSaving: d,
      themeColors: u,
      themeFonts: s,
      children: O
    }
  );
}, ia = {
  // Container
  backgroundColor: P("secondary"),
  borderColor: P("primary"),
  borderWidth: 1,
  borderRadius: 9999,
  // pill shape
  paddingX: 12,
  paddingY: 8,
  // Text
  textColor: P("textPrimary"),
  textColorLoading: M("rgba(0, 0, 0, 0.4)"),
  fontSize: 14,
  fontWeight: "medium",
  fontFamily: "inherit",
  // Product images
  imageSize: 24,
  imageBorderColor: M("#e5e7eb"),
  imageOverlap: 12,
  imageBorderRadius: 9999,
  // circle
  // Counter (+N)
  counterTextColor: M("rgba(0, 0, 0, 0.5)"),
  counterFontSize: 14,
  // Placeholder (loading state)
  placeholderBgColor: M("#f3f4f6")
}, Ot = [
  // Container
  { key: "backgroundColor", label: "Background Color", type: "color" },
  { key: "borderColor", label: "Border Color", type: "color" },
  {
    key: "borderWidth",
    label: "Border Width",
    type: "number",
    min: 0,
    max: 3,
    step: 1
  },
  {
    key: "borderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 9999,
    step: 4
  },
  {
    key: "paddingX",
    label: "Horizontal Padding",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  {
    key: "paddingY",
    label: "Vertical Padding",
    type: "number",
    min: 4,
    max: 16,
    step: 2
  },
  // Text
  { key: "textColor", label: "Text Color", type: "color" },
  { key: "textColorLoading", label: "Text Color (Loading)", type: "color" },
  {
    key: "fontSize",
    label: "Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1
  },
  {
    key: "fontWeight",
    label: "Font Weight",
    type: "options",
    options: V
  },
  {
    key: "fontFamily",
    label: "Font Family",
    type: "font"
  },
  // Product images
  {
    key: "imageSize",
    label: "Image Size",
    type: "number",
    min: 16,
    max: 40,
    step: 2
  },
  { key: "imageBorderColor", label: "Image Border Color", type: "color" },
  {
    key: "imageOverlap",
    label: "Image Overlap",
    type: "number",
    min: 0,
    max: 20,
    step: 2
  },
  {
    key: "imageBorderRadius",
    label: "Image Border Radius",
    type: "number",
    min: 0,
    max: 9999,
    step: 2
  },
  // Counter
  { key: "counterTextColor", label: "Counter Text Color", type: "color" },
  {
    key: "counterFontSize",
    label: "Counter Font Size",
    type: "number",
    min: 10,
    max: 16,
    step: 1
  },
  // Placeholder
  { key: "placeholderBgColor", label: "Placeholder Background", type: "color" }
], Mi = ({
  initialState: e = {},
  widgetId: t,
  displayName: o,
  children: n
}) => {
  const {
    state: a,
    isLoading: l,
    isSaving: d,
    handleEditChange: p,
    handleSave: c,
    themeColors: u,
    themeFonts: s,
    themeIcons: g,
    resolveColor: y,
    canSave: k
  } = q(
    t,
    { ...ia, ...e },
    Ot
  );
  if (l)
    return /* @__PURE__ */ r(G, {});
  const f = n(a, y);
  return /* @__PURE__ */ r(
    K,
    {
      widgetId: t,
      displayName: o,
      editFields: Ot,
      editValues: a,
      onEditChange: p,
      onSave: k ? c : void 0,
      isSaving: d,
      themeColors: u,
      themeFonts: s,
      themeIcons: g,
      children: f
    }
  );
}, la = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const o = document.createElement("link");
  o.rel = "stylesheet", o.href = e, document.head.appendChild(o);
}, sa = {
  // Container
  containerGap: 8,
  // Suggestion pills
  pillPaddingX: 16,
  pillPaddingY: 12,
  pillBorderRadius: 8,
  pillBorderColor: M("#e5e7eb"),
  pillBorderWidth: 1,
  pillBgColor: M("transparent"),
  pillBgColorHover: M("#f3f4f6"),
  pillTextColor: P("textPrimary"),
  pillFontSize: 14,
  pillFontWeight: "medium",
  pillFontFamily: "inherit"
}, Rt = [
  // Container
  {
    key: "containerGap",
    label: "Gap Between Pills",
    type: "number",
    min: 4,
    max: 16,
    step: 2
  },
  // Pill styling
  {
    key: "pillPaddingX",
    label: "Pill Padding X",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  {
    key: "pillPaddingY",
    label: "Pill Padding Y",
    type: "number",
    min: 6,
    max: 20,
    step: 2
  },
  {
    key: "pillBorderRadius",
    label: "Pill Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  },
  {
    key: "pillBorderWidth",
    label: "Pill Border Width",
    type: "number",
    min: 0,
    max: 3,
    step: 1
  },
  { key: "pillBorderColor", label: "Pill Border Color", type: "color" },
  { key: "pillBgColor", label: "Pill Background", type: "color" },
  { key: "pillBgColorHover", label: "Pill Hover Background", type: "color" },
  { key: "pillTextColor", label: "Pill Text Color", type: "color" },
  {
    key: "pillFontSize",
    label: "Pill Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1
  },
  {
    key: "pillFontWeight",
    label: "Pill Font Weight",
    type: "options",
    options: [...V]
  },
  { key: "pillFontFamily", label: "Pill Font Family", type: "font" }
], Ai = ({
  initialState: e = {},
  widgetId: t,
  displayName: o,
  children: n
}) => {
  const {
    state: a,
    isLoading: l,
    isSaving: d,
    handleEditChange: p,
    handleSave: c,
    themeColors: u,
    themeFonts: s,
    resolveColor: g,
    canSave: y
  } = q(
    t,
    { ...sa, ...e },
    Rt
  ), k = a.pillFontFamily, f = k && k !== "inherit" ? s[k] : null, b = f && f.format === "google" ? f.url : null;
  if ($(() => {
    b && la(b);
  }, [b]), l)
    return /* @__PURE__ */ r(G, {});
  const h = f ? f.format === "system" ? f.url : `"${f.name}", sans-serif` : "inherit", w = f && f.format !== "system" && f.format !== "google", B = `suggestion-list-${t || "default"}`, T = `
    ${w ? `
      @font-face {
        font-family: "${f.name}";
        src: url("${f.url}") format("${f.format}");
        font-display: swap;
      }
    ` : ""}
    ${h !== "inherit" ? `.${B} { font-family: ${h} !important; }` : ""}
  `.trim(), S = {
    ...a,
    pillFontFamilyCss: h
  }, z = /* @__PURE__ */ m(G, { children: [
    T && /* @__PURE__ */ r("style", { children: T }),
    /* @__PURE__ */ r("div", { className: B, children: n(S, g) })
  ] });
  return /* @__PURE__ */ r(
    K,
    {
      widgetId: t,
      displayName: o,
      editFields: Rt,
      editValues: a,
      onEditChange: p,
      onSave: y ? c : void 0,
      isSaving: d,
      themeColors: u,
      themeFonts: s,
      children: z
    }
  );
}, Wt = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const o = document.createElement("link");
  o.rel = "stylesheet", o.href = e, document.head.appendChild(o);
}, ca = {
  // Card/Pill container
  borderColor: M("#DCDCDC"),
  borderColorSelected: P("primary"),
  backgroundColor: P("secondary"),
  backgroundColorHover: M("#F6F8FA"),
  borderRadius: 8,
  // Rectangle card dimensions
  cardWidth: 88,
  cardGap: 12,
  cardImageSize: 72,
  // Compact pill dimensions
  pillImageSize: 32,
  pillGap: 8,
  pillPaddingY: 6,
  pillPaddingX: 12,
  // Checkmark badge
  checkmarkBgColor: P("primary"),
  checkmarkIconColor: P("secondary"),
  checkmarkSize: 16,
  // Price text
  priceColor: P("textPrimary"),
  priceFontSize: 16,
  priceFontWeightNormal: "medium",
  priceFontWeightSelected: "semibold",
  priceFontFamily: "inherit",
  // Variant name text
  nameColor: P("textPrimary"),
  nameFontSize: 14,
  nameFontSizeCompact: 14,
  nameFontWeightNormal: "medium",
  nameFontWeightSelected: "semibold",
  nameFontFamily: "inherit",
  // Divider
  dividerColor: M("#DCDCDC"),
  dividerColorSelected: P("primary")
}, Dt = [
  // Card/Pill container
  { key: "borderColor", label: "Border Color", type: "color" },
  {
    key: "borderColorSelected",
    label: "Border Color (Selected)",
    type: "color"
  },
  { key: "backgroundColor", label: "Background Color", type: "color" },
  {
    key: "backgroundColorHover",
    label: "Background Color (Hover)",
    type: "color"
  },
  {
    key: "borderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 16,
    step: 2
  },
  // Rectangle card dimensions
  {
    key: "cardWidth",
    label: "Card Width",
    type: "number",
    min: 60,
    max: 120,
    step: 4
  },
  {
    key: "cardGap",
    label: "Card Gap",
    type: "number",
    min: 4,
    max: 24,
    step: 2
  },
  {
    key: "cardImageSize",
    label: "Card Image Size",
    type: "number",
    min: 48,
    max: 96,
    step: 4
  },
  // Compact pill dimensions
  {
    key: "pillImageSize",
    label: "Pill Image Size",
    type: "number",
    min: 24,
    max: 48,
    step: 4
  },
  {
    key: "pillGap",
    label: "Pill Gap",
    type: "number",
    min: 4,
    max: 16,
    step: 2
  },
  {
    key: "pillPaddingY",
    label: "Pill Padding Y",
    type: "number",
    min: 4,
    max: 16,
    step: 2
  },
  {
    key: "pillPaddingX",
    label: "Pill Padding X",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  // Checkmark badge
  { key: "checkmarkBgColor", label: "Checkmark Background", type: "color" },
  { key: "checkmarkIconColor", label: "Checkmark Icon Color", type: "color" },
  {
    key: "checkmarkSize",
    label: "Checkmark Size",
    type: "number",
    min: 12,
    max: 24,
    step: 2
  },
  // Price text
  { key: "priceColor", label: "Price Color", type: "color" },
  {
    key: "priceFontSize",
    label: "Price Font Size",
    type: "number",
    min: 12,
    max: 20,
    step: 1
  },
  {
    key: "priceFontWeightNormal",
    label: "Price Font Weight",
    type: "options",
    options: [...V]
  },
  {
    key: "priceFontWeightSelected",
    label: "Price Weight (Selected)",
    type: "options",
    options: [...V]
  },
  {
    key: "priceFontFamily",
    label: "Price Font Family",
    type: "font"
  },
  // Variant name text
  { key: "nameColor", label: "Name Color", type: "color" },
  {
    key: "nameFontSize",
    label: "Name Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1
  },
  {
    key: "nameFontSizeCompact",
    label: "Name Font Size (Compact)",
    type: "number",
    min: 10,
    max: 16,
    step: 1
  },
  {
    key: "nameFontWeightNormal",
    label: "Name Font Weight",
    type: "options",
    options: [...V]
  },
  {
    key: "nameFontWeightSelected",
    label: "Name Weight (Selected)",
    type: "options",
    options: [...V]
  },
  {
    key: "nameFontFamily",
    label: "Name Font Family",
    type: "font"
  },
  // Divider
  { key: "dividerColor", label: "Divider Color", type: "color" },
  {
    key: "dividerColorSelected",
    label: "Divider Color (Selected)",
    type: "color"
  }
], Ni = ({
  initialState: e = {},
  widgetId: t,
  displayName: o,
  children: n
}) => {
  const {
    state: a,
    isLoading: l,
    isSaving: d,
    handleEditChange: p,
    handleSave: c,
    themeColors: u,
    themeFonts: s,
    resolveColor: g,
    canSave: y
  } = q(
    t,
    { ...ca, ...e },
    Dt
  ), k = a.priceFontFamily, f = k && k !== "inherit" ? s[k] : null, b = a.nameFontFamily, h = b && b !== "inherit" ? s[b] : null, w = f && f.format === "google" ? f.url : null, B = h && h.format === "google" ? h.url : null;
  if ($(() => {
    w && Wt(w);
  }, [w]), $(() => {
    B && Wt(B);
  }, [B]), l)
    return /* @__PURE__ */ r(G, {});
  const T = f ? f.format === "system" ? f.url : `"${f.name}", sans-serif` : "inherit", S = h ? h.format === "system" ? h.url : `"${h.name}", sans-serif` : "inherit", z = f && f.format !== "system" && f.format !== "google", O = h && h.format !== "system" && h.format !== "google", R = `variant-picker-${t || "default"}`, x = `
    ${z ? `
      @font-face {
        font-family: "${f.name}";
        src: url("${f.url}") format("${f.format}");
        font-display: swap;
      }
    ` : ""}
    ${O ? `
      @font-face {
        font-family: "${h.name}";
        src: url("${h.url}") format("${h.format}");
        font-display: swap;
      }
    ` : ""}
    ${T !== "inherit" ? `.${R} [data-price-text] { font-family: ${T} !important; }` : ""}
    ${S !== "inherit" ? `.${R} [data-name-text] { font-family: ${S} !important; }` : ""}
  `.trim(), L = {
    ...a,
    priceFontFamilyCss: T,
    nameFontFamilyCss: S
  }, Y = /* @__PURE__ */ m(G, { children: [
    x && /* @__PURE__ */ r("style", { children: x }),
    n(L, g)
  ] });
  return /* @__PURE__ */ r(
    K,
    {
      widgetId: t,
      displayName: o,
      editFields: Dt,
      editValues: a,
      onEditChange: p,
      onSave: y ? c : void 0,
      isSaving: d,
      themeColors: u,
      themeFonts: s,
      children: Y
    }
  );
}, da = {
  // ============================================
  // 1. HEADER SECTION (Search results toggle)
  // ============================================
  headerIconColor: M("rgba(0, 0, 0, 0.5)"),
  headerIconSize: 14,
  headerLabelText: "Search results",
  headerLabelColor: M("rgba(0, 0, 0, 0.5)"),
  headerLabelFontSize: 14,
  headerLabelFontWeight: "medium",
  headerLabelFontFamily: "inherit",
  headerChevronColor: M("rgba(0, 0, 0, 0.5)"),
  headerChevronSize: 16,
  headerGap: 6,
  headerMarginBottom: 16,
  // ============================================
  // 2. CONTAINER & LAYOUT
  // ============================================
  containerMarginBottom: 12,
  pillsGap: 8,
  pillsSectionMarginBottom: 24,
  // ============================================
  // 3. COLLAPSIBLE BEHAVIOR
  // ============================================
  defaultExpanded: !0,
  autoCollapse: !0,
  autoCollapseDelay: 1500,
  // ============================================
  // 4. THINKING INDICATOR
  // ============================================
  thinkingEnabled: !0,
  thinkingText: "Thinking...",
  thinkingTextColor: M("#666666"),
  thinkingTextFontSize: 14,
  thinkingBgColor: P("secondary"),
  thinkingPaddingX: 16,
  thinkingPaddingY: 12,
  thinkingBorderRadius: 18,
  thinkingBorderRadiusBottomLeft: 5,
  shimmerDuration: 1.5,
  shimmerColor: M("#e0e0e0"),
  // ============================================
  // 5. ANIMATION
  // ============================================
  animationsEnabled: !0,
  productAnimationDuration: 800,
  chevronRotationDuration: 200
}, Lt = [
  // ============================================
  // 1. HEADER SECTION
  // ============================================
  { key: "headerIconColor", label: "Header Icon Color", type: "color" },
  {
    key: "headerIconSize",
    label: "Header Icon Size",
    type: "number",
    min: 10,
    max: 24,
    step: 1
  },
  { key: "headerLabelText", label: "Header Label Text", type: "text" },
  { key: "headerLabelColor", label: "Header Label Color", type: "color" },
  {
    key: "headerLabelFontSize",
    label: "Header Label Font Size",
    type: "number",
    min: 10,
    max: 20,
    step: 1
  },
  {
    key: "headerLabelFontWeight",
    label: "Header Label Font Weight",
    type: "options",
    options: V
  },
  {
    key: "headerLabelFontFamily",
    label: "Header Label Font Family",
    type: "font"
  },
  { key: "headerChevronColor", label: "Header Chevron Color", type: "color" },
  {
    key: "headerChevronSize",
    label: "Header Chevron Size",
    type: "number",
    min: 12,
    max: 24,
    step: 1
  },
  {
    key: "headerGap",
    label: "Header Gap",
    type: "number",
    min: 2,
    max: 16,
    step: 1
  },
  {
    key: "headerMarginBottom",
    label: "Header Margin Bottom",
    type: "number",
    min: 8,
    max: 32,
    step: 2
  },
  // ============================================
  // 2. CONTAINER & LAYOUT
  // ============================================
  {
    key: "containerMarginBottom",
    label: "Container Margin Bottom",
    type: "number",
    min: 0,
    max: 32,
    step: 2
  },
  {
    key: "pillsGap",
    label: "Pills Gap",
    type: "number",
    min: 4,
    max: 16,
    step: 2
  },
  {
    key: "pillsSectionMarginBottom",
    label: "Pills Section Margin Bottom",
    type: "number",
    min: 8,
    max: 48,
    step: 4
  },
  // ============================================
  // 3. COLLAPSIBLE BEHAVIOR
  // ============================================
  { key: "defaultExpanded", label: "Default Expanded", type: "toggle" },
  { key: "autoCollapse", label: "Auto Collapse", type: "toggle" },
  {
    key: "autoCollapseDelay",
    label: "Auto Collapse Delay (ms)",
    type: "number",
    min: 500,
    max: 5e3,
    step: 100
  },
  // ============================================
  // 4. THINKING INDICATOR
  // ============================================
  {
    key: "thinkingEnabled",
    label: "Thinking Indicator Enabled",
    type: "toggle"
  },
  { key: "thinkingText", label: "Thinking Text", type: "text" },
  { key: "thinkingTextColor", label: "Thinking Text Color", type: "color" },
  {
    key: "thinkingTextFontSize",
    label: "Thinking Text Font Size",
    type: "number",
    min: 10,
    max: 20,
    step: 1
  },
  { key: "thinkingBgColor", label: "Thinking Background", type: "color" },
  {
    key: "thinkingPaddingX",
    label: "Thinking Padding X",
    type: "number",
    min: 8,
    max: 32,
    step: 2
  },
  {
    key: "thinkingPaddingY",
    label: "Thinking Padding Y",
    type: "number",
    min: 6,
    max: 24,
    step: 2
  },
  {
    key: "thinkingBorderRadius",
    label: "Thinking Border Radius",
    type: "number",
    min: 0,
    max: 32,
    step: 2
  },
  {
    key: "thinkingBorderRadiusBottomLeft",
    label: "Thinking Bottom Left Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 1
  },
  {
    key: "shimmerDuration",
    label: "Shimmer Duration (s)",
    type: "number",
    min: 0.5,
    max: 4,
    step: 0.1
  },
  { key: "shimmerColor", label: "Shimmer Color", type: "color" },
  // ============================================
  // 5. ANIMATION
  // ============================================
  { key: "animationsEnabled", label: "Animations Enabled", type: "toggle" },
  {
    key: "productAnimationDuration",
    label: "Product Animation Duration (ms)",
    type: "number",
    min: 200,
    max: 2e3,
    step: 100
  },
  {
    key: "chevronRotationDuration",
    label: "Chevron Rotation Duration (ms)",
    type: "number",
    min: 100,
    max: 500,
    step: 50
  }
], Hi = ({
  initialState: e = {},
  widgetId: t,
  displayName: o,
  children: n
}) => {
  const {
    state: a,
    isLoading: l,
    isSaving: d,
    handleEditChange: p,
    handleSave: c,
    themeColors: u,
    themeFonts: s,
    themeIcons: g,
    resolveColor: y,
    canSave: k
  } = q(
    t,
    { ...da, ...e },
    Lt
  );
  if (l)
    return /* @__PURE__ */ r(G, {});
  const f = n(a, y);
  return /* @__PURE__ */ r(
    K,
    {
      widgetId: t,
      displayName: o,
      editFields: Lt,
      editValues: a,
      onEditChange: p,
      onSave: k ? c : void 0,
      isSaving: d,
      themeColors: u,
      themeFonts: s,
      themeIcons: g,
      children: f
    }
  );
}, pa = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const o = document.createElement("link");
  o.rel = "stylesheet", o.href = e, document.head.appendChild(o);
}, ma = {
  // Carousel properties
  carouselGap: 15,
  itemWidth: 240,
  itemWidthMobile: 180,
  // Card container
  cardBorderColor: M("#dcdddc"),
  cardBorderRadius: 12,
  cardBgColor: M("#ffffff00"),
  cardBgColorHover: M("#F6F8FA"),
  cardPadding: 16,
  cardPaddingMobile: 10,
  // Title
  titleColor: P("textPrimary"),
  titleFontFamily: "inherit",
  titleFontSize: 14,
  titleFontWeight: 500,
  titleLineClamp: 3,
  titleLineHeight: 1.5,
  titleMarginTop: 20,
  // Price
  priceColor: P("textPrimary"),
  priceFontFamily: "inherit",
  priceFontSize: 20,
  priceFontSizeMobile: 16,
  priceFontWeight: 600,
  // Retailer icons
  retailerIconSize: 25,
  retailerIconSizeMobile: 15,
  // Image container
  imageMaxWidth: 190
}, jt = [
  // Carousel properties
  {
    key: "carouselGap",
    label: "Gap Between Items (px)",
    type: "number",
    min: 8,
    max: 32,
    step: 1,
    group: "Carousel"
  },
  {
    key: "itemWidth",
    label: "Item Width (Desktop)",
    type: "number",
    min: 150,
    max: 300,
    step: 10,
    group: "Carousel"
  },
  {
    key: "itemWidthMobile",
    label: "Item Width (Mobile)",
    type: "number",
    min: 120,
    max: 220,
    step: 10,
    group: "Carousel"
  },
  // Card container
  {
    key: "cardBorderColor",
    label: "Card Border Color",
    type: "color",
    group: "Card Container"
  },
  {
    key: "cardBorderRadius",
    label: "Card Border Radius (px)",
    type: "number",
    min: 0,
    max: 24,
    step: 2,
    group: "Card Container"
  },
  {
    key: "cardBgColor",
    label: "Card Background",
    type: "color",
    group: "Card Container"
  },
  {
    key: "cardBgColorHover",
    label: "Card Hover Background",
    type: "color",
    group: "Card Container"
  },
  {
    key: "cardPadding",
    label: "Card Padding (Desktop)",
    type: "number",
    min: 8,
    max: 32,
    step: 2,
    group: "Card Container"
  },
  {
    key: "cardPaddingMobile",
    label: "Card Padding (Mobile)",
    type: "number",
    min: 4,
    max: 24,
    step: 2,
    group: "Card Container"
  },
  // Title
  { key: "titleColor", label: "Title Color", type: "color", group: "Title" },
  {
    key: "titleFontFamily",
    label: "Title Font Family",
    type: "font",
    group: "Title"
  },
  {
    key: "titleFontSize",
    label: "Title Font Size (px)",
    type: "number",
    min: 12,
    max: 20,
    step: 1,
    group: "Title"
  },
  {
    key: "titleFontWeight",
    label: "Title Font Weight",
    type: "options",
    options: fe,
    group: "Title"
  },
  {
    key: "titleLineClamp",
    label: "Title Line Clamp",
    type: "number",
    min: 1,
    max: 5,
    step: 1,
    group: "Title"
  },
  {
    key: "titleLineHeight",
    label: "Title Line Height",
    type: "number",
    min: 1,
    max: 2,
    step: 0.1,
    group: "Title"
  },
  {
    key: "titleMarginTop",
    label: "Title Margin Top (px)",
    type: "number",
    min: 8,
    max: 32,
    step: 2,
    group: "Title"
  },
  // Price
  { key: "priceColor", label: "Price Color", type: "color", group: "Price" },
  {
    key: "priceFontFamily",
    label: "Price Font Family",
    type: "font",
    group: "Price"
  },
  {
    key: "priceFontSize",
    label: "Price Font Size (Desktop)",
    type: "number",
    min: 14,
    max: 28,
    step: 1,
    group: "Price"
  },
  {
    key: "priceFontSizeMobile",
    label: "Price Font Size (Mobile)",
    type: "number",
    min: 12,
    max: 24,
    step: 1,
    group: "Price"
  },
  {
    key: "priceFontWeight",
    label: "Price Font Weight",
    type: "options",
    options: En,
    group: "Price"
  },
  // Retailer icons
  {
    key: "retailerIconSize",
    label: "Retailer Icon Size (Desktop)",
    type: "number",
    min: 16,
    max: 40,
    step: 1,
    group: "Retailer Icons"
  },
  {
    key: "retailerIconSizeMobile",
    label: "Retailer Icon Size (Mobile)",
    type: "number",
    min: 12,
    max: 30,
    step: 1,
    group: "Retailer Icons"
  },
  // Image
  {
    key: "imageMaxWidth",
    label: "Image Max Width (px)",
    type: "number",
    min: 120,
    max: 250,
    step: 10,
    group: "Image"
  }
], ga = (e) => ({
  cardBorderColor: e.cardBorderColor,
  cardBorderRadius: e.cardBorderRadius,
  cardBgColor: e.cardBgColor,
  cardBgColorHover: e.cardBgColorHover,
  cardPadding: e.cardPadding,
  cardPaddingMobile: e.cardPaddingMobile,
  titleColor: e.titleColor,
  titleFontFamily: e.titleFontFamily,
  titleFontSize: e.titleFontSize,
  titleFontWeight: e.titleFontWeight,
  titleLineClamp: e.titleLineClamp,
  titleLineHeight: e.titleLineHeight,
  titleMarginTop: e.titleMarginTop,
  priceColor: e.priceColor,
  priceFontFamily: e.priceFontFamily,
  priceFontSize: e.priceFontSize,
  priceFontSizeMobile: e.priceFontSizeMobile,
  priceFontWeight: e.priceFontWeight,
  retailerIconSize: e.retailerIconSize,
  retailerIconSizeMobile: e.retailerIconSizeMobile,
  imageMaxWidth: e.imageMaxWidth
}), ua = (e) => ({
  carouselGap: e.carouselGap,
  itemWidth: e.itemWidth,
  itemWidthMobile: e.itemWidthMobile
}), Oi = ({ initialState: e = {}, widgetId: t, displayName: o, children: n }) => {
  const {
    state: a,
    isLoading: l,
    isSaving: d,
    handleEditChange: p,
    handleSave: c,
    themeColors: u,
    themeFonts: s,
    resolveColor: g,
    canSave: y,
    getEditValues: k
  } = q(
    t,
    { ...ma, ...e },
    jt
  ), f = a.titleFontFamily, b = f && f !== "inherit" ? s[f] : null, h = b && b.format === "google" ? b.url : null, w = a.priceFontFamily, B = w && w !== "inherit" ? s[w] : null, T = B && B.format === "google" ? B.url : null, S = le(() => {
    const x = [];
    return h && !x.includes(h) && x.push(h), T && !x.includes(T) && x.push(T), x;
  }, [h, T]);
  if ($(() => {
    for (const x of S)
      pa(x);
  }, [S]), l)
    return /* @__PURE__ */ r(G, {});
  const z = ga(a), O = ua(a), R = n(z, O, s, g);
  return /* @__PURE__ */ r(
    K,
    {
      widgetId: t,
      displayName: o,
      editFields: jt,
      editValues: k(),
      onEditChange: p,
      onSave: y ? c : void 0,
      isSaving: d,
      themeColors: u,
      themeFonts: s,
      children: R
    }
  );
}, ha = {
  // Container
  containerGap: 8,
  containerMarginTop: 8,
  // Add to Bag button (primary state)
  addButtonBgColor: P("primary"),
  addButtonTextColor: P("secondary"),
  addButtonHeight: 40,
  addButtonHeightMobile: 36,
  addButtonFontSize: 14,
  addButtonFontSizeMobile: 12,
  addButtonBorderRadius: 8,
  // Added to Bag button (success state)
  addedButtonBorderColor: M("#6b7280"),
  addedButtonBorderColorHover: M("#4b5563"),
  addedButtonTextColor: M("#6b7280"),
  addedButtonBgColorHover: M("#f9fafb"),
  addedIconColor: M("#6b7280"),
  addedIconSize: 16,
  // Loading state
  loadingSpinnerColor: P("secondary"),
  loadingSpinnerSize: 14
}, Gt = [
  // Container
  {
    key: "containerGap",
    label: "Container Gap",
    type: "number",
    min: 0,
    max: 16,
    step: 2
  },
  {
    key: "containerMarginTop",
    label: "Container Margin Top",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  },
  // Add to Bag button
  { key: "addButtonBgColor", label: "Add Button Background", type: "color" },
  { key: "addButtonTextColor", label: "Add Button Text", type: "color" },
  {
    key: "addButtonHeight",
    label: "Add Button Height",
    type: "number",
    min: 32,
    max: 56,
    step: 2
  },
  {
    key: "addButtonHeightMobile",
    label: "Add Button Height (Mobile)",
    type: "number",
    min: 28,
    max: 48,
    step: 2
  },
  {
    key: "addButtonFontSize",
    label: "Add Button Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1
  },
  {
    key: "addButtonFontSizeMobile",
    label: "Add Button Font Size (Mobile)",
    type: "number",
    min: 10,
    max: 16,
    step: 1
  },
  {
    key: "addButtonBorderRadius",
    label: "Add Button Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  },
  // Added to Bag button
  {
    key: "addedButtonBorderColor",
    label: "Added Button Border",
    type: "color"
  },
  {
    key: "addedButtonBorderColorHover",
    label: "Added Button Border (Hover)",
    type: "color"
  },
  { key: "addedButtonTextColor", label: "Added Button Text", type: "color" },
  {
    key: "addedButtonBgColorHover",
    label: "Added Button Bg (Hover)",
    type: "color"
  },
  { key: "addedIconColor", label: "Added Icon Color", type: "color" },
  {
    key: "addedIconSize",
    label: "Added Icon Size",
    type: "number",
    min: 12,
    max: 24,
    step: 2
  },
  // Loading state
  { key: "loadingSpinnerColor", label: "Loading Spinner Color", type: "color" },
  {
    key: "loadingSpinnerSize",
    label: "Loading Spinner Size",
    type: "number",
    min: 10,
    max: 24,
    step: 2
  }
], Ri = ({
  initialState: e = {},
  widgetId: t,
  displayName: o,
  children: n
}) => {
  const {
    state: a,
    isLoading: l,
    isSaving: d,
    handleEditChange: p,
    handleSave: c,
    themeColors: u,
    resolveColor: s,
    canSave: g
  } = q(
    t,
    { ...ha, ...e },
    Gt
  );
  if (l)
    return /* @__PURE__ */ r(G, {});
  const y = n(a, s);
  return /* @__PURE__ */ r(
    K,
    {
      widgetId: t,
      displayName: o,
      editFields: Gt,
      editValues: a,
      onEditChange: p,
      onSave: g ? c : void 0,
      isSaving: d,
      themeColors: u,
      children: y
    }
  );
}, ya = {
  // Container
  containerBgColor: P("secondary"),
  containerGap: 8,
  // Image carousel
  imageBgColor: M("#f7f7f7"),
  imagePadding: 16,
  carouselArrowSize: 28,
  carouselArrowBgColor: M("rgba(255, 255, 255, 0.9)"),
  // Title
  titleColor: P("textPrimary"),
  titleFontSize: 16,
  titleFontWeight: "semibold",
  titleLetterSpacing: 0.08,
  // Rating
  ratingStarColor: M("#ED792F"),
  ratingTextColor: P("textPrimary"),
  ratingFontSize: 14,
  // Price
  priceColor: P("textPrimary"),
  priceFontSize: 24,
  priceFontWeight: "semibold",
  priceLetterSpacing: 0.24,
  // Feature bullets
  featureTitleColor: P("textPrimary"),
  featureTitleFontSize: 16,
  featureBulletColor: P("textPrimary"),
  featureBulletFontSize: 12,
  // Primary CTA button
  primaryButtonBgColor: P("primary"),
  primaryButtonTextColor: P("secondary"),
  primaryButtonBorderRadius: 9999,
  primaryButtonHeight: 46,
  primaryButtonFontSize: 16,
  primaryButtonFontWeight: "semibold",
  // Secondary CTA button
  secondaryButtonBorderColor: P("primary"),
  secondaryButtonTextColor: P("primary"),
  secondaryButtonBorderRadius: 9999,
  secondaryButtonHeight: 46,
  secondaryButtonFontSize: 16,
  secondaryButtonFontWeight: "semibold",
  // Content section
  contentPadding: 16,
  contentGap: 16
}, Qt = [
  // Container
  { key: "containerBgColor", label: "Container Background", type: "color" },
  {
    key: "containerGap",
    label: "Container Gap",
    type: "number",
    min: 0,
    max: 24,
    step: 4
  },
  // Image carousel
  { key: "imageBgColor", label: "Image Background", type: "color" },
  {
    key: "imagePadding",
    label: "Image Padding",
    type: "number",
    min: 0,
    max: 32,
    step: 4
  },
  {
    key: "carouselArrowSize",
    label: "Carousel Arrow Size",
    type: "number",
    min: 20,
    max: 40,
    step: 2
  },
  {
    key: "carouselArrowBgColor",
    label: "Carousel Arrow Background",
    type: "color"
  },
  // Title
  { key: "titleColor", label: "Title Color", type: "color" },
  {
    key: "titleFontSize",
    label: "Title Font Size",
    type: "number",
    min: 14,
    max: 24,
    step: 1
  },
  {
    key: "titleFontWeight",
    label: "Title Font Weight",
    type: "options",
    options: [...V]
  },
  // Rating
  { key: "ratingStarColor", label: "Rating Star Color", type: "color" },
  { key: "ratingTextColor", label: "Rating Text Color", type: "color" },
  {
    key: "ratingFontSize",
    label: "Rating Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1
  },
  // Price
  { key: "priceColor", label: "Price Color", type: "color" },
  {
    key: "priceFontSize",
    label: "Price Font Size",
    type: "number",
    min: 18,
    max: 36,
    step: 2
  },
  {
    key: "priceFontWeight",
    label: "Price Font Weight",
    type: "options",
    options: [...V]
  },
  // Feature bullets
  { key: "featureTitleColor", label: "Features Title Color", type: "color" },
  {
    key: "featureTitleFontSize",
    label: "Features Title Size",
    type: "number",
    min: 14,
    max: 20,
    step: 1
  },
  { key: "featureBulletColor", label: "Feature Bullet Color", type: "color" },
  {
    key: "featureBulletFontSize",
    label: "Feature Bullet Size",
    type: "number",
    min: 10,
    max: 16,
    step: 1
  },
  // Primary CTA button
  {
    key: "primaryButtonBgColor",
    label: "Primary Button Background",
    type: "color"
  },
  {
    key: "primaryButtonTextColor",
    label: "Primary Button Text",
    type: "color"
  },
  {
    key: "primaryButtonBorderRadius",
    label: "Primary Button Radius",
    type: "number",
    min: 0,
    max: 9999,
    step: 4
  },
  {
    key: "primaryButtonHeight",
    label: "Primary Button Height",
    type: "number",
    min: 36,
    max: 60,
    step: 2
  },
  {
    key: "primaryButtonFontSize",
    label: "Primary Button Font Size",
    type: "number",
    min: 12,
    max: 20,
    step: 1
  },
  // Secondary CTA button
  {
    key: "secondaryButtonBorderColor",
    label: "Secondary Button Border",
    type: "color"
  },
  {
    key: "secondaryButtonTextColor",
    label: "Secondary Button Text",
    type: "color"
  },
  {
    key: "secondaryButtonBorderRadius",
    label: "Secondary Button Radius",
    type: "number",
    min: 0,
    max: 9999,
    step: 4
  },
  {
    key: "secondaryButtonHeight",
    label: "Secondary Button Height",
    type: "number",
    min: 36,
    max: 60,
    step: 2
  },
  {
    key: "secondaryButtonFontSize",
    label: "Secondary Button Font Size",
    type: "number",
    min: 12,
    max: 20,
    step: 1
  },
  // Content section
  {
    key: "contentPadding",
    label: "Content Padding",
    type: "number",
    min: 0,
    max: 32,
    step: 4
  },
  {
    key: "contentGap",
    label: "Content Gap",
    type: "number",
    min: 8,
    max: 32,
    step: 4
  }
], Wi = ({
  initialState: e = {},
  widgetId: t,
  displayName: o,
  children: n
}) => {
  const {
    state: a,
    isLoading: l,
    isSaving: d,
    handleEditChange: p,
    handleSave: c,
    themeColors: u,
    resolveColor: s,
    canSave: g
  } = q(
    t,
    { ...ya, ...e },
    Qt
  );
  if (l)
    return /* @__PURE__ */ r(G, {});
  const y = n(a, s);
  return /* @__PURE__ */ r(
    K,
    {
      widgetId: t,
      displayName: o,
      editFields: Qt,
      editValues: a,
      onEditChange: p,
      onSave: g ? c : void 0,
      isSaving: d,
      themeColors: u,
      children: y
    }
  );
}, ba = {
  // Card styling
  cardBgColor: P("secondary"),
  cardBorderColor: M("#DCDDDC"),
  cardBorderRadius: 8,
  cardShadowColor: P("primary"),
  cardShadowOpacity: 0.08,
  cardPadding: 12,
  // Retailer logo
  logoContainerSize: 40,
  logoContainerBgColor: M("#F6F8FA"),
  logoContainerBorderRadius: 50,
  // Card text
  cardTitleFontSize: 14,
  cardTitleFontWeight: "semibold",
  cardTitleColor: P("textPrimary"),
  cardSubtitleFontSize: 12,
  cardSubtitleColor: M("rgba(0, 0, 0, 0.7)"),
  // Card button
  cardButtonBgColor: M("#F6F8FA"),
  cardButtonTextColor: P("textPrimary"),
  cardButtonFontSize: 12,
  cardButtonBorderRadius: 18,
  cardButtonPaddingX: 14,
  cardButtonPaddingY: 4,
  // Search bar
  searchBgColor: P("secondary"),
  searchBorderColor: M("#DCDDDC"),
  searchBorderRadius: 100,
  searchHeight: 44,
  searchPlaceholderColor: M("rgba(0, 0, 0, 0.5)"),
  searchTextColor: P("textPrimary"),
  searchIconColor: M("rgba(0, 0, 0, 0.6)"),
  // Detail panel
  panelBgColor: P("secondary"),
  panelWidth: 300,
  panelBorderRadius: 10,
  panelImageHeight: 164,
  // Status colors
  statusOpenColor: P("success"),
  statusClosedColor: P("error"),
  // Section titles
  sectionTitleFontSize: 12,
  sectionTitleFontWeight: "bold",
  sectionTitleColor: P("textPrimary"),
  // Loading/empty states
  loadingBgColor: M("#F6F8FA"),
  emptyStateTextColor: M("#666666"),
  emptyStateFontSize: 14
}, $t = [
  // Card styling
  { key: "cardBgColor", label: "Card Background", type: "color" },
  { key: "cardBorderColor", label: "Card Border Color", type: "color" },
  {
    key: "cardBorderRadius",
    label: "Card Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  },
  { key: "cardShadowColor", label: "Card Shadow Color", type: "color" },
  {
    key: "cardShadowOpacity",
    label: "Card Shadow Opacity",
    type: "number",
    min: 0,
    max: 0.5,
    step: 0.02
  },
  {
    key: "cardPadding",
    label: "Card Padding",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  // Retailer logo
  {
    key: "logoContainerSize",
    label: "Logo Container Size",
    type: "number",
    min: 24,
    max: 56,
    step: 4
  },
  {
    key: "logoContainerBgColor",
    label: "Logo Container Background",
    type: "color"
  },
  {
    key: "logoContainerBorderRadius",
    label: "Logo Border Radius (%)",
    type: "number",
    min: 0,
    max: 50,
    step: 5
  },
  // Card text
  {
    key: "cardTitleFontSize",
    label: "Card Title Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1
  },
  {
    key: "cardTitleFontWeight",
    label: "Card Title Weight",
    type: "options",
    options: [...V]
  },
  { key: "cardTitleColor", label: "Card Title Color", type: "color" },
  {
    key: "cardSubtitleFontSize",
    label: "Card Subtitle Size",
    type: "number",
    min: 10,
    max: 16,
    step: 1
  },
  { key: "cardSubtitleColor", label: "Card Subtitle Color", type: "color" },
  // Card button
  { key: "cardButtonBgColor", label: "Card Button Background", type: "color" },
  { key: "cardButtonTextColor", label: "Card Button Text", type: "color" },
  {
    key: "cardButtonFontSize",
    label: "Card Button Font Size",
    type: "number",
    min: 10,
    max: 16,
    step: 1
  },
  {
    key: "cardButtonBorderRadius",
    label: "Card Button Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  },
  {
    key: "cardButtonPaddingX",
    label: "Card Button Padding X",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  {
    key: "cardButtonPaddingY",
    label: "Card Button Padding Y",
    type: "number",
    min: 2,
    max: 12,
    step: 2
  },
  // Search bar
  { key: "searchBgColor", label: "Search Background", type: "color" },
  { key: "searchBorderColor", label: "Search Border Color", type: "color" },
  {
    key: "searchBorderRadius",
    label: "Search Border Radius",
    type: "number",
    min: 0,
    max: 100,
    step: 4
  },
  {
    key: "searchHeight",
    label: "Search Height",
    type: "number",
    min: 36,
    max: 56,
    step: 2
  },
  {
    key: "searchPlaceholderColor",
    label: "Search Placeholder Color",
    type: "color"
  },
  { key: "searchTextColor", label: "Search Text Color", type: "color" },
  { key: "searchIconColor", label: "Search Icon Color", type: "color" },
  // Detail panel
  { key: "panelBgColor", label: "Panel Background", type: "color" },
  {
    key: "panelWidth",
    label: "Panel Width",
    type: "number",
    min: 240,
    max: 400,
    step: 20
  },
  {
    key: "panelBorderRadius",
    label: "Panel Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  },
  {
    key: "panelImageHeight",
    label: "Panel Image Height",
    type: "number",
    min: 100,
    max: 240,
    step: 10
  },
  // Status colors
  { key: "statusOpenColor", label: "Status Open Color", type: "color" },
  { key: "statusClosedColor", label: "Status Closed Color", type: "color" },
  // Section titles
  {
    key: "sectionTitleFontSize",
    label: "Section Title Size",
    type: "number",
    min: 10,
    max: 16,
    step: 1
  },
  {
    key: "sectionTitleFontWeight",
    label: "Section Title Weight",
    type: "options",
    options: [...V]
  },
  { key: "sectionTitleColor", label: "Section Title Color", type: "color" },
  // Loading/empty states
  { key: "loadingBgColor", label: "Loading Background", type: "color" },
  { key: "emptyStateTextColor", label: "Empty State Text", type: "color" },
  {
    key: "emptyStateFontSize",
    label: "Empty State Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1
  }
], Di = ({
  initialState: e = {},
  widgetId: t,
  displayName: o,
  children: n
}) => {
  const {
    state: a,
    isLoading: l,
    isSaving: d,
    handleEditChange: p,
    handleSave: c,
    themeColors: u,
    resolveColor: s,
    canSave: g
  } = q(
    t,
    { ...ba, ...e },
    $t
  );
  if (l)
    return /* @__PURE__ */ r(G, {});
  const y = n(a, s);
  return /* @__PURE__ */ r(
    K,
    {
      widgetId: t,
      displayName: o,
      editFields: $t,
      editValues: a,
      onEditChange: p,
      onSave: g ? c : void 0,
      isSaving: d,
      themeColors: u,
      children: y
    }
  );
}, fa = {
  // Container
  maxWidth: 600,
  paddingX: 16,
  paddingY: 16,
  backgroundColor: "transparent",
  borderRadius: 0,
  // Header
  headerFontSize: 18,
  headerFontWeight: "semibold",
  headerColor: "#1a1a1a",
  headerMarginBottom: 16,
  // Order card
  cardBgColor: "#ffffff",
  cardBorderColor: "#e5e7eb",
  cardBorderWidth: 1,
  cardBorderRadius: 12,
  cardPadding: 16,
  cardGap: 12,
  // Order info
  orderIdFontSize: 14,
  orderIdFontWeight: "semibold",
  orderIdColor: "#1a1a1a",
  orderDateFontSize: 13,
  orderDateColor: "#6b7280",
  orderStatusFontSize: 12,
  // Item styling
  itemImageSize: 48,
  itemTitleFontSize: 14,
  itemTitleColor: "#1a1a1a",
  itemPriceFontSize: 14,
  itemPriceColor: "#374151",
  // Total
  totalFontSize: 15,
  totalFontWeight: "semibold",
  totalColor: "#1a1a1a",
  // Empty state
  emptyIconSize: 48,
  emptyTextFontSize: 14,
  emptyTextColor: "#6b7280"
}, Ue = (e) => ({
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700
})[e] || 500, Ro = (e) => `$${e.toFixed(2)}`, xa = (e) => new Date(e).toLocaleDateString("en-US", {
  year: "numeric",
  month: "short",
  day: "numeric"
}), Ca = ({ size: e, color: t }) => /* @__PURE__ */ m("svg", { width: e, height: e, viewBox: "0 0 24 24", fill: "none", stroke: t, strokeWidth: "2", children: [
  /* @__PURE__ */ r("path", { d: "M16.5 9.4L7.5 4.21M21 16V8C20.9996 7.6481 20.9071 7.3024 20.7315 6.99847C20.556 6.69454 20.3037 6.44327 20 6.27L13 2.27C12.696 2.09674 12.3511 2.0053 12 2.0053C11.6489 2.0053 11.304 2.09674 11 2.27L4 6.27C3.69626 6.44327 3.44398 6.69454 3.26846 6.99847C3.09294 7.3024 3.00036 7.6481 3 8V16C3.00036 16.3519 3.09294 16.6976 3.26846 17.0015C3.44398 17.3055 3.69626 17.5567 4 17.73L11 21.73C11.304 21.9033 11.6489 21.9947 12 21.9947C12.3511 21.9947 12.696 21.9033 13 21.73L20 17.73C20.3037 17.5567 20.556 17.3055 20.7315 17.0015C20.9071 16.6976 20.9996 16.3519 21 16Z", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ r("path", { d: "M3.27002 6.96L12 12.01L20.73 6.96", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ r("path", { d: "M12 22.08V12", strokeLinecap: "round", strokeLinejoin: "round" })
] }), Yt = ({ size: e, color: t }) => /* @__PURE__ */ m("svg", { width: e, height: e, viewBox: "0 0 24 24", fill: "none", stroke: t, strokeWidth: "2", children: [
  /* @__PURE__ */ r("path", { d: "M6 2L3 6V20C3 20.5304 3.21071 21.0391 3.58579 21.4142C3.96086 21.7893 4.46957 22 5 22H19C19.5304 22 20.0391 21.7893 20.4142 21.4142C20.7893 21.0391 21 20.5304 21 20V6L18 2H6Z", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ r("path", { d: "M3 6H21", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ r("path", { d: "M16 10C16 11.0609 15.5786 12.0783 14.8284 12.8284C14.0783 13.5786 13.0609 14 12 14C10.9391 14 9.92172 13.5786 9.17157 12.8284C8.42143 12.0783 8 11.0609 8 10", strokeLinecap: "round", strokeLinejoin: "round" })
] }), ka = ({ item: e, state: t, onClick: o }) => /* @__PURE__ */ m(
  "div",
  {
    onClick: o,
    style: {
      display: "flex",
      alignItems: "center",
      gap: 12,
      cursor: o ? "pointer" : "default"
    },
    children: [
      /* @__PURE__ */ r(
        "div",
        {
          style: {
            width: t.itemImageSize,
            height: t.itemImageSize,
            borderRadius: 8,
            overflow: "hidden",
            backgroundColor: "#f3f4f6",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0
          },
          children: e.imageUrl ? /* @__PURE__ */ r(
            "img",
            {
              src: e.imageUrl,
              alt: e.title || e.retailerSku,
              style: { width: "100%", height: "100%", objectFit: "cover" }
            }
          ) : /* @__PURE__ */ r(Ca, { size: t.itemImageSize * 0.5, color: "#9ca3af" })
        }
      ),
      /* @__PURE__ */ m("div", { style: { flex: 1, minWidth: 0 }, children: [
        /* @__PURE__ */ r(
          "div",
          {
            style: {
              fontSize: t.itemTitleFontSize,
              color: t.itemTitleColor,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap"
            },
            children: e.title || e.retailerSku
          }
        ),
        /* @__PURE__ */ m(
          "div",
          {
            style: {
              display: "flex",
              gap: 8,
              fontSize: t.itemPriceFontSize,
              color: t.itemPriceColor
            },
            children: [
              /* @__PURE__ */ r("span", { children: Ro(e.price) }),
              /* @__PURE__ */ m("span", { children: [
                "× ",
                e.quantity
              ] })
            ]
          }
        )
      ] })
    ]
  }
), va = ({ order: e, state: t, onOrderClick: o, onItemClick: n }) => /* @__PURE__ */ m(
  "div",
  {
    onClick: o,
    style: {
      backgroundColor: t.cardBgColor,
      border: `${t.cardBorderWidth}px solid ${t.cardBorderColor}`,
      borderRadius: t.cardBorderRadius,
      padding: t.cardPadding,
      cursor: o ? "pointer" : "default"
    },
    children: [
      /* @__PURE__ */ m(
        "div",
        {
          style: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            marginBottom: 12
          },
          children: [
            /* @__PURE__ */ m("div", { children: [
              /* @__PURE__ */ m(
                "div",
                {
                  style: {
                    fontSize: t.orderIdFontSize,
                    fontWeight: Ue(t.orderIdFontWeight),
                    color: t.orderIdColor
                  },
                  children: [
                    "Order #",
                    e.orderId.slice(-8).toUpperCase()
                  ]
                }
              ),
              e.retailerName && /* @__PURE__ */ r("div", { style: { fontSize: t.orderDateFontSize, color: t.orderDateColor, marginTop: 2 }, children: e.retailerName })
            ] }),
            /* @__PURE__ */ m("div", { style: { textAlign: "right" }, children: [
              /* @__PURE__ */ r("div", { style: { fontSize: t.orderDateFontSize, color: t.orderDateColor }, children: xa(e.orderDate) }),
              /* @__PURE__ */ r(
                "div",
                {
                  style: {
                    fontSize: t.orderStatusFontSize,
                    color: e.status === "delivered" ? "#10b981" : "#f59e0b",
                    marginTop: 2,
                    textTransform: "capitalize"
                  },
                  children: e.status
                }
              )
            ] })
          ]
        }
      ),
      /* @__PURE__ */ m("div", { style: { display: "flex", flexDirection: "column", gap: 10 }, children: [
        e.items.slice(0, 2).map((a, l) => /* @__PURE__ */ r(
          ka,
          {
            item: a,
            state: t,
            onClick: n ? () => n(a) : void 0
          },
          l
        )),
        e.items.length > 2 && /* @__PURE__ */ m("div", { style: { fontSize: t.itemTitleFontSize, color: t.orderDateColor }, children: [
          "+",
          e.items.length - 2,
          " more item",
          e.items.length - 2 !== 1 ? "s" : ""
        ] })
      ] }),
      /* @__PURE__ */ m(
        "div",
        {
          style: {
            display: "flex",
            justifyContent: "space-between",
            marginTop: 12,
            paddingTop: 12,
            borderTop: `1px solid ${t.cardBorderColor}`
          },
          children: [
            /* @__PURE__ */ r("span", { style: { fontSize: t.totalFontSize, color: t.orderDateColor }, children: "Total" }),
            /* @__PURE__ */ r(
              "span",
              {
                style: {
                  fontSize: t.totalFontSize,
                  fontWeight: Ue(t.totalFontWeight),
                  color: t.totalColor
                },
                children: Ro(e.totalAmount)
              }
            )
          ]
        }
      )
    ]
  }
), Li = ({
  widgetId: e,
  orders: t,
  isAuthenticated: o = !0,
  isLoading: n = !1,
  error: a,
  onOrderClick: l,
  onItemClick: d,
  emptyMessage: p = "No orders yet",
  className: c,
  children: u
}) => {
  const { state: s } = q(
    e,
    fa,
    []
    // No edit fields for now
  );
  return u ? /* @__PURE__ */ r(G, { children: u(s, t) }) : n ? /* @__PURE__ */ r(
    "div",
    {
      className: c,
      style: {
        maxWidth: s.maxWidth,
        padding: `${s.paddingY}px ${s.paddingX}px`,
        textAlign: "center"
      },
      children: /* @__PURE__ */ r("div", { style: { fontSize: s.emptyTextFontSize, color: s.emptyTextColor }, children: "Loading orders..." })
    }
  ) : a ? /* @__PURE__ */ r(
    "div",
    {
      className: c,
      style: {
        maxWidth: s.maxWidth,
        padding: `${s.paddingY}px ${s.paddingX}px`,
        textAlign: "center"
      },
      children: /* @__PURE__ */ r("div", { style: { fontSize: s.emptyTextFontSize, color: "#ef4444" }, children: a })
    }
  ) : o ? t.length === 0 ? /* @__PURE__ */ m(
    "div",
    {
      className: c,
      style: {
        maxWidth: s.maxWidth,
        padding: `${s.paddingY}px ${s.paddingX}px`,
        textAlign: "center"
      },
      children: [
        /* @__PURE__ */ r(Yt, { size: s.emptyIconSize, color: s.emptyTextColor }),
        /* @__PURE__ */ r("div", { style: { fontSize: s.emptyTextFontSize, color: s.emptyTextColor, marginTop: 12 }, children: p })
      ]
    }
  ) : /* @__PURE__ */ m(
    "div",
    {
      className: c,
      style: {
        maxWidth: s.maxWidth,
        padding: `${s.paddingY}px ${s.paddingX}px`,
        backgroundColor: s.backgroundColor,
        borderRadius: s.borderRadius
      },
      children: [
        /* @__PURE__ */ m(
          "h3",
          {
            style: {
              fontSize: s.headerFontSize,
              fontWeight: Ue(s.headerFontWeight),
              color: s.headerColor,
              marginBottom: s.headerMarginBottom,
              margin: 0,
              marginBlockEnd: s.headerMarginBottom
            },
            children: [
              t.length,
              " Order",
              t.length !== 1 ? "s" : ""
            ]
          }
        ),
        /* @__PURE__ */ r("div", { style: { display: "flex", flexDirection: "column", gap: s.cardGap }, children: t.map((g) => /* @__PURE__ */ r(
          va,
          {
            order: g,
            state: s,
            onOrderClick: l ? () => l(g) : void 0,
            onItemClick: d ? (y) => d(y, g) : void 0
          },
          g.orderId
        )) })
      ]
    }
  ) : /* @__PURE__ */ m(
    "div",
    {
      className: c,
      style: {
        maxWidth: s.maxWidth,
        padding: `${s.paddingY}px ${s.paddingX}px`,
        textAlign: "center"
      },
      children: [
        /* @__PURE__ */ r(Yt, { size: s.emptyIconSize, color: s.emptyTextColor }),
        /* @__PURE__ */ r("div", { style: { fontSize: s.emptyTextFontSize, color: s.emptyTextColor, marginTop: 12 }, children: "Please login to view your order history" })
      ]
    }
  );
}, wa = {
  // Container
  maxWidth: 600,
  paddingX: 0,
  paddingY: 0,
  backgroundColor: "transparent",
  borderRadius: 0,
  // Header
  headerFontSize: 16,
  headerFontWeight: "semibold",
  headerColor: "#1a1a1a",
  headerMarginBottom: 12,
  // Card styling
  cardBgColor: "#ffffff",
  cardBorderColor: "#e5e7eb",
  cardBorderWidth: 1,
  cardBorderRadius: 12,
  cardPadding: 12,
  cardGap: 12,
  // Product image
  imageSize: 64,
  imageBorderRadius: 8,
  // Content
  titleFontSize: 14,
  titleFontWeight: "medium",
  titleColor: "#1a1a1a",
  brandNameFontSize: 12,
  brandNameColor: "#6b7280",
  // Price
  priceFontSize: 14,
  priceColor: "#1a1a1a",
  // Reward badge
  rewardFontSize: 13,
  rewardFontWeight: "bold",
  rewardColor: "#059669",
  rewardBgColor: "#ecfdf5",
  rewardBorderRadius: 6,
  // Urgency badge
  urgencyFontSize: 11,
  urgencyColor: "#dc2626",
  urgencyBgColor: "#fef2f2",
  // Empty state
  emptyIconSize: 48,
  emptyTextFontSize: 14,
  emptyTextColor: "#6b7280"
}, Sa = [
  { label: "Normal", value: "normal" },
  { label: "Medium", value: "medium" },
  { label: "Semibold", value: "semibold" },
  { label: "Bold", value: "bold" }
], Jt = [
  // Card styling
  {
    key: "cardBgColor",
    label: "Card Background",
    type: "color",
    group: "Card"
  },
  {
    key: "cardBorderColor",
    label: "Card Border Color",
    type: "color",
    group: "Card"
  },
  {
    key: "cardBorderRadius",
    label: "Card Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2,
    group: "Card"
  },
  {
    key: "cardPadding",
    label: "Card Padding",
    type: "number",
    min: 8,
    max: 24,
    step: 2,
    group: "Card"
  },
  {
    key: "cardGap",
    label: "Gap Between Cards",
    type: "number",
    min: 8,
    max: 24,
    step: 2,
    group: "Card"
  },
  // Image
  {
    key: "imageSize",
    label: "Image Size",
    type: "number",
    min: 48,
    max: 120,
    step: 8,
    group: "Image"
  },
  {
    key: "imageBorderRadius",
    label: "Image Border Radius",
    type: "number",
    min: 0,
    max: 16,
    step: 2,
    group: "Image"
  },
  // Title
  {
    key: "titleFontSize",
    label: "Title Font Size",
    type: "number",
    min: 12,
    max: 20,
    step: 1,
    group: "Title"
  },
  {
    key: "titleColor",
    label: "Title Color",
    type: "color",
    group: "Title"
  },
  {
    key: "titleFontWeight",
    label: "Title Font Weight",
    type: "options",
    options: Sa,
    group: "Title"
  },
  // Brand
  {
    key: "brandNameFontSize",
    label: "Brand Font Size",
    type: "number",
    min: 10,
    max: 16,
    step: 1,
    group: "Brand"
  },
  {
    key: "brandNameColor",
    label: "Brand Color",
    type: "color",
    group: "Brand"
  },
  // Reward
  {
    key: "rewardFontSize",
    label: "Reward Font Size",
    type: "number",
    min: 11,
    max: 18,
    step: 1,
    group: "Reward"
  },
  {
    key: "rewardColor",
    label: "Reward Text Color",
    type: "color",
    group: "Reward"
  },
  {
    key: "rewardBgColor",
    label: "Reward Background",
    type: "color",
    group: "Reward"
  },
  {
    key: "rewardBorderRadius",
    label: "Reward Border Radius",
    type: "number",
    min: 0,
    max: 16,
    step: 2,
    group: "Reward"
  }
], Ze = (e) => ({
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700
})[e] || 500, qe = (e) => `$${e.toFixed(2)}`, Ba = ({
  size: e,
  color: t
}) => /* @__PURE__ */ r(
  "svg",
  {
    width: e,
    height: e,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    children: /* @__PURE__ */ r(
      "path",
      {
        d: "M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), za = ({ deal: e, state: t, onClick: o }) => /* @__PURE__ */ m(
  "div",
  {
    onClick: o,
    style: {
      backgroundColor: t.cardBgColor,
      border: `${t.cardBorderWidth}px solid ${t.cardBorderColor}`,
      borderRadius: t.cardBorderRadius,
      padding: t.cardPadding,
      cursor: o ? "pointer" : "default",
      display: "flex",
      gap: 12,
      alignItems: "flex-start",
      transition: "box-shadow 0.15s ease"
    },
    onMouseEnter: (n) => {
      o && (n.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.08)");
    },
    onMouseLeave: (n) => {
      n.currentTarget.style.boxShadow = "none";
    },
    children: [
      e.imageUrl && /* @__PURE__ */ r(
        "div",
        {
          style: {
            width: t.imageSize,
            height: t.imageSize,
            borderRadius: t.imageBorderRadius,
            overflow: "hidden",
            flexShrink: 0,
            backgroundColor: "#f9fafb"
          },
          children: /* @__PURE__ */ r(
            "img",
            {
              src: e.imageUrl,
              alt: e.title,
              style: { width: "100%", height: "100%", objectFit: "contain" }
            }
          )
        }
      ),
      /* @__PURE__ */ m("div", { style: { flex: 1, minWidth: 0 }, children: [
        /* @__PURE__ */ r(
          "div",
          {
            style: {
              fontSize: t.brandNameFontSize,
              color: t.brandNameColor,
              marginBottom: 2
            },
            children: e.brandName
          }
        ),
        /* @__PURE__ */ r(
          "div",
          {
            style: {
              fontSize: t.titleFontSize,
              fontWeight: Ze(t.titleFontWeight),
              color: t.titleColor,
              marginBottom: 4,
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden"
            },
            children: e.title
          }
        ),
        e.price && /* @__PURE__ */ r("div", { style: { fontSize: t.priceFontSize, color: t.priceColor }, children: qe(e.price) }),
        e.retailerName && /* @__PURE__ */ m(
          "div",
          {
            style: {
              fontSize: t.brandNameFontSize,
              color: t.brandNameColor,
              marginTop: 4
            },
            children: [
              "at ",
              e.retailerName
            ]
          }
        )
      ] }),
      /* @__PURE__ */ m(
        "div",
        {
          style: {
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
            gap: 6,
            flexShrink: 0
          },
          children: [
            /* @__PURE__ */ m(
              "div",
              {
                style: {
                  fontSize: t.rewardFontSize,
                  fontWeight: Ze(t.rewardFontWeight),
                  color: t.rewardColor,
                  backgroundColor: t.rewardBgColor,
                  padding: "6px 10px",
                  borderRadius: t.rewardBorderRadius,
                  whiteSpace: "nowrap"
                },
                children: [
                  "+",
                  qe(e.rewardAmount)
                ]
              }
            ),
            (e.isLimitedQuantity || e.expiresAt) && /* @__PURE__ */ r(
              "div",
              {
                style: {
                  fontSize: t.urgencyFontSize,
                  color: t.urgencyColor,
                  backgroundColor: t.urgencyBgColor,
                  padding: "3px 8px",
                  borderRadius: 4,
                  whiteSpace: "nowrap"
                },
                children: e.isLimitedQuantity ? "🔥 Limited" : "⏰ Limited Time"
              }
            )
          ]
        }
      )
    ]
  }
), ji = ({
  widgetId: e,
  displayName: t = "Daily Deals",
  deals: o,
  isLoading: n = !1,
  error: a,
  onDealClick: l,
  headerText: d,
  showHeader: p = !0,
  emptyMessage: c = "No daily deals available right now",
  className: u,
  children: s
}) => {
  const {
    state: g,
    handleEditChange: y,
    handleSave: k,
    isSaving: f,
    themeColors: b,
    themeFonts: h,
    canSave: w
  } = q(
    e,
    wa,
    Jt
  );
  if (s)
    return /* @__PURE__ */ r(G, { children: s(g, o) });
  if (n)
    return /* @__PURE__ */ r(
      "div",
      {
        className: u,
        style: {
          maxWidth: g.maxWidth,
          padding: `${g.paddingY}px ${g.paddingX}px`,
          textAlign: "center"
        },
        children: /* @__PURE__ */ r(
          "div",
          {
            style: {
              fontSize: g.emptyTextFontSize,
              color: g.emptyTextColor
            },
            children: "Finding today's deals..."
          }
        )
      }
    );
  if (a)
    return /* @__PURE__ */ r(
      "div",
      {
        className: u,
        style: {
          maxWidth: g.maxWidth,
          padding: `${g.paddingY}px ${g.paddingX}px`,
          textAlign: "center"
        },
        children: /* @__PURE__ */ r("div", { style: { fontSize: g.emptyTextFontSize, color: "#ef4444" }, children: a })
      }
    );
  if (o.length === 0)
    return /* @__PURE__ */ m(
      "div",
      {
        className: u,
        style: {
          maxWidth: g.maxWidth,
          padding: `${g.paddingY}px ${g.paddingX}px`,
          textAlign: "center"
        },
        children: [
          /* @__PURE__ */ r(Ba, { size: g.emptyIconSize, color: g.emptyTextColor }),
          /* @__PURE__ */ r(
            "div",
            {
              style: {
                fontSize: g.emptyTextFontSize,
                color: g.emptyTextColor,
                marginTop: 12
              },
              children: c
            }
          )
        ]
      }
    );
  const B = o.reduce((z, O) => z + O.rewardAmount, 0), T = d || `${o.length} Daily Deal${o.length !== 1 ? "s" : ""} (${qe(B)} cashback)`, S = /* @__PURE__ */ m(
    "div",
    {
      className: u,
      style: {
        maxWidth: g.maxWidth,
        padding: `${g.paddingY}px ${g.paddingX}px`,
        backgroundColor: g.backgroundColor,
        borderRadius: g.borderRadius
      },
      children: [
        p && /* @__PURE__ */ r(
          "h3",
          {
            style: {
              fontSize: g.headerFontSize,
              fontWeight: Ze(g.headerFontWeight),
              color: g.headerColor,
              marginBottom: g.headerMarginBottom,
              margin: 0,
              marginBlockEnd: g.headerMarginBottom
            },
            children: T
          }
        ),
        /* @__PURE__ */ r(
          "div",
          {
            style: { display: "flex", flexDirection: "column", gap: g.cardGap },
            children: o.map((z) => /* @__PURE__ */ r(
              za,
              {
                deal: z,
                state: g,
                onClick: l ? () => l(z) : void 0
              },
              z.stacklineSku
            ))
          }
        )
      ]
    }
  );
  return /* @__PURE__ */ r(
    K,
    {
      widgetId: e,
      displayName: t,
      editFields: Jt,
      editValues: g,
      onEditChange: y,
      onSave: w ? k : void 0,
      isSaving: f,
      themeColors: b,
      themeFonts: h,
      children: S
    }
  );
}, Wo = {
  // Container
  maxWidth: 600,
  paddingX: 0,
  paddingY: 0,
  backgroundColor: "transparent",
  borderRadius: 0,
  // Header
  headerFontSize: 16,
  headerFontWeight: "semibold",
  headerColor: "#1a1a1a",
  headerMarginBottom: 12,
  // Card styling
  cardBgColor: "#ffffff",
  cardBorderColor: "#e5e7eb",
  cardBorderWidth: 1,
  cardBorderRadius: 12,
  cardPadding: 16,
  cardGap: 12,
  // Brand logo
  brandLogoSize: 48,
  brandLogoBorderRadius: 8,
  // Content
  titleFontSize: 15,
  titleFontWeight: "semibold",
  titleColor: "#1a1a1a",
  descriptionFontSize: 13,
  descriptionColor: "#6b7280",
  brandNameFontSize: 13,
  brandNameColor: "#6b7280",
  // Meta info
  metaFontSize: 12,
  metaColor: "#9ca3af",
  // Reward badge
  rewardFontSize: 14,
  rewardFontWeight: "bold",
  rewardColor: "#059669",
  rewardBgColor: "#ecfdf5",
  rewardBorderRadius: 6,
  // Survey badge
  surveyBadgeFontSize: 11,
  surveyBadgeColor: "#1d4ed8",
  surveyBadgeBgColor: "#dbeafe",
  // Empty state
  emptyIconSize: 48,
  emptyTextFontSize: 14,
  emptyTextColor: "#6b7280"
}, Fa = [
  { label: "Normal", value: "normal" },
  { label: "Medium", value: "medium" },
  { label: "Semibold", value: "semibold" },
  { label: "Bold", value: "bold" }
], Xt = [
  // Card styling
  {
    key: "cardBgColor",
    label: "Card Background",
    type: "color",
    group: "Card"
  },
  {
    key: "cardBorderColor",
    label: "Card Border Color",
    type: "color",
    group: "Card"
  },
  {
    key: "cardBorderRadius",
    label: "Card Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2,
    group: "Card"
  },
  {
    key: "cardPadding",
    label: "Card Padding",
    type: "number",
    min: 8,
    max: 24,
    step: 2,
    group: "Card"
  },
  {
    key: "cardGap",
    label: "Gap Between Cards",
    type: "number",
    min: 8,
    max: 24,
    step: 2,
    group: "Card"
  },
  // Brand logo
  {
    key: "brandLogoSize",
    label: "Logo Size",
    type: "number",
    min: 32,
    max: 80,
    step: 4,
    group: "Logo"
  },
  {
    key: "brandLogoBorderRadius",
    label: "Logo Border Radius",
    type: "number",
    min: 0,
    max: 16,
    step: 2,
    group: "Logo"
  },
  // Title
  {
    key: "titleFontSize",
    label: "Title Font Size",
    type: "number",
    min: 12,
    max: 20,
    step: 1,
    group: "Title"
  },
  {
    key: "titleColor",
    label: "Title Color",
    type: "color",
    group: "Title"
  },
  {
    key: "titleFontWeight",
    label: "Title Font Weight",
    type: "options",
    options: Fa,
    group: "Title"
  },
  // Brand name
  {
    key: "brandNameFontSize",
    label: "Brand Font Size",
    type: "number",
    min: 10,
    max: 16,
    step: 1,
    group: "Brand"
  },
  {
    key: "brandNameColor",
    label: "Brand Color",
    type: "color",
    group: "Brand"
  },
  // Reward
  {
    key: "rewardFontSize",
    label: "Reward Font Size",
    type: "number",
    min: 11,
    max: 18,
    step: 1,
    group: "Reward"
  },
  {
    key: "rewardColor",
    label: "Reward Text Color",
    type: "color",
    group: "Reward"
  },
  {
    key: "rewardBgColor",
    label: "Reward Background",
    type: "color",
    group: "Reward"
  },
  {
    key: "rewardBorderRadius",
    label: "Reward Border Radius",
    type: "number",
    min: 0,
    max: 16,
    step: 2,
    group: "Reward"
  },
  // Survey badge
  {
    key: "surveyBadgeColor",
    label: "Badge Text Color",
    type: "color",
    group: "Badge"
  },
  {
    key: "surveyBadgeBgColor",
    label: "Badge Background",
    type: "color",
    group: "Badge"
  }
], Ve = (e) => ({
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700
})[e] || 500, Do = (e) => `$${e.toFixed(2)}`, Ta = ({ size: e, color: t }) => /* @__PURE__ */ m("svg", { width: e, height: e, viewBox: "0 0 24 24", fill: "none", stroke: t, strokeWidth: "2", children: [
  /* @__PURE__ */ r("path", { d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ r("rect", { x: "8", y: "2", width: "8", height: "4", rx: "1", ry: "1", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ r("path", { d: "M9 12h6", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ r("path", { d: "M9 16h6", strokeLinecap: "round", strokeLinejoin: "round" })
] }), Ea = ({ survey: e, state: t, onClick: o }) => /* @__PURE__ */ m(
  "div",
  {
    onClick: o,
    style: {
      backgroundColor: t.cardBgColor,
      border: `${t.cardBorderWidth}px solid ${t.cardBorderColor}`,
      borderRadius: t.cardBorderRadius,
      padding: t.cardPadding,
      cursor: o ? "pointer" : "default",
      display: "flex",
      gap: 12,
      alignItems: "flex-start",
      transition: "box-shadow 0.15s ease"
    },
    onMouseEnter: (n) => {
      o && (n.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.08)");
    },
    onMouseLeave: (n) => {
      n.currentTarget.style.boxShadow = "none";
    },
    children: [
      (e.previewImageUrl || e.brandLogoUrl) && /* @__PURE__ */ r(
        "div",
        {
          style: {
            width: t.brandLogoSize,
            height: t.brandLogoSize,
            borderRadius: t.brandLogoBorderRadius,
            overflow: "hidden",
            flexShrink: 0,
            backgroundColor: "#f9fafb"
          },
          children: /* @__PURE__ */ r(
            "img",
            {
              src: e.previewImageUrl || e.brandLogoUrl,
              alt: e.brandName,
              style: { width: "100%", height: "100%", objectFit: "contain" }
            }
          )
        }
      ),
      /* @__PURE__ */ m("div", { style: { flex: 1, minWidth: 0 }, children: [
        /* @__PURE__ */ m("div", { style: { display: "flex", alignItems: "center", gap: 8, marginBottom: 4 }, children: [
          /* @__PURE__ */ r(
            "span",
            {
              style: {
                fontSize: t.surveyBadgeFontSize,
                fontWeight: 600,
                padding: "2px 8px",
                borderRadius: 4,
                backgroundColor: t.surveyBadgeBgColor,
                color: t.surveyBadgeColor,
                whiteSpace: "nowrap"
              },
              children: "📋 Survey"
            }
          ),
          /* @__PURE__ */ r("span", { style: { fontSize: t.brandNameFontSize, color: t.brandNameColor }, children: e.brandName })
        ] }),
        /* @__PURE__ */ r(
          "div",
          {
            style: {
              fontSize: t.titleFontSize,
              fontWeight: Ve(t.titleFontWeight),
              color: t.titleColor,
              marginBottom: e.description ? 4 : 0
            },
            children: e.title
          }
        ),
        e.description && /* @__PURE__ */ r(
          "div",
          {
            style: {
              fontSize: t.descriptionFontSize,
              color: t.descriptionColor,
              lineHeight: 1.4,
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden"
            },
            children: e.description
          }
        ),
        /* @__PURE__ */ m("div", { style: { display: "flex", gap: 12, marginTop: 6 }, children: [
          e.estimatedMinutes && /* @__PURE__ */ m("span", { style: { fontSize: t.metaFontSize, color: t.metaColor }, children: [
            "~",
            e.estimatedMinutes,
            " min"
          ] }),
          e.questionCount && /* @__PURE__ */ m("span", { style: { fontSize: t.metaFontSize, color: t.metaColor }, children: [
            e.questionCount,
            " questions"
          ] })
        ] })
      ] }),
      /* @__PURE__ */ m(
        "div",
        {
          style: {
            fontSize: t.rewardFontSize,
            fontWeight: Ve(t.rewardFontWeight),
            color: t.rewardColor,
            backgroundColor: t.rewardBgColor,
            padding: "6px 10px",
            borderRadius: t.rewardBorderRadius,
            whiteSpace: "nowrap",
            flexShrink: 0
          },
          children: [
            "+",
            Do(e.rewardAmount)
          ]
        }
      )
    ]
  }
), Gi = ({
  widgetId: e,
  displayName: t = "Surveys",
  surveys: o,
  isLoading: n = !1,
  error: a,
  onSurveyClick: l,
  headerText: d,
  showHeader: p = !0,
  emptyMessage: c = "No surveys available right now",
  className: u,
  children: s
}) => {
  const {
    state: g,
    handleEditChange: y,
    handleSave: k,
    isSaving: f,
    themeColors: b,
    themeFonts: h,
    canSave: w
  } = q(
    e,
    Wo,
    Xt
  );
  if (s)
    return /* @__PURE__ */ r(G, { children: s(g, o) });
  if (n)
    return /* @__PURE__ */ r(
      "div",
      {
        className: u,
        style: {
          maxWidth: g.maxWidth,
          padding: `${g.paddingY}px ${g.paddingX}px`,
          textAlign: "center"
        },
        children: /* @__PURE__ */ r("div", { style: { fontSize: g.emptyTextFontSize, color: g.emptyTextColor }, children: "Finding available surveys..." })
      }
    );
  if (a)
    return /* @__PURE__ */ r(
      "div",
      {
        className: u,
        style: {
          maxWidth: g.maxWidth,
          padding: `${g.paddingY}px ${g.paddingX}px`,
          textAlign: "center"
        },
        children: /* @__PURE__ */ r("div", { style: { fontSize: g.emptyTextFontSize, color: "#ef4444" }, children: a })
      }
    );
  if (o.length === 0)
    return /* @__PURE__ */ m(
      "div",
      {
        className: u,
        style: {
          maxWidth: g.maxWidth,
          padding: `${g.paddingY}px ${g.paddingX}px`,
          textAlign: "center"
        },
        children: [
          /* @__PURE__ */ r(Ta, { size: g.emptyIconSize, color: g.emptyTextColor }),
          /* @__PURE__ */ r("div", { style: { fontSize: g.emptyTextFontSize, color: g.emptyTextColor, marginTop: 12 }, children: c })
        ]
      }
    );
  const B = o.reduce((z, O) => z + O.rewardAmount, 0), T = d || `${o.length} Survey${o.length !== 1 ? "s" : ""} (${Do(B)} potential)`, S = /* @__PURE__ */ m(
    "div",
    {
      className: u,
      style: {
        maxWidth: g.maxWidth,
        padding: `${g.paddingY}px ${g.paddingX}px`,
        backgroundColor: g.backgroundColor,
        borderRadius: g.borderRadius
      },
      children: [
        p && /* @__PURE__ */ r(
          "h3",
          {
            style: {
              fontSize: g.headerFontSize,
              fontWeight: Ve(g.headerFontWeight),
              color: g.headerColor,
              marginBottom: g.headerMarginBottom,
              margin: 0,
              marginBlockEnd: g.headerMarginBottom
            },
            children: T
          }
        ),
        /* @__PURE__ */ r("div", { style: { display: "flex", flexDirection: "column", gap: g.cardGap }, children: o.map((z) => /* @__PURE__ */ r(
          Ea,
          {
            survey: z,
            state: g,
            onClick: l ? () => l(z) : void 0
          },
          z.campaignId
        )) })
      ]
    }
  );
  return /* @__PURE__ */ r(
    K,
    {
      widgetId: e,
      displayName: t,
      editFields: Xt,
      editValues: g,
      onEditChange: y,
      onSave: w ? k : void 0,
      isSaving: f,
      themeColors: b,
      themeFonts: h,
      children: S
    }
  );
}, Ut = {
  bg: "rgba(162, 34, 114, 0.3)",
  text: "rgb(162, 34, 114)"
}, Pa = "https://media.brandclub.com/brandclub/image_asset/survey-reward-icon.webp", Ia = (e) => `$${e.toFixed(2)}`, Ma = (e) => `https://media.brandclub.com/b/428x428/${e}.jpg`, Aa = ({
  size: e = 40,
  color: t = "#9ca3af"
}) => /* @__PURE__ */ m(
  "svg",
  {
    width: e,
    height: e,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ r(
        "path",
        {
          d: "M9 5H7C5.89543 5 5 5.89543 5 7V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V7C19 5.89543 18.1046 5 17 5H15",
          stroke: t,
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ r(
        "path",
        {
          d: "M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5C15 6.10457 14.1046 7 13 7H11C9.89543 7 9 6.10457 9 5Z",
          stroke: t,
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ r(
        "path",
        {
          d: "M9 12H15",
          stroke: t,
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ r(
        "path",
        {
          d: "M9 16H13",
          stroke: t,
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
), Qi = ({
  survey: e,
  state: t,
  onClick: o,
  className: n,
  width: a = 280
}) => {
  const [l, d] = N(!1);
  ({ ...Wo, ...t });
  const p = () => {
    o ? o() : window.location.href = `/survey/${e.campaignId}`;
  }, c = e.brandLogoUrl || (e.brandId ? Ma(e.brandId) : void 0), u = !!c;
  return /* @__PURE__ */ m(
    "div",
    {
      className: n,
      onClick: p,
      onMouseEnter: () => d(!0),
      onMouseLeave: () => d(!1),
      style: {
        width: typeof a == "number" ? `${a}px` : a,
        backgroundColor: "#ffffff",
        border: "1px solid #e5e7eb",
        borderRadius: 16,
        overflow: "hidden",
        cursor: "pointer",
        transition: "all 0.2s ease",
        boxShadow: l ? "0 2px 8px rgba(0,0,0,0.06)" : "none",
        display: "flex",
        flexDirection: "column"
      },
      children: [
        /* @__PURE__ */ r(
          "div",
          {
            style: {
              height: 160,
              backgroundColor: "#ffffff",
              borderBottom: "1px solid #e5e7eb",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: 20
            },
            children: u ? /* @__PURE__ */ r(
              "img",
              {
                src: c,
                alt: e.brandName,
                style: {
                  maxWidth: "100%",
                  maxHeight: "100%",
                  objectFit: "contain"
                }
              }
            ) : /* @__PURE__ */ r(Aa, { size: 48, color: "#d1d5db" })
          }
        ),
        /* @__PURE__ */ m(
          "div",
          {
            style: {
              padding: 16,
              display: "flex",
              flexDirection: "column",
              backgroundColor: "#f9fafb"
            },
            children: [
              /* @__PURE__ */ r(
                "div",
                {
                  style: {
                    fontSize: 15,
                    fontWeight: 600,
                    color: "#111827",
                    lineHeight: 1.4,
                    marginBottom: 6,
                    height: 42,
                    // Fixed height for 2 lines (15px * 1.4 * 2)
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden"
                  },
                  children: e.title
                }
              ),
              /* @__PURE__ */ r(
                "div",
                {
                  style: {
                    fontSize: 13,
                    color: "#6b7280",
                    lineHeight: 1.5,
                    marginBottom: 12,
                    height: 20,
                    // Fixed height for 1 line
                    display: "-webkit-box",
                    WebkitLineClamp: 1,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden"
                  },
                  children: e.description || `Share your feedback with ${e.brandName}.`
                }
              ),
              /* @__PURE__ */ m(
                "div",
                {
                  style: {
                    display: "flex",
                    alignItems: "center",
                    gap: 7
                  },
                  children: [
                    /* @__PURE__ */ m(
                      "div",
                      {
                        style: {
                          display: "flex",
                          alignItems: "center",
                          gap: 6,
                          backgroundColor: Ut.bg,
                          color: Ut.text,
                          borderRadius: 25,
                          padding: "5px 13px",
                          fontSize: 14,
                          fontWeight: 600
                        },
                        children: [
                          /* @__PURE__ */ r(
                            "img",
                            {
                              src: Pa,
                              alt: "survey-reward-icon",
                              style: {
                                width: 14,
                                height: 14,
                                objectFit: "contain"
                              }
                            }
                          ),
                          /* @__PURE__ */ r("span", { children: Ia(e.rewardAmount) })
                        ]
                      }
                    ),
                    /* @__PURE__ */ r(
                      "span",
                      {
                        style: {
                          fontSize: 14,
                          fontWeight: 600,
                          color: "#181d56"
                        },
                        children: "survey reward"
                      }
                    )
                  ]
                }
              )
            ]
          }
        )
      ]
    }
  );
}, Na = {
  // Container
  maxWidth: 600,
  paddingX: 0,
  paddingY: 0,
  backgroundColor: "transparent",
  borderRadius: 0,
  // Header
  headerFontSize: 16,
  headerFontWeight: "semibold",
  headerColor: "#1a1a1a",
  headerMarginBottom: 12,
  // Card styling
  cardBgColor: "#ffffff",
  cardBorderColor: "#e5e7eb",
  cardBorderWidth: 1,
  cardBorderRadius: 12,
  cardPadding: 16,
  cardGap: 12,
  // Type badge
  typeBadgeFontSize: 11,
  typeBadgePaddingX: 8,
  typeBadgePaddingY: 4,
  typeBadgeBorderRadius: 4,
  surveyBadgeBgColor: "#dbeafe",
  surveyBadgeTextColor: "#1d4ed8",
  contentBadgeBgColor: "#fce7f3",
  contentBadgeTextColor: "#be185d",
  membershipBadgeBgColor: "#d1fae5",
  membershipBadgeTextColor: "#047857",
  reviewBadgeBgColor: "#fef3c7",
  reviewBadgeTextColor: "#b45309",
  referralBadgeBgColor: "#e0e7ff",
  referralBadgeTextColor: "#4338ca",
  affiliateBadgeBgColor: "#f3e8ff",
  affiliateBadgeTextColor: "#7c3aed",
  // Content
  titleFontSize: 15,
  titleFontWeight: "semibold",
  titleColor: "#1a1a1a",
  descriptionFontSize: 13,
  descriptionColor: "#6b7280",
  brandNameFontSize: 13,
  brandNameColor: "#6b7280",
  // Reward amount
  rewardFontSize: 14,
  rewardFontWeight: "bold",
  rewardColor: "#059669",
  rewardBgColor: "#ecfdf5",
  rewardBorderRadius: 6,
  // Brand logo
  brandLogoSize: 40,
  // Empty state
  emptyIconSize: 48,
  emptyTextFontSize: 14,
  emptyTextColor: "#6b7280"
}, Ke = (e) => ({
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700
})[e] || 500, Lo = (e) => `$${e.toFixed(2)}`, Ha = {
  survey: "📋 Survey",
  content: "🎬 Content",
  membership: "🏆 Club",
  review: "⭐ Review",
  referral: "👥 Referral",
  affiliate: "🔗 Affiliate"
}, Oa = ({ size: e, color: t }) => /* @__PURE__ */ m("svg", { width: e, height: e, viewBox: "0 0 24 24", fill: "none", stroke: t, strokeWidth: "2", children: [
  /* @__PURE__ */ r("rect", { x: "3", y: "8", width: "18", height: "4", rx: "1", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ r("path", { d: "M12 8V21", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ r("path", { d: "M19 12V20C19 20.5523 18.5523 21 18 21H6C5.44772 21 5 20.5523 5 20V12", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ r("path", { d: "M7.5 8C6.67157 8 6 7.32843 6 6.5C6 5.67157 6.67157 5 7.5 5C9.5 5 12 8 12 8C12 8 14.5 5 16.5 5C17.3284 5 18 5.67157 18 6.5C18 7.32843 17.3284 8 16.5 8", strokeLinecap: "round", strokeLinejoin: "round" })
] }), Ra = ({ type: e, state: t }) => {
  const n = ((a) => {
    switch (a) {
      case "survey":
        return { bg: t.surveyBadgeBgColor, text: t.surveyBadgeTextColor };
      case "content":
        return { bg: t.contentBadgeBgColor, text: t.contentBadgeTextColor };
      case "membership":
        return { bg: t.membershipBadgeBgColor, text: t.membershipBadgeTextColor };
      case "review":
        return { bg: t.reviewBadgeBgColor, text: t.reviewBadgeTextColor };
      case "referral":
        return { bg: t.referralBadgeBgColor, text: t.referralBadgeTextColor };
      case "affiliate":
        return { bg: t.affiliateBadgeBgColor, text: t.affiliateBadgeTextColor };
      default:
        return { bg: "#f3f4f6", text: "#374151" };
    }
  })(e);
  return /* @__PURE__ */ r(
    "span",
    {
      style: {
        fontSize: t.typeBadgeFontSize,
        fontWeight: 600,
        padding: `${t.typeBadgePaddingY}px ${t.typeBadgePaddingX}px`,
        borderRadius: t.typeBadgeBorderRadius,
        backgroundColor: n.bg,
        color: n.text,
        whiteSpace: "nowrap"
      },
      children: Ha[e] || e
    }
  );
}, Wa = ({ opportunity: e, state: t, onClick: o }) => /* @__PURE__ */ m(
  "div",
  {
    onClick: o,
    style: {
      backgroundColor: t.cardBgColor,
      border: `${t.cardBorderWidth}px solid ${t.cardBorderColor}`,
      borderRadius: t.cardBorderRadius,
      padding: t.cardPadding,
      cursor: o ? "pointer" : "default",
      display: "flex",
      gap: 12,
      alignItems: "flex-start",
      transition: "box-shadow 0.15s ease"
    },
    onMouseEnter: (n) => {
      o && (n.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.08)");
    },
    onMouseLeave: (n) => {
      n.currentTarget.style.boxShadow = "none";
    },
    children: [
      e.brandLogoUrl && /* @__PURE__ */ r(
        "div",
        {
          style: {
            width: t.brandLogoSize,
            height: t.brandLogoSize,
            borderRadius: 8,
            overflow: "hidden",
            flexShrink: 0,
            backgroundColor: "#f9fafb"
          },
          children: /* @__PURE__ */ r(
            "img",
            {
              src: e.brandLogoUrl,
              alt: e.brandName,
              style: { width: "100%", height: "100%", objectFit: "contain" }
            }
          )
        }
      ),
      /* @__PURE__ */ m("div", { style: { flex: 1, minWidth: 0 }, children: [
        /* @__PURE__ */ m("div", { style: { display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }, children: [
          /* @__PURE__ */ r(Ra, { type: e.type, state: t }),
          /* @__PURE__ */ r("span", { style: { fontSize: t.brandNameFontSize, color: t.brandNameColor }, children: e.brandName })
        ] }),
        /* @__PURE__ */ r(
          "div",
          {
            style: {
              fontSize: t.titleFontSize,
              fontWeight: Ke(t.titleFontWeight),
              color: t.titleColor,
              marginBottom: e.description ? 4 : 0
            },
            children: e.title
          }
        ),
        e.description && /* @__PURE__ */ r(
          "div",
          {
            style: {
              fontSize: t.descriptionFontSize,
              color: t.descriptionColor,
              lineHeight: 1.4,
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden"
            },
            children: e.description
          }
        ),
        e.estimatedMinutes && /* @__PURE__ */ m(
          "div",
          {
            style: {
              fontSize: t.descriptionFontSize,
              color: t.descriptionColor,
              marginTop: 4
            },
            children: [
              "~",
              e.estimatedMinutes,
              " min"
            ]
          }
        )
      ] }),
      /* @__PURE__ */ m(
        "div",
        {
          style: {
            fontSize: t.rewardFontSize,
            fontWeight: Ke(t.rewardFontWeight),
            color: t.rewardColor,
            backgroundColor: t.rewardBgColor,
            padding: "6px 10px",
            borderRadius: t.rewardBorderRadius,
            whiteSpace: "nowrap",
            flexShrink: 0
          },
          children: [
            "+",
            Lo(e.rewardAmount)
          ]
        }
      )
    ]
  }
), $i = ({
  widgetId: e,
  opportunities: t,
  isLoading: o = !1,
  error: n,
  onOpportunityClick: a,
  headerText: l,
  showHeader: d = !0,
  emptyMessage: p = "No reward opportunities available",
  className: c,
  children: u
}) => {
  const { state: s } = q(
    e,
    Na,
    []
    // No edit fields for now
  );
  if (u)
    return /* @__PURE__ */ r(G, { children: u(s, t) });
  if (o)
    return /* @__PURE__ */ r(
      "div",
      {
        className: c,
        style: {
          maxWidth: s.maxWidth,
          padding: `${s.paddingY}px ${s.paddingX}px`,
          textAlign: "center"
        },
        children: /* @__PURE__ */ r("div", { style: { fontSize: s.emptyTextFontSize, color: s.emptyTextColor }, children: "Finding reward opportunities..." })
      }
    );
  if (n)
    return /* @__PURE__ */ r(
      "div",
      {
        className: c,
        style: {
          maxWidth: s.maxWidth,
          padding: `${s.paddingY}px ${s.paddingX}px`,
          textAlign: "center"
        },
        children: /* @__PURE__ */ r("div", { style: { fontSize: s.emptyTextFontSize, color: "#ef4444" }, children: n })
      }
    );
  if (t.length === 0)
    return /* @__PURE__ */ m(
      "div",
      {
        className: c,
        style: {
          maxWidth: s.maxWidth,
          padding: `${s.paddingY}px ${s.paddingX}px`,
          textAlign: "center"
        },
        children: [
          /* @__PURE__ */ r(Oa, { size: s.emptyIconSize, color: s.emptyTextColor }),
          /* @__PURE__ */ r("div", { style: { fontSize: s.emptyTextFontSize, color: s.emptyTextColor, marginTop: 12 }, children: p })
        ]
      }
    );
  const g = t.reduce((k, f) => k + f.rewardAmount, 0), y = l || `${t.length} Reward Opportunity${t.length !== 1 ? "s" : ""} (${Lo(g)} potential)`;
  return /* @__PURE__ */ m(
    "div",
    {
      className: c,
      style: {
        maxWidth: s.maxWidth,
        padding: `${s.paddingY}px ${s.paddingX}px`,
        backgroundColor: s.backgroundColor,
        borderRadius: s.borderRadius
      },
      children: [
        d && /* @__PURE__ */ r(
          "h3",
          {
            style: {
              fontSize: s.headerFontSize,
              fontWeight: Ke(s.headerFontWeight),
              color: s.headerColor,
              marginBottom: s.headerMarginBottom,
              margin: 0,
              marginBlockEnd: s.headerMarginBottom
            },
            children: y
          }
        ),
        /* @__PURE__ */ r("div", { style: { display: "flex", flexDirection: "column", gap: s.cardGap }, children: t.map((k) => /* @__PURE__ */ r(
          Wa,
          {
            opportunity: k,
            state: s,
            onClick: a ? () => a(k) : void 0
          },
          k.id || k.campaignId || `${k.type}-${k.title}`
        )) })
      ]
    }
  );
}, Da = {
  // Container
  maxWidth: 900,
  paddingX: 0,
  paddingY: 0,
  backgroundColor: "transparent",
  borderRadius: 0,
  // Header
  headerFontSize: 18,
  headerFontWeight: "semibold",
  headerColor: "#1a1a1a",
  headerMarginBottom: 16,
  // Product card
  cardBgColor: "#ffffff",
  cardBorderColor: "#e5e7eb",
  cardBorderWidth: 1,
  cardBorderRadius: 12,
  cardPadding: 12,
  cardGap: 12,
  // Product image
  imageSize: 120,
  imageBorderRadius: 8,
  // Product title
  titleFontSize: 14,
  titleFontWeight: "semibold",
  titleColor: "#1a1a1a",
  titleMaxLines: 2,
  // Brand name
  brandFontSize: 12,
  brandColor: "#6b7280",
  // Price
  priceFontSize: 16,
  priceFontWeight: "bold",
  priceColor: "#1a1a1a",
  // Reward
  rewardFontSize: 12,
  rewardColor: "#059669",
  rewardBgColor: "#ecfdf5",
  // Rating
  ratingStarSize: 14,
  ratingStarColor: "#f59e0b",
  ratingStarEmptyColor: "#d1d5db",
  ratingTextFontSize: 12,
  ratingTextColor: "#6b7280",
  // Comparison table
  rowBgColor: "#ffffff",
  rowBgColorAlt: "#f9fafb",
  rowBorderColor: "#e5e7eb",
  labelFontSize: 13,
  labelFontWeight: "medium",
  labelColor: "#374151",
  valueFontSize: 13,
  valueColor: "#1a1a1a",
  // Highlight
  highlightBgColor: "#ecfdf5",
  highlightBorderColor: "#10b981",
  // Empty state
  emptyTextFontSize: 14,
  emptyTextColor: "#6b7280"
}, Ne = (e) => ({
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700
})[e] || 500, _e = (e) => `$${e.toFixed(2)}`, La = ({ rating: e, maxRating: t = 5, starSize: o, starColor: n, emptyColor: a }) => {
  const l = [];
  for (let d = 1; d <= t; d++) {
    const p = Math.min(Math.max(e - d + 1, 0), 1) * 100;
    l.push(
      /* @__PURE__ */ m("svg", { width: o, height: o, viewBox: "0 0 24 24", children: [
        /* @__PURE__ */ r("defs", { children: /* @__PURE__ */ m("linearGradient", { id: `star-fill-${d}-${e}`, children: [
          /* @__PURE__ */ r("stop", { offset: `${p}%`, stopColor: n }),
          /* @__PURE__ */ r("stop", { offset: `${p}%`, stopColor: a })
        ] }) }),
        /* @__PURE__ */ r(
          "path",
          {
            fill: `url(#star-fill-${d}-${e})`,
            d: "M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
          }
        )
      ] }, d)
    );
  }
  return /* @__PURE__ */ r("div", { style: { display: "flex", gap: 2 }, children: l });
}, ja = ({ size: e, color: t }) => /* @__PURE__ */ r("svg", { width: e, height: e, viewBox: "0 0 24 24", fill: "none", stroke: t, strokeWidth: "1.5", children: /* @__PURE__ */ r("path", { d: "M16.5 9.4L7.5 4.21M21 16V8C20.9996 7.6481 20.9071 7.3024 20.7315 6.99847C20.556 6.69454 20.3037 6.44327 20 6.27L13 2.27C12.696 2.09674 12.3511 2.0053 12 2.0053C11.6489 2.0053 11.304 2.09674 11 2.27L4 6.27C3.69626 6.44327 3.44398 6.69454 3.26846 6.99847C3.09294 7.3024 3.00036 7.6481 3 8V16C3.00036 16.3519 3.09294 16.6976 3.26846 17.0015C3.44398 17.3055 3.69626 17.5567 4 17.73L11 21.73C11.304 21.9033 11.6489 21.9947 12 21.9947C12.3511 21.9947 12.696 21.9033 13 21.73L20 17.73C20.3037 17.5567 20.556 17.3055 20.7315 17.0015C20.9071 16.6976 20.9996 16.3519 21 16Z", strokeLinecap: "round", strokeLinejoin: "round" }) }), Ga = ({
  product: e,
  state: t,
  onClick: o,
  onAddToCart: n,
  showAddToCart: a
}) => /* @__PURE__ */ m(
  "div",
  {
    style: {
      flex: 1,
      minWidth: 150,
      maxWidth: 220,
      backgroundColor: t.cardBgColor,
      border: `${t.cardBorderWidth}px solid ${t.cardBorderColor}`,
      borderRadius: t.cardBorderRadius,
      padding: t.cardPadding,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: 8,
      cursor: o ? "pointer" : "default"
    },
    onClick: o,
    children: [
      /* @__PURE__ */ r(
        "div",
        {
          style: {
            width: t.imageSize,
            height: t.imageSize,
            borderRadius: t.imageBorderRadius,
            overflow: "hidden",
            backgroundColor: "#f3f4f6",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          },
          children: e.imageUrl ? /* @__PURE__ */ r(
            "img",
            {
              src: e.imageUrl,
              alt: e.title,
              style: { width: "100%", height: "100%", objectFit: "contain" }
            }
          ) : /* @__PURE__ */ r(ja, { size: t.imageSize * 0.4, color: "#9ca3af" })
        }
      ),
      e.brand && /* @__PURE__ */ r("div", { style: { fontSize: t.brandFontSize, color: t.brandColor }, children: e.brand }),
      /* @__PURE__ */ r(
        "div",
        {
          style: {
            fontSize: t.titleFontSize,
            fontWeight: Ne(t.titleFontWeight),
            color: t.titleColor,
            textAlign: "center",
            display: "-webkit-box",
            WebkitLineClamp: t.titleMaxLines,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            lineHeight: 1.3
          },
          children: e.title
        }
      ),
      /* @__PURE__ */ r(
        "div",
        {
          style: {
            fontSize: t.priceFontSize,
            fontWeight: Ne(t.priceFontWeight),
            color: t.priceColor
          },
          children: _e(e.price)
        }
      ),
      e.rewardAmount && e.rewardAmount > 0 && /* @__PURE__ */ m(
        "div",
        {
          style: {
            fontSize: t.rewardFontSize,
            color: t.rewardColor,
            backgroundColor: t.rewardBgColor,
            padding: "4px 8px",
            borderRadius: 4
          },
          children: [
            "+",
            _e(e.rewardAmount),
            " reward"
          ]
        }
      ),
      e.reviewsRating !== void 0 && /* @__PURE__ */ m("div", { style: { display: "flex", alignItems: "center", gap: 4 }, children: [
        /* @__PURE__ */ r(
          La,
          {
            rating: e.reviewsRating,
            starSize: t.ratingStarSize,
            starColor: t.ratingStarColor,
            emptyColor: t.ratingStarEmptyColor
          }
        ),
        e.reviewsCount !== void 0 && /* @__PURE__ */ m("span", { style: { fontSize: t.ratingTextFontSize, color: t.ratingTextColor }, children: [
          "(",
          e.reviewsCount,
          ")"
        ] })
      ] }),
      a && n && /* @__PURE__ */ r(
        "button",
        {
          onClick: (l) => {
            l.stopPropagation(), n();
          },
          style: {
            marginTop: 8,
            padding: "8px 16px",
            fontSize: 13,
            fontWeight: 600,
            color: "#ffffff",
            backgroundColor: "#1a1a1a",
            border: "none",
            borderRadius: 6,
            cursor: "pointer",
            width: "100%"
          },
          children: "Add to Cart"
        }
      )
    ]
  }
), Qa = (e) => {
  const t = /* @__PURE__ */ new Set();
  return e.forEach((o) => {
    o.attributes && Object.keys(o.attributes).forEach((n) => t.add(n));
  }), Array.from(t).map((o) => ({
    key: o,
    label: o.charAt(0).toUpperCase() + o.slice(1).replace(/([A-Z])/g, " $1"),
    format: "text"
  }));
}, Yi = ({
  widgetId: e,
  products: t,
  attributes: o,
  isLoading: n = !1,
  error: a,
  onProductClick: l,
  onAddToCart: d,
  showAddToCart: p = !1,
  headerText: c,
  showHeader: u = !0,
  className: s,
  children: g
}) => {
  const { state: y } = q(
    e,
    Da,
    []
    // No edit fields for now
  );
  if (g)
    return /* @__PURE__ */ r(G, { children: g(y, t) });
  if (n)
    return /* @__PURE__ */ r(
      "div",
      {
        className: s,
        style: {
          maxWidth: y.maxWidth,
          padding: `${y.paddingY}px ${y.paddingX}px`,
          textAlign: "center"
        },
        children: /* @__PURE__ */ r("div", { style: { fontSize: y.emptyTextFontSize, color: y.emptyTextColor }, children: "Comparing products..." })
      }
    );
  if (a)
    return /* @__PURE__ */ r(
      "div",
      {
        className: s,
        style: {
          maxWidth: y.maxWidth,
          padding: `${y.paddingY}px ${y.paddingX}px`,
          textAlign: "center"
        },
        children: /* @__PURE__ */ r("div", { style: { fontSize: y.emptyTextFontSize, color: "#ef4444" }, children: a })
      }
    );
  if (t.length < 2)
    return /* @__PURE__ */ r(
      "div",
      {
        className: s,
        style: {
          maxWidth: y.maxWidth,
          padding: `${y.paddingY}px ${y.paddingX}px`,
          textAlign: "center"
        },
        children: /* @__PURE__ */ r("div", { style: { fontSize: y.emptyTextFontSize, color: y.emptyTextColor }, children: "At least 2 products are needed for comparison" })
      }
    );
  const k = o || Qa(t), f = c || `Comparing ${t.length} Products`;
  return /* @__PURE__ */ m(
    "div",
    {
      className: s,
      style: {
        maxWidth: y.maxWidth,
        padding: `${y.paddingY}px ${y.paddingX}px`,
        backgroundColor: y.backgroundColor,
        borderRadius: y.borderRadius,
        overflowX: "auto"
      },
      children: [
        u && /* @__PURE__ */ r(
          "h3",
          {
            style: {
              fontSize: y.headerFontSize,
              fontWeight: Ne(y.headerFontWeight),
              color: y.headerColor,
              marginBottom: y.headerMarginBottom,
              margin: 0,
              marginBlockEnd: y.headerMarginBottom
            },
            children: f
          }
        ),
        /* @__PURE__ */ r(
          "div",
          {
            style: {
              display: "flex",
              gap: y.cardGap,
              marginBottom: k.length > 0 ? 16 : 0
            },
            children: t.map((b) => /* @__PURE__ */ r(
              Ga,
              {
                product: b,
                state: y,
                onClick: l ? () => l(b) : void 0,
                onAddToCart: d ? () => d(b) : void 0,
                showAddToCart: p
              },
              b.stacklineSku
            ))
          }
        ),
        k.length > 0 && /* @__PURE__ */ r(
          "div",
          {
            style: {
              border: `1px solid ${y.rowBorderColor}`,
              borderRadius: 8,
              overflow: "hidden"
            },
            children: k.map((b, h) => /* @__PURE__ */ m(
              "div",
              {
                style: {
                  display: "flex",
                  backgroundColor: h % 2 === 0 ? y.rowBgColor : y.rowBgColorAlt,
                  borderBottom: h < k.length - 1 ? `1px solid ${y.rowBorderColor}` : "none"
                },
                children: [
                  /* @__PURE__ */ r(
                    "div",
                    {
                      style: {
                        width: 120,
                        flexShrink: 0,
                        padding: "10px 12px",
                        fontSize: y.labelFontSize,
                        fontWeight: Ne(y.labelFontWeight),
                        color: y.labelColor,
                        borderRight: `1px solid ${y.rowBorderColor}`
                      },
                      children: b.label
                    }
                  ),
                  t.map((w) => {
                    var S;
                    const B = (S = w.attributes) == null ? void 0 : S[b.key];
                    let T = "-";
                    return B != null && (b.format === "currency" && typeof B == "number" ? T = _e(B) : b.format === "boolean" ? T = B ? "✓" : "✗" : T = String(B)), /* @__PURE__ */ r(
                      "div",
                      {
                        style: {
                          flex: 1,
                          minWidth: 150,
                          maxWidth: 220,
                          padding: "10px 12px",
                          fontSize: y.valueFontSize,
                          color: y.valueColor,
                          textAlign: "center",
                          borderRight: `1px solid ${y.rowBorderColor}`
                        },
                        children: T
                      },
                      w.stacklineSku
                    );
                  })
                ]
              },
              b.key
            ))
          }
        )
      ]
    }
  );
}, $a = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const o = document.createElement("link");
  o.rel = "stylesheet", o.href = e, document.head.appendChild(o);
}, Ya = {
  content: "Default Text",
  fontFamily: "inherit",
  fontSize: 16,
  fontWeight: "medium",
  color: {
    type: "theme",
    value: "textPrimary"
  },
  textAlign: "left",
  lineHeight: 1.5,
  letterSpacing: 0,
  textTransform: "none"
}, Zt = [
  { key: "content", label: "Text Content", type: "text" },
  { key: "fontFamily", label: "Font Family", type: "font" },
  {
    key: "fontSize",
    label: "Font Size (px)",
    type: "number",
    min: 12,
    max: 72,
    step: 1
  },
  {
    key: "fontWeight",
    label: "Font Weight",
    type: "options",
    options: V
  },
  { key: "color", label: "Text Color", type: "color" },
  {
    key: "textAlign",
    label: "Text Alignment",
    type: "options",
    options: [
      { label: "Left", value: "left" },
      { label: "Center", value: "center" },
      { label: "Right", value: "right" }
    ]
  },
  {
    key: "lineHeight",
    label: "Line Height",
    type: "number",
    min: 1,
    max: 3,
    step: 0.1
  },
  {
    key: "letterSpacing",
    label: "Letter Spacing (px)",
    type: "number",
    min: -2,
    max: 5,
    step: 0.5
  },
  {
    key: "textTransform",
    label: "Text Transform",
    type: "options",
    options: [
      { label: "None", value: "none" },
      { label: "Uppercase", value: "uppercase" },
      { label: "Lowercase", value: "lowercase" },
      { label: "Capitalize", value: "capitalize" }
    ]
  }
], Ji = ({
  initialState: e = {},
  widgetId: t,
  displayName: o
}) => {
  const {
    state: n,
    isLoading: a,
    isSaving: l,
    handleEditChange: d,
    handleSave: p,
    themeColors: c,
    themeFonts: u,
    resolveColor: s,
    canSave: g
  } = q(
    t,
    { ...Ya, ...e },
    Zt
  ), y = n.fontFamily, k = y && y !== "inherit" ? u[y] : null, f = k && k.format === "google" ? k.url : null;
  if ($(() => {
    f && $a(f);
  }, [f]), a)
    return /* @__PURE__ */ r(G, {});
  const b = (z) => {
    const O = {
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700
    }, R = parseInt(z, 10);
    return isNaN(R) ? O[z] || 500 : R;
  }, h = k ? k.format === "system" ? k.url : `"${k.name}", sans-serif` : "inherit", w = `textbox-${t || "default"}`, T = `
    ${k && k.format !== "system" && k.format !== "google" ? `
      @font-face {
        font-family: "${k.name}";
        src: url("${k.url}") format("${k.format}");
        font-display: swap;
      }
    ` : ""}
    ${h !== "inherit" ? `.${w} { font-family: ${h} !important; }` : ""}
  `.trim(), S = /* @__PURE__ */ m(G, { children: [
    T && /* @__PURE__ */ r("style", { children: T }),
    /* @__PURE__ */ r(
      "span",
      {
        className: `textbox-content ${w}`,
        style: {
          // font-family is set via CSS class with !important, only use inline for inherit
          ...h === "inherit" ? { fontFamily: "inherit" } : {},
          fontSize: `${n.fontSize}px`,
          fontWeight: b(n.fontWeight),
          color: s(n.color),
          textAlign: n.textAlign,
          lineHeight: n.lineHeight,
          letterSpacing: `${n.letterSpacing}px`,
          textTransform: n.textTransform,
          display: "inline-block",
          width: "100%"
        },
        children: n.content
      }
    )
  ] });
  return /* @__PURE__ */ r(
    K,
    {
      widgetId: t,
      displayName: o,
      editFields: Zt,
      editValues: n,
      onEditChange: d,
      onSave: g ? p : void 0,
      isSaving: l,
      themeColors: c,
      themeFonts: u,
      children: S
    }
  );
}, qt = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const o = document.createElement("link");
  o.rel = "stylesheet", o.href = e, document.head.appendChild(o);
}, Ja = {
  // Instant reward (DailyDeals) - orange
  instantBgColor: M("rgba(236, 121, 46, 0.3)"),
  instantTextColor: M("rgb(236, 121, 46)"),
  // Purchase reward - magenta
  purchaseBgColor: M("rgba(162, 34, 114, 0.3)"),
  purchaseTextColor: M("rgb(162, 34, 114)"),
  // Affiliate reward - teal
  affiliateBgColor: M("rgba(22, 148, 155, 0.2)"),
  affiliateTextColor: M("rgb(22, 148, 155)"),
  // Content/Survey reward - magenta
  contentBgColor: M("rgba(162, 34, 114, 0.3)"),
  contentTextColor: M("rgb(162, 34, 114)"),
  // Pill styling
  pillBorderRadius: 25,
  pillPaddingMultiplier: 0.95,
  // Icon
  iconSizeMultiplier: 1,
  iconMarginMultiplier: 0.416,
  // Text
  pillFontWeight: "semibold",
  pillFontFamily: "inherit",
  subfixTextColor: P("textPrimary"),
  subfixFontWeight: "semibold",
  subfixFontFamily: "inherit",
  // Container
  containerGap: 7
}, Vt = [
  // Instant reward
  { key: "instantBgColor", label: "Instant Reward Background", type: "color" },
  { key: "instantTextColor", label: "Instant Reward Text", type: "color" },
  // Purchase reward
  {
    key: "purchaseBgColor",
    label: "Purchase Reward Background",
    type: "color"
  },
  { key: "purchaseTextColor", label: "Purchase Reward Text", type: "color" },
  // Affiliate reward
  {
    key: "affiliateBgColor",
    label: "Affiliate Reward Background",
    type: "color"
  },
  { key: "affiliateTextColor", label: "Affiliate Reward Text", type: "color" },
  // Content/Survey reward
  { key: "contentBgColor", label: "Content Reward Background", type: "color" },
  { key: "contentTextColor", label: "Content Reward Text", type: "color" },
  // Pill styling
  {
    key: "pillBorderRadius",
    label: "Pill Border Radius",
    type: "number",
    min: 0,
    max: 50,
    step: 2
  },
  {
    key: "pillPaddingMultiplier",
    label: "Pill Padding Multiplier",
    type: "number",
    min: 0.5,
    max: 1.5,
    step: 0.05
  },
  // Icon
  {
    key: "iconSizeMultiplier",
    label: "Icon Size Multiplier",
    type: "number",
    min: 0.5,
    max: 1.5,
    step: 0.1
  },
  {
    key: "iconMarginMultiplier",
    label: "Icon Margin Multiplier",
    type: "number",
    min: 0.2,
    max: 0.8,
    step: 0.05
  },
  // Text
  {
    key: "pillFontWeight",
    label: "Pill Font Weight",
    type: "options",
    options: [...V]
  },
  {
    key: "pillFontFamily",
    label: "Pill Font Family",
    type: "font"
  },
  { key: "subfixTextColor", label: "Subfix Text Color", type: "color" },
  {
    key: "subfixFontWeight",
    label: "Subfix Font Weight",
    type: "options",
    options: [...V]
  },
  {
    key: "subfixFontFamily",
    label: "Subfix Font Family",
    type: "font"
  },
  // Container
  {
    key: "containerGap",
    label: "Container Gap",
    type: "number",
    min: 4,
    max: 16,
    step: 1
  }
], Xi = ({
  initialState: e = {},
  widgetId: t,
  displayName: o,
  children: n
}) => {
  const {
    state: a,
    isLoading: l,
    isSaving: d,
    handleEditChange: p,
    handleSave: c,
    themeColors: u,
    themeFonts: s,
    resolveColor: g,
    canSave: y
  } = q(
    t,
    { ...Ja, ...e },
    Vt
  ), k = a.pillFontFamily, f = k && k !== "inherit" ? s[k] : null, b = a.subfixFontFamily, h = b && b !== "inherit" ? s[b] : null, w = f && f.format === "google" ? f.url : null, B = h && h.format === "google" ? h.url : null;
  if ($(() => {
    w && qt(w);
  }, [w]), $(() => {
    B && qt(B);
  }, [B]), l)
    return /* @__PURE__ */ r(G, {});
  const T = f ? f.format === "system" ? f.url : `"${f.name}", sans-serif` : "inherit", S = h ? h.format === "system" ? h.url : `"${h.name}", sans-serif` : "inherit", z = f && f.format !== "system" && f.format !== "google", O = h && h.format !== "system" && h.format !== "google", R = `reward-pill-${t || "default"}`, x = `
    ${z ? `
      @font-face {
        font-family: "${f.name}";
        src: url("${f.url}") format("${f.format}");
        font-display: swap;
      }
    ` : ""}
    ${O ? `
      @font-face {
        font-family: "${h.name}";
        src: url("${h.url}") format("${h.format}");
        font-display: swap;
      }
    ` : ""}
    ${T !== "inherit" ? `.${R} [data-pill-text] { font-family: ${T} !important; }` : ""}
    ${S !== "inherit" ? `.${R} [data-subfix-text] { font-family: ${S} !important; }` : ""}
  `.trim(), L = {
    ...a,
    pillFontFamilyCss: T,
    subfixFontFamilyCss: S
  }, Y = /* @__PURE__ */ m(G, { children: [
    x && /* @__PURE__ */ r("style", { children: x }),
    n(L, g)
  ] });
  return /* @__PURE__ */ r(
    K,
    {
      widgetId: t,
      displayName: o,
      editFields: Vt,
      editValues: a,
      onEditChange: p,
      onSave: y ? c : void 0,
      isSaving: d,
      themeColors: u,
      themeFonts: s,
      children: Y
    }
  );
}, Xa = {
  // Icon size
  iconSize: 18,
  iconSizeMobile: 15,
  // Overlap and spacing
  overlapRatio: 0.46,
  counterMarginLeft: 7,
  // Border styling
  iconBorderRadius: 50,
  // percentage - 50 = circle
  // Counter text
  counterTextColor: P("textPrimary"),
  counterFontSize: 11,
  counterFontWeight: "semibold",
  // Display limits
  maxVisibleIcons: 4
}, Kt = [
  // Icon size
  {
    key: "iconSize",
    label: "Icon Size",
    type: "number",
    min: 12,
    max: 32,
    step: 2
  },
  {
    key: "iconSizeMobile",
    label: "Icon Size (Mobile)",
    type: "number",
    min: 10,
    max: 24,
    step: 1
  },
  // Overlap and spacing
  {
    key: "overlapRatio",
    label: "Overlap Ratio",
    type: "number",
    min: 0,
    max: 0.7,
    step: 0.05
  },
  {
    key: "counterMarginLeft",
    label: "Counter Margin Left",
    type: "number",
    min: 0,
    max: 16,
    step: 1
  },
  // Border styling
  {
    key: "iconBorderRadius",
    label: "Icon Border Radius (%)",
    type: "number",
    min: 0,
    max: 50,
    step: 5
  },
  // Counter text
  { key: "counterTextColor", label: "Counter Text Color", type: "color" },
  {
    key: "counterFontSize",
    label: "Counter Font Size",
    type: "number",
    min: 8,
    max: 16,
    step: 1
  },
  {
    key: "counterFontWeight",
    label: "Counter Font Weight",
    type: "options",
    options: [...V]
  },
  // Display limits
  {
    key: "maxVisibleIcons",
    label: "Max Visible Icons",
    type: "number",
    min: 1,
    max: 8,
    step: 1
  }
], Ui = ({
  initialState: e = {},
  widgetId: t,
  displayName: o,
  children: n
}) => {
  const {
    state: a,
    isLoading: l,
    isSaving: d,
    handleEditChange: p,
    handleSave: c,
    themeColors: u,
    resolveColor: s,
    canSave: g
  } = q(
    t,
    { ...Xa, ...e },
    Kt
  );
  if (l)
    return /* @__PURE__ */ r(G, {});
  const y = n(a, s);
  return /* @__PURE__ */ r(
    K,
    {
      widgetId: t,
      displayName: o,
      editFields: Kt,
      editValues: a,
      onEditChange: p,
      onSave: g ? c : void 0,
      isSaving: d,
      themeColors: u,
      children: y
    }
  );
}, Pe = 60, _t = 420, eo = ({
  showSettings: e,
  viewMode: t,
  editorMode: o = "iframe"
}) => `
  /* Reset and base styles */
  .bc-theme-editor-shell {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999999;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  }

  .bc-theme-editor-shell * {
    box-sizing: border-box;
  }

  /* Top Bar */
  .bc-theme-editor-topbar {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: ${Pe}px;
    background: #f5f5f7;
    border-bottom: 1px solid ${i.border_glass};
    display: flex;
    align-items: center;
    padding: 0 20px;
    gap: 16px;
    z-index: 1000001;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  }

  /* Logo/Brand */
  .bc-theme-editor-logo {
    display: flex;
    align-items: center;
    gap: 10px;
    padding-right: 16px;
    border-right: 1px solid ${i.border_glass};
  }

  .bc-theme-editor-logo-icon {
    width: 32px;
    height: 32px;
    background: linear-gradient(135deg, ${i.blue_dark} 0%, #252b6e 100%);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
  }

  .bc-theme-editor-logo-text {
    font-size: 14px;
    font-weight: 600;
    color: ${i.primary};
    letter-spacing: -0.3px;
  }

  /* Theme ID */
  .bc-theme-editor-theme-info {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .bc-theme-editor-theme-label {
    font-size: 12px;
    color: ${i.gray_medium};
    font-weight: 500;
  }

  .bc-theme-editor-theme-id {
    font-size: 12px;
    font-family: 'SF Mono', 'Menlo', 'Monaco', 'Courier New', monospace;
    color: ${i.primary};
    background: ${i.white};
    padding: 6px 12px;
    border-radius: 8px;
    border: 1px solid ${i.border_glass};
  }

  .bc-theme-editor-live-indicator {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    font-weight: 600;
    color: #4caf50;
    margin-left: 8px;
  }

  .bc-theme-editor-live-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #4caf50;
  }

  /* Viewport Toggle */
  .bc-theme-editor-viewport-toggle {
    display: flex;
    background: ${i.white};
    border-radius: 10px;
    padding: 4px;
    margin-left: 16px;
    border: 1px solid ${i.border_glass};
    gap: 2px;
  }

  /* Spacer */
  .bc-theme-editor-spacer {
    flex: 1;
  }

  /* Action Buttons */
  .bc-theme-editor-actions {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-left: auto;
  }

  /* Preview Area */
  .bc-theme-editor-preview {
    position: fixed;
    top: ${Pe}px;
    left: 0;
    right: ${e ? _t : 0}px;
    bottom: 0;
    background: #e8e8ed;
    transition: right 0.3s ease;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    overflow: auto;
  }

  .bc-theme-editor-preview-container {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    padding: ${t === "mobile" ? "24px" : "0"};
    transition: padding 0.3s ease;
  }

  .bc-theme-editor-iframe-wrapper {
    width: ${t === "desktop" ? "100%" : "375px"};
    height: ${t === "desktop" ? "100%" : "calc(100% - 48px)"};
    background: white;
    transition: all 0.3s ease;
    ${t === "mobile" ? `
      border-radius: 24px;
      box-shadow: 0 25px 80px rgba(0, 0, 0, 0.25), 0 0 0 1px rgba(0, 0, 0, 0.05);
      overflow: hidden;
    ` : ""}
  }

  .bc-theme-editor-iframe {
    width: 100%;
    height: 100%;
    border: none;
    display: block;
  }

  /* Side Panel */
  @keyframes bc-slide-in {
    from {
      transform: translateX(100%);
    }
    to {
      transform: translateX(0);
    }
  }

  @keyframes bc-slide-out {
    from {
      transform: translateX(0);
    }
    to {
      transform: translateX(100%);
    }
  }

  .bc-theme-editor-sidepanel {
    position: fixed;
    top: ${Pe}px;
    right: 0;
    bottom: 0;
    width: ${_t}px;
    background: #fff;
    border-left: 1px solid ${i.border_subtle};
    z-index: 1000000;
    overflow-y: auto;
    animation: bc-slide-in 0.3s ease;
    box-shadow: -8px 0 32px rgba(0, 0, 0, 0.15);
  }

  .bc-theme-editor-sidepanel-header {
    position: sticky;
    top: 0;
    background: ${i.glass_bg_strong};
    backdrop-filter: blur(20px);
    padding: 20px 24px;
    border-bottom: 1px solid ${i.border_glass};
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 1;
  }

  .bc-theme-editor-sidepanel-title {
    font-size: 16px;
    font-weight: 600;
    color: ${i.primary};
    margin: 0;
  }

  .bc-theme-editor-sidepanel-close {
    width: 32px;
    height: 32px;
    border: none;
    background: ${i.overlay_light};
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    color: ${i.gray_medium};
    transition: all 0.15s ease;
  }

  .bc-theme-editor-sidepanel-close:hover {
    background: ${i.gray_light};
    color: ${i.primary};
  }

  .bc-theme-editor-sidepanel-content {
    padding: 24px;
  }

  /* Messages */
  .bc-theme-editor-message {
    padding: 12px 16px;
    border-radius: 10px;
    margin-bottom: 20px;
    font-size: 13px;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .bc-theme-editor-message-success {
    background: rgba(113, 194, 133, 0.15);
    color: ${i.green};
    border: 1px solid rgba(113, 194, 133, 0.3);
  }

  .bc-theme-editor-message-error {
    background: rgba(255, 83, 74, 0.1);
    color: ${i.red};
    border: 1px solid rgba(255, 83, 74, 0.2);
  }

  /* Sections */
  .bc-theme-editor-section {
    margin-bottom: 8px;
    background: ${i.white};
    border-radius: 12px;
    border: 1px solid ${i.border_glass};
    overflow: hidden;
  }

  .bc-theme-editor-section:last-child {
    margin-bottom: 0;
  }

  .bc-theme-editor-section-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 16px;
    cursor: pointer;
    transition: background 0.15s ease;
    user-select: none;
  }

  .bc-theme-editor-section-header:hover {
    background: ${i.bg_light};
  }

  .bc-theme-editor-section-title {
    font-size: 12px;
    font-weight: 600;
    color: ${i.primary};
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .bc-theme-editor-section-count {
    font-size: 11px;
    font-weight: 500;
    color: ${i.gray_medium};
    background: ${i.bg_light};
    padding: 2px 8px;
    border-radius: 10px;
  }

  .bc-theme-editor-section-chevron {
    color: ${i.gray_medium};
    transition: transform 0.2s ease;
  }

  .bc-theme-editor-section-chevron.expanded {
    transform: rotate(90deg);
  }

  .bc-theme-editor-section-content {
    padding: 0 16px 16px;
  }

  /* Color/Asset Lists */
  .bc-theme-editor-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .bc-theme-editor-row {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 14px;
    background: ${i.overlay_light};
    border-radius: 12px;
    border: 1px solid ${i.border_glass};
    transition: all 0.15s ease;
  }

  .bc-theme-editor-row:hover {
    background: ${i.white};
    box-shadow: 0 2px 8px ${i.shadow_soft};
  }

  .bc-theme-editor-input {
    flex: 1;
    padding: 8px 12px;
    border: 1px solid ${i.border_glass};
    border-radius: 8px;
    font-size: 13px;
    background: ${i.white};
    color: ${i.primary};
    outline: none;
    transition: all 0.15s ease;
    min-width: 0;
  }

  .bc-theme-editor-input:focus {
    border-color: ${i.blue};
    box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.15);
  }

  .bc-theme-editor-input:disabled {
    background: transparent;
    border-color: transparent;
    padding-left: 0;
  }

  .bc-theme-editor-color-picker {
    width: 44px;
    height: 36px;
    border: 2px solid ${i.border_glass};
    border-radius: 8px;
    cursor: pointer;
    outline: none;
    padding: 2px;
    transition: all 0.15s ease;
    flex-shrink: 0;
  }

  .bc-theme-editor-color-picker:hover:not(:disabled) {
    border-color: ${i.gray_border};
    transform: scale(1.05);
  }

  .bc-theme-editor-color-picker:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  .bc-theme-editor-color-value {
    font-size: 11px;
    font-family: 'SF Mono', 'Menlo', 'Monaco', 'Courier New', monospace;
    color: ${i.gray_medium};
    width: 85px;
    text-align: right;
    background: ${i.bg_light};
    padding: 5px 8px;
    border-radius: 4px;
    flex-shrink: 0;
    display: inline-block;
  }

  /* Buttons */
  .bc-theme-editor-btn-small {
    padding: 8px 12px;
    border: none;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.15s ease;
    outline: none;
    white-space: nowrap;
    flex-shrink: 0;
  }

  .bc-theme-editor-btn-delete {
    background: linear-gradient(135deg, ${i.red} 0%, #e63e37 100%);
    color: white;
    box-shadow: 0 2px 4px rgba(255, 83, 74, 0.2);
  }

  .bc-theme-editor-btn-delete:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 3px 8px rgba(255, 83, 74, 0.3);
  }

  .bc-theme-editor-btn-save {
    background: linear-gradient(135deg, ${i.green} 0%, #5fb077 100%);
    color: white;
    box-shadow: 0 2px 4px rgba(113, 194, 133, 0.2);
  }

  .bc-theme-editor-btn-save:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 3px 8px rgba(113, 194, 133, 0.3);
  }

  .bc-theme-editor-btn-cancel {
    background: ${i.gray_light};
    color: ${i.gray_dark};
  }

  .bc-theme-editor-btn-cancel:hover:not(:disabled) {
    background: ${i.gray_border};
  }

  .bc-theme-editor-btn-small:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
  }

  .bc-theme-editor-btn-add {
    width: fit-content;
    padding: 10px 16px;
    background: transparent;
    color: ${i.blue};
    border: 2px dashed ${i.gray_border};
    border-radius: 10px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.15s ease;
    outline: none;
    margin-top: 4px;
  }

  .bc-theme-editor-btn-add:hover:not(:disabled) {
    background: ${i.blue_light};
    border-color: ${i.blue};
    border-style: solid;
  }

  .bc-theme-editor-btn-add:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  /* Delete button (minimal red X) */
  .bc-theme-editor-delete-btn {
    width: 28px;
    height: 28px;
    border: none;
    background: transparent;
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${i.gray_medium};
    transition: all 0.15s ease;
    flex-shrink: 0;
  }

  .bc-theme-editor-delete-btn:hover:not(:disabled) {
    background: rgba(255, 83, 74, 0.1);
    color: ${i.red};
  }

  .bc-theme-editor-delete-btn:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  /* Font section specific */
  .bc-font-row {
    justify-content: space-between;
  }

  .bc-font-preview-name {
    font-size: 15px;
    color: ${i.primary};
    flex: 1;
    min-width: 0;
  }

  /* Asset specific */
  .bc-theme-editor-asset-preview {
    width: 36px;
    height: 36px;
    border-radius: 6px;
    background: ${i.bg_light};
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    flex-shrink: 0;
  }

  .bc-theme-editor-asset-preview img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }

  .bc-theme-editor-asset-format {
    font-size: 10px;
    color: ${i.gray_medium};
    background: ${i.bg_light};
    padding: 3px 6px;
    border-radius: 4px;
    text-transform: uppercase;
    flex-shrink: 0;
  }

  .bc-theme-editor-file-wrapper {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .bc-theme-editor-file-btn {
    padding: 6px 10px;
    background: ${i.overlay_light};
    border: 1px solid ${i.border_glass};
    border-radius: 6px;
    font-size: 11px;
    font-weight: 500;
    color: ${i.gray_dark};
    cursor: pointer;
    transition: all 0.15s ease;
  }

  .bc-theme-editor-file-btn:hover:not(:disabled) {
    background: ${i.white};
    border-color: ${i.blue};
    color: ${i.blue};
  }

  .bc-theme-editor-file-name {
    font-size: 11px;
    color: ${i.gray_medium};
    max-width: 80px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .bc-theme-editor-loading {
    text-align: center;
    padding: 24px;
    color: ${i.gray_medium};
    font-size: 13px;
  }

  /* Inline mode specific styles */
  ${o === "inline" ? `
  /* Push page content below the fixed top bar */
  body {
    padding-top: ${Pe}px !important;
  }

  /* In inline mode, shell doesn't cover the entire viewport */
  .bc-theme-editor-shell {
    position: relative;
    top: auto;
    left: auto;
    right: auto;
    bottom: auto;
  }

  /* Hide viewport toggle in inline mode (no mobile preview available) */
  .bc-theme-editor-viewport-toggle {
    display: none;
  }
  ` : ""}
`, Ua = {
  100: "Thin",
  200: "Extra Light",
  300: "Light",
  400: "Regular",
  500: "Medium",
  600: "Semi Bold",
  700: "Bold",
  800: "Extra Bold",
  900: "Black"
}, v = (e) => e.map((t) => ({
  weight: t,
  label: Ua[t] || `Weight ${t}`
})), He = [
  // === SANS-SERIF ===
  {
    name: "Inter",
    category: "sans-serif",
    variants: v([100, 200, 300, 400, 500, 600, 700, 800, 900]),
    popular: !0
  },
  {
    name: "Roboto",
    category: "sans-serif",
    variants: v([100, 300, 400, 500, 700, 900]),
    popular: !0
  },
  {
    name: "Open Sans",
    category: "sans-serif",
    variants: v([300, 400, 500, 600, 700, 800]),
    popular: !0
  },
  {
    name: "Lato",
    category: "sans-serif",
    variants: v([100, 300, 400, 700, 900]),
    popular: !0
  },
  {
    name: "Montserrat",
    category: "sans-serif",
    variants: v([100, 200, 300, 400, 500, 600, 700, 800, 900]),
    popular: !0
  },
  {
    name: "Poppins",
    category: "sans-serif",
    variants: v([100, 200, 300, 400, 500, 600, 700, 800, 900]),
    popular: !0
  },
  {
    name: "Nunito",
    category: "sans-serif",
    variants: v([200, 300, 400, 500, 600, 700, 800, 900]),
    popular: !0
  },
  {
    name: "Nunito Sans",
    category: "sans-serif",
    variants: v([200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Source Sans 3",
    category: "sans-serif",
    variants: v([200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Raleway",
    category: "sans-serif",
    variants: v([100, 200, 300, 400, 500, 600, 700, 800, 900]),
    popular: !0
  },
  {
    name: "Work Sans",
    category: "sans-serif",
    variants: v([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Oswald",
    category: "sans-serif",
    variants: v([200, 300, 400, 500, 600, 700]),
    popular: !0
  },
  {
    name: "Rubik",
    category: "sans-serif",
    variants: v([300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Quicksand",
    category: "sans-serif",
    variants: v([300, 400, 500, 600, 700])
  },
  {
    name: "Mulish",
    category: "sans-serif",
    variants: v([200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Barlow",
    category: "sans-serif",
    variants: v([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Barlow Condensed",
    category: "sans-serif",
    variants: v([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Kanit",
    category: "sans-serif",
    variants: v([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Manrope",
    category: "sans-serif",
    variants: v([200, 300, 400, 500, 600, 700, 800])
  },
  {
    name: "DM Sans",
    category: "sans-serif",
    variants: v([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Outfit",
    category: "sans-serif",
    variants: v([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Plus Jakarta Sans",
    category: "sans-serif",
    variants: v([200, 300, 400, 500, 600, 700, 800])
  },
  {
    name: "Figtree",
    category: "sans-serif",
    variants: v([300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Cabin",
    category: "sans-serif",
    variants: v([400, 500, 600, 700])
  },
  {
    name: "Karla",
    category: "sans-serif",
    variants: v([200, 300, 400, 500, 600, 700, 800])
  },
  {
    name: "Archivo",
    category: "sans-serif",
    variants: v([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Josefin Sans",
    category: "sans-serif",
    variants: v([100, 200, 300, 400, 500, 600, 700])
  },
  {
    name: "Lexend",
    category: "sans-serif",
    variants: v([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Exo 2",
    category: "sans-serif",
    variants: v([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Titillium Web",
    category: "sans-serif",
    variants: v([200, 300, 400, 600, 700, 900])
  },
  {
    name: "Sora",
    category: "sans-serif",
    variants: v([100, 200, 300, 400, 500, 600, 700, 800])
  },
  {
    name: "Space Grotesk",
    category: "sans-serif",
    variants: v([300, 400, 500, 600, 700])
  },
  {
    name: "Albert Sans",
    category: "sans-serif",
    variants: v([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Be Vietnam Pro",
    category: "sans-serif",
    variants: v([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Asap",
    category: "sans-serif",
    variants: v([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Ubuntu",
    category: "sans-serif",
    variants: v([300, 400, 500, 700]),
    popular: !0
  },
  {
    name: "Dosis",
    category: "sans-serif",
    variants: v([200, 300, 400, 500, 600, 700, 800]),
    popular: !0
  },
  {
    name: "Noto Sans",
    category: "sans-serif",
    variants: v([100, 200, 300, 400, 500, 600, 700, 800, 900]),
    popular: !0
  },
  {
    name: "Noto Sans Display",
    category: "sans-serif",
    variants: v([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Fira Sans",
    category: "sans-serif",
    variants: v([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "PT Sans",
    category: "sans-serif",
    variants: v([400, 700])
  },
  {
    name: "PT Sans Narrow",
    category: "sans-serif",
    variants: v([400, 700])
  },
  {
    name: "Mukta",
    category: "sans-serif",
    variants: v([200, 300, 400, 500, 600, 700, 800])
  },
  {
    name: "Hind",
    category: "sans-serif",
    variants: v([300, 400, 500, 600, 700])
  },
  {
    name: "Rajdhani",
    category: "sans-serif",
    variants: v([300, 400, 500, 600, 700])
  },
  {
    name: "Varela Round",
    category: "sans-serif",
    variants: v([400])
  },
  {
    name: "Comic Neue",
    category: "sans-serif",
    variants: v([300, 400, 700])
  },
  // === SERIF ===
  {
    name: "Playfair Display",
    category: "serif",
    variants: v([400, 500, 600, 700, 800, 900]),
    popular: !0
  },
  {
    name: "Merriweather",
    category: "serif",
    variants: v([300, 400, 700, 900]),
    popular: !0
  },
  {
    name: "Lora",
    category: "serif",
    variants: v([400, 500, 600, 700]),
    popular: !0
  },
  {
    name: "PT Serif",
    category: "serif",
    variants: v([400, 700])
  },
  {
    name: "Noto Serif",
    category: "serif",
    variants: v([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Source Serif 4",
    category: "serif",
    variants: v([200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Libre Baskerville",
    category: "serif",
    variants: v([400, 700])
  },
  {
    name: "Crimson Text",
    category: "serif",
    variants: v([400, 600, 700])
  },
  {
    name: "Crimson Pro",
    category: "serif",
    variants: v([200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Bitter",
    category: "serif",
    variants: v([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Cormorant Garamond",
    category: "serif",
    variants: v([300, 400, 500, 600, 700])
  },
  {
    name: "EB Garamond",
    category: "serif",
    variants: v([400, 500, 600, 700, 800])
  },
  {
    name: "DM Serif Display",
    category: "serif",
    variants: v([400])
  },
  {
    name: "Spectral",
    category: "serif",
    variants: v([200, 300, 400, 500, 600, 700, 800])
  },
  {
    name: "Cardo",
    category: "serif",
    variants: v([400, 700])
  },
  {
    name: "Libre Caslon Text",
    category: "serif",
    variants: v([400, 700])
  },
  {
    name: "Bodoni Moda",
    category: "serif",
    variants: v([400, 500, 600, 700, 800, 900])
  },
  {
    name: "Fraunces",
    category: "serif",
    variants: v([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Cormorant",
    category: "serif",
    variants: v([300, 400, 500, 600, 700])
  },
  {
    name: "Cinzel",
    category: "serif",
    variants: v([400, 500, 600, 700, 800, 900])
  },
  {
    name: "Playfair Display SC",
    category: "serif",
    variants: v([400, 700, 900])
  },
  // === DISPLAY ===
  {
    name: "Bebas Neue",
    category: "display",
    variants: v([400]),
    popular: !0
  },
  {
    name: "Abril Fatface",
    category: "display",
    variants: v([400]),
    popular: !0
  },
  {
    name: "Righteous",
    category: "display",
    variants: v([400])
  },
  {
    name: "Alfa Slab One",
    category: "display",
    variants: v([400])
  },
  {
    name: "Fredoka",
    category: "display",
    variants: v([300, 400, 500, 600, 700])
  },
  {
    name: "Comfortaa",
    category: "display",
    variants: v([300, 400, 500, 600, 700])
  },
  {
    name: "Lobster",
    category: "display",
    variants: v([400])
  },
  {
    name: "Staatliches",
    category: "display",
    variants: v([400])
  },
  {
    name: "Bungee",
    category: "display",
    variants: v([400])
  },
  {
    name: "Monoton",
    category: "display",
    variants: v([400])
  },
  {
    name: "Black Ops One",
    category: "display",
    variants: v([400])
  },
  {
    name: "Permanent Marker",
    category: "display",
    variants: v([400])
  },
  {
    name: "Russo One",
    category: "display",
    variants: v([400])
  },
  {
    name: "Fugaz One",
    category: "display",
    variants: v([400])
  },
  {
    name: "Bangers",
    category: "display",
    variants: v([400])
  },
  {
    name: "Anton",
    category: "display",
    variants: v([400]),
    popular: !0
  },
  {
    name: "Creepster",
    category: "display",
    variants: v([400])
  },
  {
    name: "Orbitron",
    category: "display",
    variants: v([400, 500, 600, 700, 800, 900])
  },
  {
    name: "Audiowide",
    category: "display",
    variants: v([400])
  },
  {
    name: "Bungee Inline",
    category: "display",
    variants: v([400])
  },
  {
    name: "Bungee Shade",
    category: "display",
    variants: v([400])
  },
  {
    name: "Faster One",
    category: "display",
    variants: v([400])
  },
  {
    name: "Press Start 2P",
    category: "display",
    variants: v([400])
  },
  // === HANDWRITING ===
  {
    name: "Dancing Script",
    category: "handwriting",
    variants: v([400, 500, 600, 700]),
    popular: !0
  },
  {
    name: "Pacifico",
    category: "handwriting",
    variants: v([400]),
    popular: !0
  },
  {
    name: "Caveat",
    category: "handwriting",
    variants: v([400, 500, 600, 700])
  },
  {
    name: "Great Vibes",
    category: "handwriting",
    variants: v([400])
  },
  {
    name: "Satisfy",
    category: "handwriting",
    variants: v([400])
  },
  {
    name: "Sacramento",
    category: "handwriting",
    variants: v([400])
  },
  {
    name: "Kalam",
    category: "handwriting",
    variants: v([300, 400, 700])
  },
  {
    name: "Shadows Into Light",
    category: "handwriting",
    variants: v([400])
  },
  {
    name: "Indie Flower",
    category: "handwriting",
    variants: v([400])
  },
  {
    name: "Amatic SC",
    category: "handwriting",
    variants: v([400, 700])
  },
  {
    name: "Patrick Hand",
    category: "handwriting",
    variants: v([400])
  },
  {
    name: "Courgette",
    category: "handwriting",
    variants: v([400])
  },
  {
    name: "Shadows Into Light Two",
    category: "handwriting",
    variants: v([400]),
    popular: !0
  },
  {
    name: "Caveat Brush",
    category: "handwriting",
    variants: v([400])
  },
  // === MONOSPACE ===
  {
    name: "Fira Code",
    category: "monospace",
    variants: v([300, 400, 500, 600, 700]),
    popular: !0
  },
  {
    name: "JetBrains Mono",
    category: "monospace",
    variants: v([100, 200, 300, 400, 500, 600, 700, 800]),
    popular: !0
  },
  {
    name: "Source Code Pro",
    category: "monospace",
    variants: v([200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Roboto Mono",
    category: "monospace",
    variants: v([100, 200, 300, 400, 500, 600, 700])
  },
  {
    name: "IBM Plex Mono",
    category: "monospace",
    variants: v([100, 200, 300, 400, 500, 600, 700])
  },
  {
    name: "Space Mono",
    category: "monospace",
    variants: v([400, 700])
  },
  {
    name: "Inconsolata",
    category: "monospace",
    variants: v([200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Ubuntu Mono",
    category: "monospace",
    variants: v([400, 700])
  },
  {
    name: "Noto Sans Mono",
    category: "monospace",
    variants: v([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Courier Prime",
    category: "monospace",
    variants: v([400, 700])
  },
  {
    name: "Fira Mono",
    category: "monospace",
    variants: v([400, 500, 700])
  }
], Za = (e, t = [500]) => {
  const o = e.replace(/ /g, "+"), n = t.join(";");
  return `https://fonts.googleapis.com/css2?family=${o}:wght@${n}&display=swap`;
}, qa = (e) => `https://fonts.googleapis.com/css2?${e.map((o) => {
  const n = o.name.replace(/ /g, "+"), a = o.weights.join(";");
  return `family=${n}:wght@${a}`;
}).join("&")}&display=swap`, Va = (e) => {
  const t = He.find(
    (o) => o.name.toLowerCase() === e.toLowerCase()
  );
  return (t == null ? void 0 : t.variants) || [{ weight: 500, label: "Medium" }];
};
let Ie = null;
const jo = () => Ie || (Ie = new Promise((e) => {
  const t = He.map((a) => ({
    name: a.name,
    weights: [400, 500]
  })), o = qa(t), n = document.createElement("link");
  n.href = o, n.rel = "stylesheet", n.onload = () => {
    e();
  }, n.onerror = () => {
    console.warn("Failed to preload Google Fonts"), e();
  }, document.head.appendChild(n);
}), Ie), Ka = (e) => {
  if (!e) return "#000000ff";
  const t = e.startsWith("#") ? e : `#${e}`;
  return t.length === 9 ? t : t.length === 7 ? `${t}ff` : t.padEnd(9, "f").slice(0, 9);
}, to = (e) => {
  const t = Ka(e);
  return t.length === 9 && t.slice(7, 9).toLowerCase() === "ff" ? t.slice(0, 7) : t;
}, pe = (e, t, o) => {
  var a;
  const n = {
    type: Io,
    payload: { updateType: t, themeId: o }
  };
  (a = e == null ? void 0 : e.current) != null && a.contentWindow ? e.current.contentWindow.postMessage(
    n,
    window.location.origin
  ) : window.postMessage(n, window.location.origin);
}, _a = (e) => {
  var o;
  switch ((o = e.split(".").pop()) == null ? void 0 : o.toLowerCase()) {
    case "woff2":
      return "woff2";
    case "woff":
      return "woff";
    case "ttf":
      return "truetype";
    case "otf":
      return "opentype";
    default:
      return "woff2";
  }
}, ei = ({
  themeId: e,
  editThemeToken: t,
  iframeRef: o,
  refreshThemeColors: n,
  refreshThemeFonts: a,
  refreshThemeIcons: l
}) => {
  const [d, p] = N(!1), [c, u] = N(null), [s, g] = N(null), [y, k] = N(!1), [f, b] = N(""), [h, w] = N("#000000ff"), [B, T] = N(
    null
  ), S = async () => {
    if (!f.trim()) {
      u("Color name is required");
      return;
    }
    if (!t || !e) {
      u("Theme ID and edit token are required");
      return;
    }
    p(!0), u(null), g(null);
    try {
      await xt({
        themeId: e,
        colorKey: f.trim(),
        colorValue: to(h),
        editThemeToken: t
      }), await n(), pe(o, "colors", e), b(""), w("#000000ff"), k(!1), g("Color added successfully"), setTimeout(() => g(null), 2e3);
    } catch (H) {
      u(H.message || "Failed to add color");
    } finally {
      p(!1);
    }
  }, z = async (H, j) => {
    if (!(!t || !e)) {
      p(!0), u(null), g(null);
      try {
        await xt({
          themeId: e,
          colorKey: H,
          colorValue: to(j),
          editThemeToken: t
        }), await n(), pe(o, "colors", e), g("Color updated successfully"), setTimeout(() => g(null), 2e3);
      } catch (A) {
        u(A.message || "Failed to update color");
      } finally {
        p(!1);
      }
    }
  }, O = async (H, j) => {
    if (!(!t || !e)) {
      if (!j.trim()) {
        u("Color name is required");
        return;
      }
      if (H !== j.trim()) {
        p(!0), u(null), g(null);
        try {
          await Cn({
            themeId: e,
            oldColorKey: H,
            newColorKey: j.trim(),
            editThemeToken: t
          }), await n(), pe(o, "colors", e), g("Color renamed successfully"), setTimeout(() => g(null), 2e3);
        } catch (A) {
          u(A.message || "Failed to rename color");
        } finally {
          p(!1);
        }
      }
    }
  }, R = (H) => {
    !t || !e || T({ type: "color", key: H });
  }, x = async (H) => {
    if (!(!t || !e)) {
      p(!0), u(null), g(null);
      try {
        await xn({
          themeId: e,
          colorKey: H,
          editThemeToken: t
        }), await n(), pe(o, "colors", e), g("Color deleted successfully"), setTimeout(() => g(null), 2e3);
      } catch (j) {
        u(j.message || "Failed to delete color");
      } finally {
        p(!1);
      }
    }
  }, L = async (H) => {
    if (!t || !e) {
      u("Theme ID and edit token are required");
      return;
    }
    p(!0), u(null), g(null);
    try {
      let j, A;
      switch (H.type) {
        case "system":
          j = H.value || H.name, A = "system";
          break;
        case "google":
          const W = Va(H.name).map((ne) => ne.weight);
          W.includes(800) || W.push(800), W.includes(900) || W.push(900), j = Za(H.name, W), A = "google";
          break;
        case "upload":
          if (!H.file)
            throw new Error("No font file provided");
          const { signedUploadUrl: J, objectPublicUrl: re } = await Ct({
            themeId: e,
            fileName: H.file.name,
            contentType: H.file.type || "font/woff2",
            assetType: "font",
            editThemeToken: t
          });
          await kt({
            file: H.file,
            signedUploadUrl: J
          }), j = re, A = _a(H.file.name);
          break;
        default:
          throw new Error("Unknown font type");
      }
      await kn({
        themeId: e,
        fontKey: H.name.toLowerCase().replace(/\s+/g, "-"),
        fontValue: {
          name: H.name,
          url: j,
          format: A
        },
        editThemeToken: t
      }), await a(), pe(o, "fonts", e), g("Font added successfully"), setTimeout(() => g(null), 2e3);
    } catch (j) {
      u(j.message || "Failed to add font");
    } finally {
      p(!1);
    }
  }, Y = (H) => {
    !t || !e || T({ type: "font", key: H });
  }, I = async (H) => {
    if (!(!t || !e)) {
      p(!0), u(null), g(null);
      try {
        await vn({
          themeId: e,
          fontKey: H,
          editThemeToken: t
        }), await a(), pe(o, "fonts", e), g("Font deleted successfully"), setTimeout(() => g(null), 2e3);
      } catch (j) {
        u(j.message || "Failed to delete font");
      } finally {
        p(!1);
      }
    }
  }, D = async (H) => {
    if (!t || !e) {
      u("Theme ID and edit token are required");
      return;
    }
    p(!0), u(null), g(null);
    try {
      let j;
      switch (H.type) {
        case "lucide":
          if (j = H.url || "", !j)
            throw new Error("No icon URL provided");
          break;
        case "upload":
          if (!H.file)
            throw new Error("No icon file provided");
          const { signedUploadUrl: A, objectPublicUrl: Q } = await Ct({
            themeId: e,
            fileName: H.file.name,
            contentType: H.file.type || "image/svg+xml",
            assetType: "icon",
            editThemeToken: t
          });
          await kt({
            file: H.file,
            signedUploadUrl: A
          }), j = Q;
          break;
        default:
          throw new Error("Unknown icon type");
      }
      await wn({
        themeId: e,
        iconKey: H.name.toLowerCase().replace(/\s+/g, "-"),
        iconValue: {
          name: H.name,
          url: j
        },
        editThemeToken: t
      }), await l(), pe(o, "icons", e), g("Icon added successfully"), setTimeout(() => g(null), 2e3);
    } catch (j) {
      u(j.message || "Failed to add icon");
    } finally {
      p(!1);
    }
  }, C = (H) => {
    !t || !e || T({ type: "icon", key: H });
  }, E = async (H) => {
    if (!(!t || !e)) {
      p(!0), u(null), g(null);
      try {
        await Sn({
          themeId: e,
          iconKey: H,
          editThemeToken: t
        }), await l(), pe(o, "icons", e), g("Icon deleted successfully"), setTimeout(() => g(null), 2e3);
      } catch (j) {
        u(j.message || "Failed to delete icon");
      } finally {
        p(!1);
      }
    }
  };
  return {
    // Loading and messages
    isLoading: d,
    error: c,
    successMessage: s,
    // Color state
    isAddingColor: y,
    setIsAddingColor: k,
    newColorKey: f,
    setNewColorKey: b,
    newColorValue: h,
    setNewColorValue: w,
    // Color Handlers
    handleAddColor: S,
    handleUpdateColor: z,
    handleRenameColor: O,
    handleDeleteColor: R,
    // Font Handlers
    handleAddFont: L,
    handleDeleteFont: Y,
    // Icon Handlers
    handleAddIcon: D,
    handleDeleteIcon: C,
    // Delete confirmation
    pendingDelete: B,
    confirmDelete: async () => {
      if (!B) return;
      const { type: H, key: j } = B;
      switch (T(null), H) {
        case "color":
          await x(j);
          break;
        case "font":
          await I(j);
          break;
        case "icon":
          await E(j);
          break;
      }
    },
    cancelDelete: () => {
      T(null);
    }
  };
}, oo = ({
  onClose: e,
  successMessage: t,
  error: o,
  children: n
}) => /* @__PURE__ */ m("div", { className: "bc-theme-editor-sidepanel", children: [
  /* @__PURE__ */ m("div", { className: "bc-theme-editor-sidepanel-header", children: [
    /* @__PURE__ */ r("h2", { className: "bc-theme-editor-sidepanel-title", children: "Theme Settings" }),
    /* @__PURE__ */ r(
      U,
      {
        variant: "icon",
        size: "sm",
        onClick: e,
        "aria-label": "Close settings",
        children: /* @__PURE__ */ r(ue, { size: 16 })
      }
    )
  ] }),
  /* @__PURE__ */ m("div", { className: "bc-theme-editor-sidepanel-content", children: [
    t && /* @__PURE__ */ m("div", { className: "bc-theme-editor-message bc-theme-editor-message-success", children: [
      /* @__PURE__ */ r(tr, { size: 14 }),
      " ",
      t
    ] }),
    o && /* @__PURE__ */ m("div", { className: "bc-theme-editor-message bc-theme-editor-message-error", children: [
      /* @__PURE__ */ r(rr, { size: 14 }),
      " ",
      o
    ] }),
    n
  ] })
] }), ro = ({
  themeFonts: e,
  isExpanded: t,
  onToggle: o,
  isLoading: n,
  onDeleteFont: a,
  onOpenFontPicker: l
}) => {
  const [d, p] = N(!1);
  $(() => {
    t && !d && jo().then(() => p(!0));
  }, [t, d]);
  const c = (u) => {
    switch (u) {
      case "google":
        return "Google Fonts";
      case "system":
        return "System";
      case "woff2":
      case "woff":
      case "truetype":
      case "opentype":
        return "Uploaded";
      default:
        return u;
    }
  };
  return /* @__PURE__ */ m("div", { className: "bc-theme-editor-section", children: [
    /* @__PURE__ */ m("div", { className: "bc-theme-editor-section-header", onClick: o, children: [
      /* @__PURE__ */ m("h3", { className: "bc-theme-editor-section-title", children: [
        "Fonts",
        /* @__PURE__ */ r("span", { className: "bc-theme-editor-section-count", children: Object.keys(e).length })
      ] }),
      /* @__PURE__ */ r(
        tt,
        {
          size: 16,
          className: `bc-theme-editor-section-chevron ${t ? "expanded" : ""}`
        }
      )
    ] }),
    t && /* @__PURE__ */ r("div", { className: "bc-theme-editor-section-content", children: /* @__PURE__ */ m("div", { className: "bc-theme-editor-list", children: [
      Object.entries(e).map(([u, s]) => /* @__PURE__ */ m("div", { className: "bc-theme-editor-row bc-font-row", children: [
        /* @__PURE__ */ r(
          "span",
          {
            className: "bc-font-preview-name",
            style: {
              fontFamily: d ? `'${s.name}', sans-serif` : "inherit"
            },
            children: s.name
          }
        ),
        /* @__PURE__ */ r("span", { className: "bc-theme-editor-asset-format", children: c(s.format) }),
        /* @__PURE__ */ r(
          "button",
          {
            className: "bc-theme-editor-delete-btn",
            onClick: () => a(u),
            disabled: n,
            "aria-label": "Delete font",
            children: /* @__PURE__ */ r(ue, { size: 16 })
          }
        )
      ] }, u)),
      /* @__PURE__ */ r(
        U,
        {
          variant: "ghost",
          size: "sm",
          leftIcon: /* @__PURE__ */ r(ot, { size: 12 }),
          onClick: l,
          disabled: n,
          children: "Add Font"
        }
      )
    ] }) })
  ] });
}, no = ({
  themeIcons: e,
  isExpanded: t,
  onToggle: o,
  isLoading: n,
  onDeleteIcon: a,
  onOpenIconPicker: l
}) => /* @__PURE__ */ m("div", { className: "bc-theme-editor-section", children: [
  /* @__PURE__ */ m("div", { className: "bc-theme-editor-section-header", onClick: o, children: [
    /* @__PURE__ */ m("h3", { className: "bc-theme-editor-section-title", children: [
      "Icons",
      /* @__PURE__ */ r("span", { className: "bc-theme-editor-section-count", children: Object.keys(e).length })
    ] }),
    /* @__PURE__ */ r(
      tt,
      {
        size: 16,
        className: `bc-theme-editor-section-chevron ${t ? "expanded" : ""}`
      }
    )
  ] }),
  t && /* @__PURE__ */ r("div", { className: "bc-theme-editor-section-content", children: /* @__PURE__ */ m("div", { className: "bc-theme-editor-list", children: [
    Object.entries(e).map(([d, p]) => /* @__PURE__ */ m("div", { className: "bc-theme-editor-row", children: [
      /* @__PURE__ */ r("div", { className: "bc-theme-editor-asset-preview", children: /* @__PURE__ */ r("img", { src: p.url, alt: p.name }) }),
      /* @__PURE__ */ r(
        "input",
        {
          type: "text",
          className: "bc-theme-editor-input",
          value: p.name,
          disabled: !0
        }
      ),
      /* @__PURE__ */ r(
        "button",
        {
          className: "bc-theme-editor-delete-btn",
          onClick: () => a(d),
          disabled: n,
          "aria-label": "Delete icon",
          children: /* @__PURE__ */ r(ue, { size: 16 })
        }
      )
    ] }, d)),
    /* @__PURE__ */ r(
      U,
      {
        variant: "ghost",
        size: "sm",
        leftIcon: /* @__PURE__ */ r(ot, { size: 12 }),
        onClick: l,
        disabled: n,
        children: "Add Icon"
      }
    )
  ] }) })
] }), ao = [
  // Sans-serif
  {
    name: "System UI",
    value: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    category: "sans-serif"
  },
  {
    name: "SF Pro",
    value: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', sans-serif",
    category: "sans-serif"
  },
  {
    name: "Helvetica",
    value: "Helvetica, Arial, sans-serif",
    category: "sans-serif"
  },
  {
    name: "Arial",
    value: "Arial, Helvetica, sans-serif",
    category: "sans-serif"
  },
  {
    name: "Segoe UI",
    value: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    category: "sans-serif"
  },
  {
    name: "Verdana",
    value: "Verdana, Geneva, sans-serif",
    category: "sans-serif"
  },
  {
    name: "Tahoma",
    value: "Tahoma, Geneva, sans-serif",
    category: "sans-serif"
  },
  {
    name: "Trebuchet MS",
    value: "'Trebuchet MS', sans-serif",
    category: "sans-serif"
  },
  // Serif
  {
    name: "New York",
    value: "'New York', 'Iowan Old Style', Georgia, serif",
    category: "serif"
  },
  {
    name: "Georgia",
    value: "Georgia, 'Times New Roman', serif",
    category: "serif"
  },
  {
    name: "Times New Roman",
    value: "'Times New Roman', Times, serif",
    category: "serif"
  },
  {
    name: "Palatino",
    value: "'Palatino Linotype', Palatino, 'Book Antiqua', serif",
    category: "serif"
  },
  {
    name: "Garamond",
    value: "Garamond, 'Times New Roman', serif",
    category: "serif"
  },
  // Monospace
  {
    name: "SF Mono",
    value: "'SF Mono', Menlo, Monaco, monospace",
    category: "monospace"
  },
  {
    name: "Menlo",
    value: "Menlo, Monaco, 'Courier New', monospace",
    category: "monospace"
  },
  {
    name: "Monaco",
    value: "Monaco, Menlo, 'Courier New', monospace",
    category: "monospace"
  },
  {
    name: "Consolas",
    value: "Consolas, 'Courier New', monospace",
    category: "monospace"
  },
  {
    name: "Courier New",
    value: "'Courier New', Courier, monospace",
    category: "monospace"
  }
], ti = () => `
  /* Overlay */
  .font-picker-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000002;
    animation: font-picker-fade-in 0.2s ease;
  }

  @keyframes font-picker-fade-in {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  /* Modal */
  .font-picker-modal {
    background: ${i.white};
    border-radius: 16px;
    width: 90%;
    max-width: 560px;
    max-height: 85vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 25px 80px rgba(0, 0, 0, 0.25);
    animation: font-picker-slide-up 0.25s ease;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  }

  @keyframes font-picker-slide-up {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  /* Header */
  .font-picker-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 24px;
    border-bottom: 1px solid ${i.border_glass};
  }

  .font-picker-title {
    font-size: 18px;
    font-weight: 600;
    color: ${i.primary};
    margin: 0;
  }

  /* Search */
  .font-picker-search {
    padding: 16px 24px;
    border-bottom: 1px solid ${i.border_glass};
    position: relative;
  }

  .font-picker-search-icon {
    position: absolute;
    left: 40px;
    top: 50%;
    transform: translateY(-50%);
    color: ${i.gray_medium};
  }

  .font-picker-search-input {
    width: 100%;
    padding: 12px 16px 12px 44px;
    border: 1px solid ${i.border_glass};
    border-radius: 10px;
    font-size: 14px;
    color: ${i.primary};
    background: ${i.bg_light};
    outline: none;
    transition: all 0.15s ease;
    box-sizing: border-box;
  }

  .font-picker-search-input:focus {
    border-color: ${i.blue};
    background: ${i.white};
    box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.15);
  }

  .font-picker-search-input::placeholder {
    color: ${i.gray_medium};
  }

  /* Tabs */
  .font-picker-tabs {
    display: flex;
    padding: 0 24px;
    border-bottom: 1px solid ${i.border_glass};
  }

  .font-picker-tab {
    padding: 14px 20px;
    border: none;
    background: transparent;
    font-size: 13px;
    font-weight: 500;
    color: ${i.gray_medium};
    cursor: pointer;
    position: relative;
    transition: color 0.15s ease;
  }

  .font-picker-tab:hover {
    color: ${i.primary};
  }

  .font-picker-tab.active {
    color: ${i.primary};
  }

  .font-picker-tab.active::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    right: 0;
    height: 2px;
    background: ${i.primary};
    border-radius: 2px 2px 0 0;
  }

  /* Content */
  .font-picker-content {
    flex: 1;
    overflow-y: auto;
    padding: 0;
  }

  .font-picker-description {
    font-size: 13px;
    color: ${i.gray_medium};
    padding: 16px 24px 8px;
    margin: 0;
    line-height: 1.5;
  }

  /* Font List */
  .font-picker-list {
    padding-bottom: 16px;
  }

  .font-picker-category {
    margin-bottom: 8px;
  }

  .font-picker-category-title {
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: ${i.gray_medium};
    padding: 16px 24px 8px;
    margin: 0;
  }

  .font-picker-item {
    display: flex;
    align-items: center;
    padding: 14px 24px;
    cursor: pointer;
    transition: background 0.15s ease;
    border-bottom: 1px solid ${i.border_glass};
  }

  .font-picker-item:hover {
    background: ${i.bg_light};
  }

  .font-picker-item.selected {
    background: rgba(85, 114, 183, 0.08);
  }

  .font-picker-item-name {
    flex: 1;
    font-size: 16px;
    color: ${i.primary};
  }

  .font-picker-popular {
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    color: ${i.blue};
    background: rgba(85, 114, 183, 0.1);
    padding: 3px 8px;
    border-radius: 4px;
    margin-right: 12px;
  }

  .font-picker-check {
    color: ${i.blue};
    flex-shrink: 0;
  }

  /* Variant Selector */
  .font-picker-variant-selector {
    padding: 8px 24px 8px 48px;
    background: ${i.bg_light};
    border-bottom: 1px solid ${i.border_glass};
  }

  .font-picker-variant-select {
    padding: 8px 32px 8px 12px;
    border: 1px solid ${i.border_glass};
    border-radius: 8px;
    font-size: 13px;
    color: ${i.primary};
    background: ${i.white};
    cursor: pointer;
    outline: none;
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%237e8fa8' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 10px center;
    transition: all 0.15s ease;
  }

  .font-picker-variant-select:focus {
    border-color: ${i.blue};
    box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.15);
  }

  /* Upload Tab */
  .font-picker-upload {
    padding: 16px 24px;
  }

  .font-picker-upload-zone {
    border: 2px dashed ${i.gray_border};
    border-radius: 12px;
    padding: 48px 24px;
    text-align: center;
    cursor: pointer;
    transition: all 0.15s ease;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    margin-top: 8px;
  }

  .font-picker-upload-zone:hover {
    border-color: ${i.blue};
    background: rgba(85, 114, 183, 0.04);
  }

  .font-picker-upload-icon {
    color: ${i.gray_medium};
  }

  .font-picker-upload-text {
    font-size: 14px;
    font-weight: 500;
    color: ${i.primary};
  }

  .font-picker-upload-hint {
    font-size: 12px;
    color: ${i.gray_medium};
  }

  .font-picker-upload-preview {
    margin-top: 16px;
  }

  .font-picker-upload-file {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    background: ${i.bg_light};
    border-radius: 10px;
    margin-bottom: 16px;
  }

  .font-picker-upload-filename {
    font-size: 14px;
    font-weight: 500;
    color: ${i.primary};
    font-family: 'SF Mono', 'Menlo', monospace;
  }

  .font-picker-upload-name {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .font-picker-upload-label {
    font-size: 12px;
    font-weight: 600;
    color: ${i.gray_medium};
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .font-picker-upload-input {
    padding: 12px 14px;
    border: 1px solid ${i.border_glass};
    border-radius: 10px;
    font-size: 14px;
    color: ${i.primary};
    background: ${i.white};
    outline: none;
    transition: all 0.15s ease;
    box-sizing: border-box;
  }

  .font-picker-upload-input:focus {
    border-color: ${i.blue};
    box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.15);
  }

  /* Footer */
  .font-picker-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding: 20px 24px;
    border-top: 1px solid ${i.border_glass};
    background: ${i.bg_light};
    border-radius: 0 0 16px 16px;
  }
`, io = ({
  isOpen: e,
  onClose: t,
  onSelect: o,
  isLoading: n = !1
}) => {
  const [a, l] = N("system"), [d, p] = N(""), [c, u] = N(null), [s, g] = N(null), [y, k] = N(""), f = te(null), [b, h] = N(!1);
  $(() => {
    e && (p(""), u(null), g(null), k(""));
  }, [e]), $(() => {
    a === "google" && !b && jo().then(() => {
      h(!0);
    });
  }, [a, b]);
  const w = le(() => {
    if (!d) return ao;
    const C = d.toLowerCase();
    return ao.filter(
      (E) => E.name.toLowerCase().includes(C) || E.category.toLowerCase().includes(C)
    );
  }, [d]), B = le(() => {
    if (!d) return He;
    const C = d.toLowerCase();
    return He.filter(
      (E) => E.name.toLowerCase().includes(C) || E.category.toLowerCase().includes(C)
    );
  }, [d]), T = (C) => {
    u({
      type: "system",
      name: C.name,
      value: C.value
    });
  }, S = (C) => {
    u({
      type: "google",
      name: C.name
    });
  }, z = (C) => {
    var F;
    const E = (F = C.target.files) == null ? void 0 : F[0];
    if (E) {
      g(E);
      const X = E.name.replace(/\.[^/.]+$/, "");
      k(X), u({
        type: "upload",
        name: X,
        file: E,
        format: O(E.name)
      });
    }
  }, O = (C) => {
    var F;
    switch ((F = C.split(".").pop()) == null ? void 0 : F.toLowerCase()) {
      case "woff2":
        return "woff2";
      case "woff":
        return "woff";
      case "ttf":
        return "truetype";
      case "otf":
        return "opentype";
      default:
        return "woff2";
    }
  }, R = (C) => {
    k(C), (c == null ? void 0 : c.type) === "upload" && s && u({
      ...c,
      name: C
    });
  }, x = () => {
    c && (o(c), t());
  }, L = n || !c || c.type === "upload" && (!s || !y.trim()), Y = le(() => {
    const C = {};
    return B.forEach((E) => {
      C[E.category] || (C[E.category] = []), C[E.category].push(E);
    }), C;
  }, [B]), I = le(() => {
    const C = {};
    return w.forEach((E) => {
      C[E.category] || (C[E.category] = []), C[E.category].push(E);
    }), C;
  }, [w]);
  if (!e) return null;
  const D = /* @__PURE__ */ m(G, { children: [
    /* @__PURE__ */ r("style", { children: ti() }),
    /* @__PURE__ */ r("div", { className: "font-picker-overlay", onClick: t, children: /* @__PURE__ */ m("div", { className: "font-picker-modal", onClick: (C) => C.stopPropagation(), children: [
      /* @__PURE__ */ m("div", { className: "font-picker-header", children: [
        /* @__PURE__ */ r("h2", { className: "font-picker-title", children: "Select font" }),
        /* @__PURE__ */ r(
          U,
          {
            variant: "icon",
            size: "sm",
            onClick: t,
            "aria-label": "Close",
            children: /* @__PURE__ */ r(ue, { size: 20 })
          }
        )
      ] }),
      /* @__PURE__ */ m("div", { className: "font-picker-search", children: [
        /* @__PURE__ */ r(ho, { size: 16, className: "font-picker-search-icon" }),
        /* @__PURE__ */ r(
          "input",
          {
            type: "text",
            placeholder: "Search",
            value: d,
            onChange: (C) => p(C.target.value),
            className: "font-picker-search-input",
            autoFocus: !0
          }
        )
      ] }),
      /* @__PURE__ */ m("div", { className: "font-picker-tabs", children: [
        /* @__PURE__ */ r(
          "button",
          {
            className: `font-picker-tab ${a === "system" ? "active" : ""}`,
            onClick: () => l("system"),
            children: "System Fonts"
          }
        ),
        /* @__PURE__ */ r(
          "button",
          {
            className: `font-picker-tab ${a === "google" ? "active" : ""}`,
            onClick: () => l("google"),
            children: "Google Fonts"
          }
        ),
        /* @__PURE__ */ r(
          "button",
          {
            className: `font-picker-tab ${a === "upload" ? "active" : ""}`,
            onClick: () => l("upload"),
            children: "Upload"
          }
        )
      ] }),
      /* @__PURE__ */ m("div", { className: "font-picker-content", children: [
        a === "system" && /* @__PURE__ */ m("div", { className: "font-picker-list", children: [
          /* @__PURE__ */ r("p", { className: "font-picker-description", children: "These fonts load faster and might appear differently on various devices." }),
          Object.entries(I).map(
            ([C, E]) => /* @__PURE__ */ m("div", { className: "font-picker-category", children: [
              /* @__PURE__ */ r("h4", { className: "font-picker-category-title", children: C.charAt(0).toUpperCase() + C.slice(1) }),
              E.map((F) => /* @__PURE__ */ m(
                "div",
                {
                  className: `font-picker-item ${(c == null ? void 0 : c.type) === "system" && (c == null ? void 0 : c.name) === F.name ? "selected" : ""}`,
                  onClick: () => T(F),
                  children: [
                    /* @__PURE__ */ r(
                      "span",
                      {
                        className: "font-picker-item-name",
                        style: { fontFamily: F.value },
                        children: F.name
                      }
                    ),
                    (c == null ? void 0 : c.type) === "system" && (c == null ? void 0 : c.name) === F.name && /* @__PURE__ */ r(Ce, { size: 16, className: "font-picker-check" })
                  ]
                },
                F.name
              ))
            ] }, C)
          )
        ] }),
        a === "google" && /* @__PURE__ */ m("div", { className: "font-picker-list", children: [
          /* @__PURE__ */ r("p", { className: "font-picker-description", children: "These fonts are downloaded onto a visitor's computer and might cause slower load times." }),
          Object.entries(Y).map(
            ([C, E]) => /* @__PURE__ */ m("div", { className: "font-picker-category", children: [
              /* @__PURE__ */ r("h4", { className: "font-picker-category-title", children: C.charAt(0).toUpperCase() + C.slice(1) }),
              E.map((F) => {
                const X = (c == null ? void 0 : c.type) === "google" && (c == null ? void 0 : c.name) === F.name;
                return /* @__PURE__ */ r("div", { children: /* @__PURE__ */ m(
                  "div",
                  {
                    className: `font-picker-item ${X ? "selected" : ""}`,
                    onClick: () => S(F),
                    children: [
                      /* @__PURE__ */ r(
                        "span",
                        {
                          className: "font-picker-item-name",
                          style: {
                            fontFamily: b ? `'${F.name}', sans-serif` : "inherit"
                          },
                          children: F.name
                        }
                      ),
                      X && /* @__PURE__ */ r(
                        Ce,
                        {
                          size: 16,
                          className: "font-picker-check"
                        }
                      )
                    ]
                  }
                ) }, F.name);
              })
            ] }, C)
          )
        ] }),
        a === "upload" && /* @__PURE__ */ m("div", { className: "font-picker-upload", children: [
          /* @__PURE__ */ r("p", { className: "font-picker-description", children: "Upload your own font file. Supported formats: WOFF2, WOFF, TTF, OTF." }),
          /* @__PURE__ */ r(
            "input",
            {
              ref: f,
              type: "file",
              accept: ".woff2,.woff,.ttf,.otf",
              onChange: z,
              style: { display: "none" }
            }
          ),
          s ? /* @__PURE__ */ m("div", { className: "font-picker-upload-preview", children: [
            /* @__PURE__ */ m("div", { className: "font-picker-upload-file", children: [
              /* @__PURE__ */ r("span", { className: "font-picker-upload-filename", children: s.name }),
              /* @__PURE__ */ r(
                U,
                {
                  variant: "ghost",
                  size: "sm",
                  onClick: () => {
                    var C;
                    return (C = f.current) == null ? void 0 : C.click();
                  },
                  children: "Change"
                }
              )
            ] }),
            /* @__PURE__ */ m("div", { className: "font-picker-upload-name", children: [
              /* @__PURE__ */ r("label", { className: "font-picker-upload-label", children: "Font name" }),
              /* @__PURE__ */ r(
                "input",
                {
                  type: "text",
                  value: y,
                  onChange: (C) => R(C.target.value),
                  placeholder: "Enter font name",
                  className: "font-picker-upload-input"
                }
              )
            ] })
          ] }) : /* @__PURE__ */ m(
            "div",
            {
              className: "font-picker-upload-zone",
              onClick: () => {
                var C;
                return (C = f.current) == null ? void 0 : C.click();
              },
              children: [
                /* @__PURE__ */ r(yo, { size: 32, className: "font-picker-upload-icon" }),
                /* @__PURE__ */ r("span", { className: "font-picker-upload-text", children: "Click to upload font file" }),
                /* @__PURE__ */ r("span", { className: "font-picker-upload-hint", children: "WOFF2, WOFF, TTF, or OTF" })
              ]
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ m("div", { className: "font-picker-footer", children: [
        /* @__PURE__ */ r(U, { variant: "outline", onClick: t, disabled: n, children: "Cancel" }),
        /* @__PURE__ */ r(
          U,
          {
            variant: "primary",
            onClick: x,
            disabled: L,
            children: n ? "Adding..." : "Select"
          }
        )
      ] })
    ] }) })
  ] });
  return ge.createPortal(D, Re());
}, lo = [
  "arrows",
  "commerce",
  "communication",
  "devices",
  "files",
  "layout",
  "media",
  "navigation",
  "social",
  "symbols",
  "text",
  "weather"
], Oe = [
  // === ARROWS ===
  { name: "arrow-up", tags: ["up", "direction"], category: "arrows" },
  { name: "arrow-down", tags: ["down", "direction"], category: "arrows" },
  {
    name: "arrow-left",
    tags: ["left", "direction", "back"],
    category: "arrows"
  },
  {
    name: "arrow-right",
    tags: ["right", "direction", "forward"],
    category: "arrows"
  },
  {
    name: "arrow-up-right",
    tags: ["diagonal", "external"],
    category: "arrows"
  },
  { name: "arrow-down-left", tags: ["diagonal"], category: "arrows" },
  { name: "arrow-up-left", tags: ["diagonal"], category: "arrows" },
  { name: "arrow-down-right", tags: ["diagonal"], category: "arrows" },
  { name: "chevron-up", tags: ["up", "expand"], category: "arrows" },
  { name: "chevron-down", tags: ["down", "collapse"], category: "arrows" },
  { name: "chevron-left", tags: ["left", "back"], category: "arrows" },
  { name: "chevron-right", tags: ["right", "forward"], category: "arrows" },
  { name: "chevrons-up", tags: ["up", "double"], category: "arrows" },
  { name: "chevrons-down", tags: ["down", "double"], category: "arrows" },
  { name: "chevrons-left", tags: ["left", "double"], category: "arrows" },
  { name: "chevrons-right", tags: ["right", "double"], category: "arrows" },
  { name: "move", tags: ["drag", "reorder"], category: "arrows" },
  { name: "move-horizontal", tags: ["drag", "resize"], category: "arrows" },
  { name: "move-vertical", tags: ["drag", "resize"], category: "arrows" },
  {
    name: "refresh-cw",
    tags: ["reload", "sync", "refresh"],
    category: "arrows"
  },
  { name: "refresh-ccw", tags: ["reload", "undo"], category: "arrows" },
  { name: "rotate-cw", tags: ["rotate", "clockwise"], category: "arrows" },
  { name: "rotate-ccw", tags: ["rotate", "counter"], category: "arrows" },
  { name: "undo", tags: ["back", "reverse"], category: "arrows" },
  { name: "redo", tags: ["forward"], category: "arrows" },
  { name: "repeat", tags: ["loop", "cycle"], category: "arrows" },
  { name: "corner-down-left", tags: ["enter", "return"], category: "arrows" },
  { name: "corner-down-right", tags: ["turn"], category: "arrows" },
  { name: "corner-up-left", tags: ["turn"], category: "arrows" },
  { name: "corner-up-right", tags: ["turn"], category: "arrows" },
  // === COMMERCE ===
  {
    name: "shopping-cart",
    tags: ["cart", "buy", "ecommerce"],
    category: "commerce"
  },
  { name: "shopping-bag", tags: ["bag", "buy", "store"], category: "commerce" },
  {
    name: "credit-card",
    tags: ["payment", "card", "money"],
    category: "commerce"
  },
  { name: "wallet", tags: ["money", "payment"], category: "commerce" },
  { name: "receipt", tags: ["invoice", "bill"], category: "commerce" },
  { name: "tag", tags: ["label", "price"], category: "commerce" },
  { name: "tags", tags: ["labels", "prices"], category: "commerce" },
  { name: "percent", tags: ["discount", "sale"], category: "commerce" },
  {
    name: "dollar-sign",
    tags: ["money", "currency", "price"],
    category: "commerce"
  },
  {
    name: "banknote",
    tags: ["money", "cash", "payment"],
    category: "commerce"
  },
  { name: "coins", tags: ["money", "currency"], category: "commerce" },
  { name: "gift", tags: ["present", "reward"], category: "commerce" },
  {
    name: "package",
    tags: ["box", "shipping", "delivery"],
    category: "commerce"
  },
  { name: "truck", tags: ["delivery", "shipping"], category: "commerce" },
  { name: "store", tags: ["shop", "retail"], category: "commerce" },
  { name: "barcode", tags: ["scan", "product"], category: "commerce" },
  { name: "qr-code", tags: ["scan", "code"], category: "commerce" },
  // === COMMUNICATION ===
  {
    name: "mail",
    tags: ["email", "message", "envelope"],
    category: "communication"
  },
  { name: "mail-open", tags: ["email", "read"], category: "communication" },
  { name: "inbox", tags: ["email", "messages"], category: "communication" },
  {
    name: "send",
    tags: ["email", "message", "submit"],
    category: "communication"
  },
  {
    name: "message-circle",
    tags: ["chat", "comment"],
    category: "communication"
  },
  {
    name: "message-square",
    tags: ["chat", "comment"],
    category: "communication"
  },
  {
    name: "messages-square",
    tags: ["chat", "conversation"],
    category: "communication"
  },
  { name: "phone", tags: ["call", "contact"], category: "communication" },
  { name: "phone-call", tags: ["calling", "ring"], category: "communication" },
  {
    name: "phone-incoming",
    tags: ["call", "receive"],
    category: "communication"
  },
  { name: "phone-outgoing", tags: ["call", "dial"], category: "communication" },
  { name: "phone-missed", tags: ["call", "missed"], category: "communication" },
  {
    name: "video",
    tags: ["camera", "call", "meeting"],
    category: "communication"
  },
  {
    name: "video-off",
    tags: ["camera", "disabled"],
    category: "communication"
  },
  {
    name: "mic",
    tags: ["microphone", "audio", "voice"],
    category: "communication"
  },
  { name: "mic-off", tags: ["mute", "silent"], category: "communication" },
  { name: "bell", tags: ["notification", "alert"], category: "communication" },
  {
    name: "bell-off",
    tags: ["notification", "mute"],
    category: "communication"
  },
  {
    name: "bell-ring",
    tags: ["notification", "alert"],
    category: "communication"
  },
  { name: "at-sign", tags: ["email", "mention"], category: "communication" },
  // === DEVICES ===
  {
    name: "smartphone",
    tags: ["phone", "mobile", "device"],
    category: "devices"
  },
  { name: "tablet", tags: ["ipad", "device"], category: "devices" },
  { name: "laptop", tags: ["computer", "device"], category: "devices" },
  {
    name: "monitor",
    tags: ["screen", "display", "desktop"],
    category: "devices"
  },
  { name: "tv", tags: ["television", "screen"], category: "devices" },
  { name: "watch", tags: ["time", "wearable"], category: "devices" },
  { name: "headphones", tags: ["audio", "music"], category: "devices" },
  { name: "speaker", tags: ["audio", "sound"], category: "devices" },
  { name: "camera", tags: ["photo", "picture"], category: "devices" },
  { name: "printer", tags: ["print", "document"], category: "devices" },
  { name: "keyboard", tags: ["input", "type"], category: "devices" },
  { name: "mouse", tags: ["input", "click"], category: "devices" },
  { name: "gamepad", tags: ["game", "controller"], category: "devices" },
  { name: "cpu", tags: ["processor", "chip"], category: "devices" },
  { name: "hard-drive", tags: ["storage", "disk"], category: "devices" },
  { name: "usb", tags: ["cable", "port"], category: "devices" },
  {
    name: "wifi",
    tags: ["internet", "network", "wireless"],
    category: "devices"
  },
  { name: "bluetooth", tags: ["wireless", "connect"], category: "devices" },
  { name: "battery", tags: ["power", "charge"], category: "devices" },
  { name: "battery-charging", tags: ["power", "charge"], category: "devices" },
  { name: "plug", tags: ["power", "electric"], category: "devices" },
  // === FILES ===
  { name: "file", tags: ["document", "page"], category: "files" },
  { name: "file-text", tags: ["document", "text"], category: "files" },
  { name: "file-image", tags: ["picture", "photo"], category: "files" },
  { name: "file-video", tags: ["movie", "media"], category: "files" },
  { name: "file-audio", tags: ["music", "sound"], category: "files" },
  { name: "file-code", tags: ["code", "programming"], category: "files" },
  { name: "file-json", tags: ["data", "code"], category: "files" },
  { name: "file-spreadsheet", tags: ["excel", "data"], category: "files" },
  { name: "file-archive", tags: ["zip", "compress"], category: "files" },
  { name: "file-plus", tags: ["add", "new"], category: "files" },
  { name: "file-minus", tags: ["remove", "delete"], category: "files" },
  { name: "file-check", tags: ["done", "complete"], category: "files" },
  { name: "file-x", tags: ["delete", "remove"], category: "files" },
  { name: "folder", tags: ["directory"], category: "files" },
  { name: "folder-open", tags: ["directory", "open"], category: "files" },
  { name: "folder-plus", tags: ["add", "new"], category: "files" },
  { name: "folder-minus", tags: ["remove"], category: "files" },
  { name: "clipboard", tags: ["copy", "paste"], category: "files" },
  { name: "clipboard-check", tags: ["done", "complete"], category: "files" },
  { name: "copy", tags: ["duplicate", "clipboard"], category: "files" },
  { name: "scissors", tags: ["cut"], category: "files" },
  { name: "download", tags: ["save", "get"], category: "files" },
  { name: "upload", tags: ["send", "share"], category: "files" },
  { name: "cloud", tags: ["storage", "online"], category: "files" },
  { name: "cloud-download", tags: ["download", "sync"], category: "files" },
  { name: "cloud-upload", tags: ["upload", "sync"], category: "files" },
  { name: "archive", tags: ["box", "storage"], category: "files" },
  { name: "trash", tags: ["delete", "remove"], category: "files" },
  { name: "trash-2", tags: ["delete", "remove"], category: "files" },
  // === LAYOUT ===
  { name: "layout", tags: ["template", "design"], category: "layout" },
  { name: "layout-grid", tags: ["grid", "template"], category: "layout" },
  { name: "layout-list", tags: ["list", "rows"], category: "layout" },
  {
    name: "layout-dashboard",
    tags: ["dashboard", "widgets"],
    category: "layout"
  },
  { name: "grid-2x2", tags: ["grid", "squares"], category: "layout" },
  { name: "grid-3x3", tags: ["grid", "squares"], category: "layout" },
  { name: "list", tags: ["items", "menu"], category: "layout" },
  { name: "list-ordered", tags: ["numbers", "ol"], category: "layout" },
  { name: "list-checks", tags: ["todo", "tasks"], category: "layout" },
  { name: "table", tags: ["data", "spreadsheet"], category: "layout" },
  { name: "columns", tags: ["layout", "split"], category: "layout" },
  { name: "rows", tags: ["layout", "split"], category: "layout" },
  { name: "sidebar", tags: ["panel", "nav"], category: "layout" },
  { name: "panel-left", tags: ["sidebar", "layout"], category: "layout" },
  { name: "panel-right", tags: ["sidebar", "layout"], category: "layout" },
  { name: "panel-top", tags: ["header", "layout"], category: "layout" },
  { name: "panel-bottom", tags: ["footer", "layout"], category: "layout" },
  { name: "maximize", tags: ["fullscreen", "expand"], category: "layout" },
  { name: "maximize-2", tags: ["fullscreen", "expand"], category: "layout" },
  { name: "minimize", tags: ["exit", "shrink"], category: "layout" },
  { name: "minimize-2", tags: ["exit", "shrink"], category: "layout" },
  { name: "split", tags: ["divide", "separate"], category: "layout" },
  { name: "merge", tags: ["combine", "join"], category: "layout" },
  // === MEDIA ===
  { name: "play", tags: ["start", "video", "audio"], category: "media" },
  { name: "pause", tags: ["stop", "wait"], category: "media" },
  { name: "stop-circle", tags: ["end", "halt"], category: "media" },
  { name: "skip-back", tags: ["previous", "rewind"], category: "media" },
  { name: "skip-forward", tags: ["next", "forward"], category: "media" },
  { name: "rewind", tags: ["backward", "reverse"], category: "media" },
  { name: "fast-forward", tags: ["forward", "speed"], category: "media" },
  { name: "volume", tags: ["sound", "audio"], category: "media" },
  { name: "volume-1", tags: ["sound", "low"], category: "media" },
  { name: "volume-2", tags: ["sound", "high"], category: "media" },
  { name: "volume-x", tags: ["mute", "silent"], category: "media" },
  { name: "music", tags: ["audio", "song"], category: "media" },
  { name: "music-2", tags: ["audio", "notes"], category: "media" },
  { name: "music-3", tags: ["audio", "notes"], category: "media" },
  { name: "music-4", tags: ["audio", "notes"], category: "media" },
  { name: "image", tags: ["picture", "photo"], category: "media" },
  { name: "images", tags: ["pictures", "gallery"], category: "media" },
  { name: "film", tags: ["movie", "video"], category: "media" },
  { name: "clapperboard", tags: ["movie", "film"], category: "media" },
  { name: "disc", tags: ["cd", "dvd", "music"], category: "media" },
  { name: "radio", tags: ["music", "broadcast"], category: "media" },
  { name: "podcast", tags: ["audio", "broadcast"], category: "media" },
  { name: "cast", tags: ["stream", "broadcast"], category: "media" },
  { name: "airplay", tags: ["stream", "mirror"], category: "media" },
  { name: "screen-share", tags: ["present", "stream"], category: "media" },
  { name: "screen-share-off", tags: ["stop", "stream"], category: "media" },
  // === NAVIGATION ===
  { name: "home", tags: ["house", "main"], category: "navigation" },
  { name: "menu", tags: ["hamburger", "nav"], category: "navigation" },
  {
    name: "more-horizontal",
    tags: ["dots", "options"],
    category: "navigation"
  },
  { name: "more-vertical", tags: ["dots", "options"], category: "navigation" },
  { name: "grip-horizontal", tags: ["drag", "handle"], category: "navigation" },
  { name: "grip-vertical", tags: ["drag", "handle"], category: "navigation" },
  { name: "search", tags: ["find", "magnify"], category: "navigation" },
  { name: "zoom-in", tags: ["magnify", "enlarge"], category: "navigation" },
  { name: "zoom-out", tags: ["shrink", "reduce"], category: "navigation" },
  { name: "filter", tags: ["sort", "funnel"], category: "navigation" },
  {
    name: "settings",
    tags: ["gear", "config", "preferences"],
    category: "navigation"
  },
  { name: "settings-2", tags: ["sliders", "config"], category: "navigation" },
  {
    name: "sliders-horizontal",
    tags: ["settings", "adjust"],
    category: "navigation"
  },
  {
    name: "sliders-vertical",
    tags: ["settings", "adjust"],
    category: "navigation"
  },
  { name: "map", tags: ["location", "navigation"], category: "navigation" },
  { name: "map-pin", tags: ["location", "marker"], category: "navigation" },
  { name: "navigation", tags: ["direction", "arrow"], category: "navigation" },
  {
    name: "compass",
    tags: ["direction", "navigation"],
    category: "navigation"
  },
  { name: "globe", tags: ["world", "earth", "web"], category: "navigation" },
  { name: "locate", tags: ["gps", "position"], category: "navigation" },
  { name: "crosshair", tags: ["target", "aim"], category: "navigation" },
  { name: "bookmark", tags: ["save", "favorite"], category: "navigation" },
  { name: "flag", tags: ["mark", "report"], category: "navigation" },
  { name: "hash", tags: ["tag", "number"], category: "navigation" },
  { name: "link", tags: ["url", "chain"], category: "navigation" },
  { name: "link-2", tags: ["url", "chain"], category: "navigation" },
  { name: "unlink", tags: ["break", "disconnect"], category: "navigation" },
  {
    name: "external-link",
    tags: ["open", "new window"],
    category: "navigation"
  },
  { name: "log-in", tags: ["sign in", "enter"], category: "navigation" },
  { name: "log-out", tags: ["sign out", "exit"], category: "navigation" },
  // === SOCIAL ===
  { name: "user", tags: ["person", "account", "profile"], category: "social" },
  { name: "user-plus", tags: ["add", "follow"], category: "social" },
  { name: "user-minus", tags: ["remove", "unfollow"], category: "social" },
  { name: "user-check", tags: ["verified", "approved"], category: "social" },
  { name: "user-x", tags: ["delete", "remove"], category: "social" },
  { name: "users", tags: ["people", "team", "group"], category: "social" },
  { name: "user-circle", tags: ["avatar", "profile"], category: "social" },
  { name: "contact", tags: ["person", "card"], category: "social" },
  { name: "heart", tags: ["like", "love", "favorite"], category: "social" },
  { name: "thumbs-up", tags: ["like", "approve"], category: "social" },
  { name: "thumbs-down", tags: ["dislike", "disapprove"], category: "social" },
  { name: "star", tags: ["favorite", "rating"], category: "social" },
  { name: "award", tags: ["achievement", "badge"], category: "social" },
  { name: "trophy", tags: ["winner", "achievement"], category: "social" },
  { name: "medal", tags: ["achievement", "award"], category: "social" },
  { name: "share", tags: ["social", "send"], category: "social" },
  { name: "share-2", tags: ["social", "network"], category: "social" },
  { name: "rss", tags: ["feed", "subscribe"], category: "social" },
  { name: "smile", tags: ["emoji", "happy"], category: "social" },
  { name: "frown", tags: ["emoji", "sad"], category: "social" },
  { name: "meh", tags: ["emoji", "neutral"], category: "social" },
  { name: "laugh", tags: ["emoji", "happy"], category: "social" },
  { name: "angry", tags: ["emoji", "mad"], category: "social" },
  // === SYMBOLS ===
  { name: "check", tags: ["done", "complete", "yes"], category: "symbols" },
  { name: "check-circle", tags: ["done", "success"], category: "symbols" },
  { name: "check-square", tags: ["done", "checkbox"], category: "symbols" },
  { name: "x", tags: ["close", "cancel", "no"], category: "symbols" },
  { name: "x-circle", tags: ["close", "error"], category: "symbols" },
  { name: "x-square", tags: ["close", "cancel"], category: "symbols" },
  { name: "plus", tags: ["add", "new", "create"], category: "symbols" },
  { name: "plus-circle", tags: ["add", "new"], category: "symbols" },
  { name: "plus-square", tags: ["add", "new"], category: "symbols" },
  { name: "minus", tags: ["remove", "subtract"], category: "symbols" },
  { name: "minus-circle", tags: ["remove"], category: "symbols" },
  { name: "minus-square", tags: ["remove"], category: "symbols" },
  { name: "circle", tags: ["shape", "dot"], category: "symbols" },
  { name: "square", tags: ["shape", "box"], category: "symbols" },
  { name: "triangle", tags: ["shape", "warning"], category: "symbols" },
  { name: "octagon", tags: ["stop", "shape"], category: "symbols" },
  { name: "info", tags: ["information", "help"], category: "symbols" },
  { name: "alert-circle", tags: ["warning", "error"], category: "symbols" },
  { name: "alert-triangle", tags: ["warning", "caution"], category: "symbols" },
  { name: "help-circle", tags: ["question", "support"], category: "symbols" },
  { name: "ban", tags: ["block", "forbidden"], category: "symbols" },
  { name: "shield", tags: ["security", "protect"], category: "symbols" },
  { name: "shield-check", tags: ["secure", "verified"], category: "symbols" },
  { name: "lock", tags: ["secure", "private"], category: "symbols" },
  { name: "unlock", tags: ["open", "public"], category: "symbols" },
  { name: "key", tags: ["password", "access"], category: "symbols" },
  { name: "eye", tags: ["view", "visible", "show"], category: "symbols" },
  { name: "eye-off", tags: ["hide", "invisible"], category: "symbols" },
  { name: "zap", tags: ["lightning", "fast", "power"], category: "symbols" },
  { name: "flame", tags: ["fire", "hot", "trending"], category: "symbols" },
  { name: "sparkles", tags: ["magic", "new", "ai"], category: "symbols" },
  { name: "wand", tags: ["magic", "transform"], category: "symbols" },
  { name: "target", tags: ["goal", "aim"], category: "symbols" },
  { name: "clock", tags: ["time", "schedule"], category: "symbols" },
  { name: "timer", tags: ["countdown", "stopwatch"], category: "symbols" },
  {
    name: "calendar",
    tags: ["date", "schedule", "event"],
    category: "symbols"
  },
  { name: "hourglass", tags: ["time", "wait"], category: "symbols" },
  { name: "infinity", tags: ["endless", "loop"], category: "symbols" },
  // === TEXT ===
  { name: "type", tags: ["text", "font"], category: "text" },
  { name: "bold", tags: ["text", "strong"], category: "text" },
  { name: "italic", tags: ["text", "emphasis"], category: "text" },
  { name: "underline", tags: ["text", "format"], category: "text" },
  { name: "strikethrough", tags: ["text", "delete"], category: "text" },
  { name: "align-left", tags: ["text", "paragraph"], category: "text" },
  { name: "align-center", tags: ["text", "paragraph"], category: "text" },
  { name: "align-right", tags: ["text", "paragraph"], category: "text" },
  { name: "align-justify", tags: ["text", "paragraph"], category: "text" },
  { name: "indent", tags: ["text", "tab"], category: "text" },
  { name: "outdent", tags: ["text", "tab"], category: "text" },
  { name: "heading-1", tags: ["text", "h1"], category: "text" },
  { name: "heading-2", tags: ["text", "h2"], category: "text" },
  { name: "heading-3", tags: ["text", "h3"], category: "text" },
  { name: "heading-4", tags: ["text", "h4"], category: "text" },
  { name: "heading-5", tags: ["text", "h5"], category: "text" },
  { name: "heading-6", tags: ["text", "h6"], category: "text" },
  { name: "pilcrow", tags: ["paragraph", "text"], category: "text" },
  { name: "quote", tags: ["blockquote", "cite"], category: "text" },
  { name: "code", tags: ["programming", "syntax"], category: "text" },
  { name: "braces", tags: ["code", "curly"], category: "text" },
  { name: "brackets", tags: ["code", "square"], category: "text" },
  { name: "parentheses", tags: ["code", "round"], category: "text" },
  { name: "terminal", tags: ["code", "command"], category: "text" },
  { name: "pencil", tags: ["edit", "write"], category: "text" },
  { name: "pen", tags: ["edit", "write"], category: "text" },
  { name: "highlighter", tags: ["mark", "highlight"], category: "text" },
  { name: "eraser", tags: ["delete", "remove"], category: "text" },
  { name: "text-cursor", tags: ["input", "caret"], category: "text" },
  { name: "text-cursor-input", tags: ["input", "field"], category: "text" },
  { name: "spell-check", tags: ["grammar", "correct"], category: "text" },
  { name: "languages", tags: ["translate", "i18n"], category: "text" },
  // === WEATHER ===
  { name: "sun", tags: ["day", "bright", "light"], category: "weather" },
  { name: "moon", tags: ["night", "dark"], category: "weather" },
  { name: "cloud", tags: ["weather", "overcast"], category: "weather" },
  { name: "cloud-sun", tags: ["partly cloudy"], category: "weather" },
  { name: "cloud-moon", tags: ["night", "cloudy"], category: "weather" },
  { name: "cloud-rain", tags: ["rain", "weather"], category: "weather" },
  { name: "cloud-drizzle", tags: ["light rain"], category: "weather" },
  { name: "cloud-snow", tags: ["snow", "winter"], category: "weather" },
  { name: "cloud-lightning", tags: ["storm", "thunder"], category: "weather" },
  { name: "cloud-fog", tags: ["mist", "haze"], category: "weather" },
  { name: "snowflake", tags: ["snow", "winter", "cold"], category: "weather" },
  { name: "wind", tags: ["breeze", "air"], category: "weather" },
  { name: "droplet", tags: ["water", "rain"], category: "weather" },
  { name: "droplets", tags: ["water", "humidity"], category: "weather" },
  { name: "thermometer", tags: ["temperature", "heat"], category: "weather" },
  { name: "rainbow", tags: ["weather", "colors"], category: "weather" },
  { name: "umbrella", tags: ["rain", "protection"], category: "weather" },
  { name: "sunrise", tags: ["morning", "dawn"], category: "weather" },
  { name: "sunset", tags: ["evening", "dusk"], category: "weather" }
], so = (e) => `https://unpkg.com/lucide-static@latest/icons/${e}.svg`, oi = (e) => {
  const t = e.toLowerCase().trim();
  return t ? Oe.filter(
    (o) => o.name.toLowerCase().includes(t) || o.tags.some((n) => n.toLowerCase().includes(t)) || o.category.toLowerCase().includes(t)
  ) : Oe;
}, co = (e) => Oe.filter((t) => t.category === e), ri = () => `
  /* Overlay */
  .icon-picker-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000002;
    animation: icon-picker-fade-in 0.2s ease;
  }

  @keyframes icon-picker-fade-in {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  /* Modal */
  .icon-picker-modal {
    background: ${i.white};
    border-radius: 16px;
    width: 90%;
    max-width: 680px;
    max-height: 85vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 25px 80px rgba(0, 0, 0, 0.25);
    animation: icon-picker-slide-up 0.25s ease;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  }

  @keyframes icon-picker-slide-up {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  /* Header */
  .icon-picker-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 24px;
    border-bottom: 1px solid ${i.border_glass};
  }

  .icon-picker-title {
    font-size: 18px;
    font-weight: 600;
    color: ${i.primary};
    margin: 0;
  }

  /* Search */
  .icon-picker-search {
    padding: 16px 24px;
    border-bottom: 1px solid ${i.border_glass};
    position: relative;
  }

  .icon-picker-search-icon {
    position: absolute;
    left: 40px;
    top: 50%;
    transform: translateY(-50%);
    color: ${i.gray_medium};
  }

  .icon-picker-search-input {
    width: 100%;
    padding: 12px 16px 12px 44px;
    border: 1px solid ${i.border_glass};
    border-radius: 10px;
    font-size: 14px;
    color: ${i.primary};
    background: ${i.bg_light};
    outline: none;
    transition: all 0.15s ease;
    box-sizing: border-box;
  }

  .icon-picker-search-input:focus {
    border-color: ${i.blue};
    background: ${i.white};
    box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.15);
  }

  .icon-picker-search-input::placeholder {
    color: ${i.gray_medium};
  }

  /* Tabs */
  .icon-picker-tabs {
    display: flex;
    padding: 0 24px;
    border-bottom: 1px solid ${i.border_glass};
  }

  .icon-picker-tab {
    padding: 14px 20px;
    border: none;
    background: transparent;
    font-size: 13px;
    font-weight: 500;
    color: ${i.gray_medium};
    cursor: pointer;
    position: relative;
    transition: color 0.15s ease;
  }

  .icon-picker-tab:hover {
    color: ${i.primary};
  }

  .icon-picker-tab.active {
    color: ${i.primary};
  }

  .icon-picker-tab.active::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    right: 0;
    height: 2px;
    background: ${i.primary};
    border-radius: 2px 2px 0 0;
  }

  /* Content */
  .icon-picker-content {
    flex: 1;
    overflow-y: auto;
    min-height: 0;
  }

  .icon-picker-description {
    font-size: 13px;
    color: ${i.gray_medium};
    padding: 16px 24px 8px;
    margin: 0;
    line-height: 1.5;
  }

  /* Category Filter */
  .icon-picker-categories {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    padding: 16px 24px;
    border-bottom: 1px solid ${i.border_glass};
  }

  .icon-picker-category-btn {
    padding: 6px 14px;
    border: 1px solid ${i.border_glass};
    border-radius: 20px;
    background: ${i.white};
    font-size: 12px;
    font-weight: 500;
    color: ${i.gray_dark};
    cursor: pointer;
    transition: all 0.15s ease;
  }

  .icon-picker-category-btn:hover {
    border-color: ${i.blue};
    color: ${i.blue};
  }

  .icon-picker-category-btn.active {
    background: ${i.primary};
    border-color: ${i.primary};
    color: ${i.white};
  }

  /* Icons Container */
  .icon-picker-icons-container {
    padding: 16px 24px;
  }

  .icon-picker-category-section {
    margin-bottom: 24px;
  }

  .icon-picker-category-section:last-child {
    margin-bottom: 0;
  }

  .icon-picker-category-title {
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: ${i.gray_medium};
    margin: 0 0 12px 0;
  }

  /* Icons Grid */
  .icon-picker-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(52px, 1fr));
    gap: 8px;
  }

  .icon-picker-icon-item {
    position: relative;
    width: 52px;
    height: 52px;
    border: 1px solid ${i.border_glass};
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.15s ease;
    background: ${i.white};
  }

  .icon-picker-icon-item:hover {
    border-color: ${i.blue};
    background: rgba(85, 114, 183, 0.04);
    transform: scale(1.05);
  }

  .icon-picker-icon-item.selected {
    border-color: ${i.blue};
    background: rgba(85, 114, 183, 0.08);
    box-shadow: 0 0 0 2px rgba(85, 114, 183, 0.2);
  }

  .icon-picker-icon-preview {
    width: 24px;
    height: 24px;
    object-fit: contain;
  }

  .icon-picker-icon-check {
    position: absolute;
    top: -6px;
    right: -6px;
    width: 18px;
    height: 18px;
    background: ${i.blue};
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${i.white};
  }

  .icon-picker-empty {
    text-align: center;
    padding: 48px 24px;
    color: ${i.gray_medium};
  }

  /* Selected Icon Info */
  .icon-picker-selected-info {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 24px;
    background: ${i.bg_light};
    border-top: 1px solid ${i.border_glass};
  }

  .icon-picker-selected-preview {
    width: 32px;
    height: 32px;
    object-fit: contain;
  }

  .icon-picker-selected-name {
    font-size: 14px;
    font-weight: 500;
    color: ${i.primary};
    font-family: 'SF Mono', 'Menlo', monospace;
  }

  /* Upload Tab */
  .icon-picker-upload {
    padding: 16px 24px;
  }

  .icon-picker-upload-zone {
    border: 2px dashed ${i.gray_border};
    border-radius: 12px;
    padding: 48px 24px;
    text-align: center;
    cursor: pointer;
    transition: all 0.15s ease;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    margin-top: 8px;
  }

  .icon-picker-upload-zone:hover {
    border-color: ${i.blue};
    background: rgba(85, 114, 183, 0.04);
  }

  .icon-picker-upload-icon {
    color: ${i.gray_medium};
  }

  .icon-picker-upload-text {
    font-size: 14px;
    font-weight: 500;
    color: ${i.primary};
  }

  .icon-picker-upload-hint {
    font-size: 12px;
    color: ${i.gray_medium};
  }

  .icon-picker-upload-preview {
    margin-top: 16px;
  }

  .icon-picker-upload-file {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 16px;
    background: ${i.bg_light};
    border-radius: 10px;
    margin-bottom: 16px;
  }

  .icon-picker-svg-preview {
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .icon-picker-svg-preview svg {
    max-width: 100%;
    max-height: 100%;
  }

  .icon-picker-upload-file-info {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }

  .icon-picker-upload-filename {
    font-size: 14px;
    font-weight: 500;
    color: ${i.primary};
    font-family: 'SF Mono', 'Menlo', monospace;
  }

  .icon-picker-upload-name {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .icon-picker-upload-label {
    font-size: 12px;
    font-weight: 600;
    color: ${i.gray_medium};
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .icon-picker-upload-input {
    padding: 12px 14px;
    border: 1px solid ${i.border_glass};
    border-radius: 10px;
    font-size: 14px;
    color: ${i.primary};
    background: ${i.white};
    outline: none;
    transition: all 0.15s ease;
    box-sizing: border-box;
  }

  .icon-picker-upload-input:focus {
    border-color: ${i.blue};
    box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.15);
  }

  /* Footer */
  .icon-picker-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding: 20px 24px;
    border-top: 1px solid ${i.border_glass};
    background: ${i.bg_light};
    border-radius: 0 0 16px 16px;
  }
`, po = ({
  isOpen: e,
  onClose: t,
  onSelect: o,
  isLoading: n = !1
}) => {
  const [a, l] = N("lucide"), [d, p] = N(""), [c, u] = N(null), [s, g] = N("all"), [y, k] = N(null), [f, b] = N(""), [h, w] = N(null), B = te(null);
  $(() => {
    e && (p(""), u(null), g("all"), k(null), b(""), w(null));
  }, [e]);
  const T = le(() => {
    let I;
    return d ? I = oi(d) : s === "all" ? I = Oe : I = co(s), I;
  }, [d, s]), S = le(() => {
    if (d || s !== "all")
      return {
        [s === "all" ? "results" : s]: T
      };
    const I = {};
    return lo.forEach((D) => {
      I[D] = co(D);
    }), I;
  }, [T, d, s]), z = (I) => {
    u({
      type: "lucide",
      name: I.name,
      url: so(I.name)
    });
  }, O = async (I) => {
    var C;
    const D = (C = I.target.files) == null ? void 0 : C[0];
    if (D) {
      k(D);
      const E = D.name.replace(/\.[^/.]+$/, "");
      b(E);
      const F = new FileReader();
      F.onload = (X) => {
        var j;
        const H = (j = X.target) == null ? void 0 : j.result;
        w(H);
      }, F.readAsText(D), u({
        type: "upload",
        name: E,
        file: D
      });
    }
  }, R = (I) => {
    b(I), (c == null ? void 0 : c.type) === "upload" && y && u({
      ...c,
      name: I
    });
  }, x = () => {
    c && (o(c), t());
  }, L = n || !c || c.type === "upload" && (!y || !f.trim());
  if (!e) return null;
  const Y = /* @__PURE__ */ m(G, { children: [
    /* @__PURE__ */ r("style", { children: ri() }),
    /* @__PURE__ */ r("div", { className: "icon-picker-overlay", onClick: t, children: /* @__PURE__ */ m("div", { className: "icon-picker-modal", onClick: (I) => I.stopPropagation(), children: [
      /* @__PURE__ */ m("div", { className: "icon-picker-header", children: [
        /* @__PURE__ */ r("h2", { className: "icon-picker-title", children: "Select icon" }),
        /* @__PURE__ */ r(
          U,
          {
            variant: "icon",
            size: "sm",
            onClick: t,
            "aria-label": "Close",
            children: /* @__PURE__ */ r(ue, { size: 20 })
          }
        )
      ] }),
      /* @__PURE__ */ m("div", { className: "icon-picker-search", children: [
        /* @__PURE__ */ r(ho, { size: 16, className: "icon-picker-search-icon" }),
        /* @__PURE__ */ r(
          "input",
          {
            type: "text",
            placeholder: "Search icons...",
            value: d,
            onChange: (I) => p(I.target.value),
            className: "icon-picker-search-input",
            autoFocus: !0
          }
        )
      ] }),
      /* @__PURE__ */ m("div", { className: "icon-picker-tabs", children: [
        /* @__PURE__ */ r(
          "button",
          {
            className: `icon-picker-tab ${a === "lucide" ? "active" : ""}`,
            onClick: () => l("lucide"),
            children: "Lucide Icons"
          }
        ),
        /* @__PURE__ */ r(
          "button",
          {
            className: `icon-picker-tab ${a === "upload" ? "active" : ""}`,
            onClick: () => l("upload"),
            children: "Upload SVG"
          }
        )
      ] }),
      /* @__PURE__ */ m("div", { className: "icon-picker-content", children: [
        a === "lucide" && /* @__PURE__ */ m(G, { children: [
          /* @__PURE__ */ m("div", { className: "icon-picker-categories", children: [
            /* @__PURE__ */ r(
              "button",
              {
                className: `icon-picker-category-btn ${s === "all" ? "active" : ""}`,
                onClick: () => g("all"),
                children: "All"
              }
            ),
            lo.map((I) => /* @__PURE__ */ r(
              "button",
              {
                className: `icon-picker-category-btn ${s === I ? "active" : ""}`,
                onClick: () => g(I),
                children: I.charAt(0).toUpperCase() + I.slice(1)
              },
              I
            ))
          ] }),
          /* @__PURE__ */ m("div", { className: "icon-picker-icons-container", children: [
            Object.entries(S).map(([I, D]) => /* @__PURE__ */ m(
              "div",
              {
                className: "icon-picker-category-section",
                children: [
                  !d && s === "all" && /* @__PURE__ */ r("h4", { className: "icon-picker-category-title", children: I.charAt(0).toUpperCase() + I.slice(1) }),
                  /* @__PURE__ */ r("div", { className: "icon-picker-grid", children: D.map((C) => /* @__PURE__ */ m(
                    "div",
                    {
                      className: `icon-picker-icon-item ${(c == null ? void 0 : c.type) === "lucide" && (c == null ? void 0 : c.name) === C.name ? "selected" : ""}`,
                      onClick: () => z(C),
                      title: C.name,
                      children: [
                        /* @__PURE__ */ r(
                          "img",
                          {
                            src: so(C.name),
                            alt: C.name,
                            className: "icon-picker-icon-preview"
                          }
                        ),
                        (c == null ? void 0 : c.type) === "lucide" && (c == null ? void 0 : c.name) === C.name && /* @__PURE__ */ r("div", { className: "icon-picker-icon-check", children: /* @__PURE__ */ r(Ce, { size: 12 }) })
                      ]
                    },
                    C.name
                  )) })
                ]
              },
              I
            )),
            T.length === 0 && /* @__PURE__ */ r("div", { className: "icon-picker-empty", children: /* @__PURE__ */ m("p", { children: [
              'No icons found for "',
              d,
              '"'
            ] }) })
          ] }),
          (c == null ? void 0 : c.type) === "lucide" && /* @__PURE__ */ m("div", { className: "icon-picker-selected-info", children: [
            /* @__PURE__ */ r(
              "img",
              {
                src: c.url,
                alt: c.name,
                className: "icon-picker-selected-preview"
              }
            ),
            /* @__PURE__ */ r("span", { className: "icon-picker-selected-name", children: c.name })
          ] })
        ] }),
        a === "upload" && /* @__PURE__ */ m("div", { className: "icon-picker-upload", children: [
          /* @__PURE__ */ r("p", { className: "icon-picker-description", children: "Upload your own SVG icon file." }),
          /* @__PURE__ */ r(
            "input",
            {
              ref: B,
              type: "file",
              accept: ".svg",
              onChange: O,
              style: { display: "none" }
            }
          ),
          y ? /* @__PURE__ */ m("div", { className: "icon-picker-upload-preview", children: [
            /* @__PURE__ */ m("div", { className: "icon-picker-upload-file", children: [
              h && /* @__PURE__ */ r(
                "div",
                {
                  className: "icon-picker-svg-preview",
                  dangerouslySetInnerHTML: { __html: h }
                }
              ),
              /* @__PURE__ */ m("div", { className: "icon-picker-upload-file-info", children: [
                /* @__PURE__ */ r("span", { className: "icon-picker-upload-filename", children: y.name }),
                /* @__PURE__ */ r(
                  U,
                  {
                    variant: "ghost",
                    size: "sm",
                    onClick: () => {
                      var I;
                      return (I = B.current) == null ? void 0 : I.click();
                    },
                    children: "Change"
                  }
                )
              ] })
            ] }),
            /* @__PURE__ */ m("div", { className: "icon-picker-upload-name", children: [
              /* @__PURE__ */ r("label", { className: "icon-picker-upload-label", children: "Icon name" }),
              /* @__PURE__ */ r(
                "input",
                {
                  type: "text",
                  value: f,
                  onChange: (I) => R(I.target.value),
                  placeholder: "Enter icon name",
                  className: "icon-picker-upload-input"
                }
              )
            ] })
          ] }) : /* @__PURE__ */ m(
            "div",
            {
              className: "icon-picker-upload-zone",
              onClick: () => {
                var I;
                return (I = B.current) == null ? void 0 : I.click();
              },
              children: [
                /* @__PURE__ */ r(yo, { size: 32, className: "icon-picker-upload-icon" }),
                /* @__PURE__ */ r("span", { className: "icon-picker-upload-text", children: "Click to upload SVG file" }),
                /* @__PURE__ */ r("span", { className: "icon-picker-upload-hint", children: "SVG only" })
              ]
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ m("div", { className: "icon-picker-footer", children: [
        /* @__PURE__ */ r(U, { variant: "outline", onClick: t, disabled: n, children: "Cancel" }),
        /* @__PURE__ */ r(
          U,
          {
            variant: "primary",
            onClick: x,
            disabled: L,
            children: n ? "Adding..." : "Select"
          }
        )
      ] })
    ] }) })
  ] });
  return ge.createPortal(Y, Re());
}, Zi = () => {
  const e = we(), t = bo(), [o, n] = N("checking"), [a, l] = N("desktop"), d = te(null), [p, c] = N(!1), { data: u } = Se(), s = (u == null ? void 0 : u.themeName) || e.themeId, { themeColors: g, refreshThemeColors: y } = nt(), { themeFonts: k, refreshThemeFonts: f } = Mo(), { themeIcons: b, refreshThemeIcons: h } = Ao(), [w, B] = N(null), [T, S] = N(!1), [z, O] = N(!1), R = (E) => {
    B((F) => F === E ? null : E);
  }, x = ei({
    themeId: e.themeId,
    editThemeToken: e.editThemeToken,
    iframeRef: o === "iframe" ? d : null,
    refreshThemeColors: y,
    refreshThemeFonts: f,
    refreshThemeIcons: h
  });
  $(() => {
    t || cn();
  }, [t]), $(() => {
    if (t || !e.themeId) return;
    (async () => {
      const F = await Mr();
      n(F ? "iframe" : "inline");
    })();
  }, [t, e.themeId]);
  const L = de(() => {
    var E;
    if (d.current)
      try {
        const F = new URL(
          ((E = d.current.contentWindow) == null ? void 0 : E.location.href) || ""
        ), X = new URL(window.location.href);
        X.pathname = F.pathname;
        const H = new URLSearchParams(F.search), j = new URLSearchParams();
        e.themeId && j.set("themeId", e.themeId), e.editMode && j.set("editMode", "true"), e.editThemeToken && j.set("editThemeToken", e.editThemeToken), H.forEach((A, Q) => {
          Q !== "frameMode" && Q !== "themeId" && Q !== "editMode" && Q !== "editThemeToken" && j.set(Q, A);
        }), X.search = j.toString(), window.history.replaceState({}, "", X.toString());
      } catch (F) {
        console.debug("Could not access iframe URL (cross-origin):", F);
      }
  }, [e]);
  if (!e.themeId || t)
    return null;
  if (o === "checking")
    return /* @__PURE__ */ m(
      "div",
      {
        style: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          height: 60,
          background: "#f5f5f7",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 8,
          zIndex: 999999,
          fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
          fontSize: 14,
          color: "#666"
        },
        children: [
          /* @__PURE__ */ r(cr, { size: 16, className: "bc-theme-editor-spinner" }),
          /* @__PURE__ */ r("span", { children: "Initializing Theme Editor..." }),
          /* @__PURE__ */ r("style", { children: `
          @keyframes bc-spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
          .bc-theme-editor-spinner {
            animation: bc-spin 1s linear infinite;
          }
        ` })
        ]
      }
    );
  const Y = () => {
    sn(), dn();
    const E = e.origin ? decodeURIComponent(e.origin) : "https://shopperos.stackline.com/integrations/apps";
    window.location.href = E;
  }, I = () => {
    c(!p);
  }, D = async (E) => {
    await x.handleAddFont(E);
  }, C = async (E) => {
    await x.handleAddIcon(E);
  };
  return o === "inline" ? /* @__PURE__ */ m(G, { children: [
    /* @__PURE__ */ r("style", { children: eo({ showSettings: p, viewMode: a, editorMode: o }) }),
    /* @__PURE__ */ m("div", { className: "bc-theme-editor-shell", children: [
      /* @__PURE__ */ m("div", { className: "bc-theme-editor-topbar", children: [
        /* @__PURE__ */ m("div", { className: "bc-theme-editor-logo", children: [
          /* @__PURE__ */ r("div", { className: "bc-theme-editor-logo-icon", children: /* @__PURE__ */ r(lt, { size: 18 }) }),
          /* @__PURE__ */ r("span", { className: "bc-theme-editor-logo-text", children: "Theme Editor" })
        ] }),
        /* @__PURE__ */ m("div", { className: "bc-theme-editor-theme-info", children: [
          /* @__PURE__ */ r("span", { className: "bc-theme-editor-theme-label", children: "Theme:" }),
          /* @__PURE__ */ r("span", { className: "bc-theme-editor-theme-id", children: s }),
          (u == null ? void 0 : u.isPublished) && /* @__PURE__ */ m("span", { className: "bc-theme-editor-live-indicator", children: [
            /* @__PURE__ */ r("span", { className: "bc-theme-editor-live-dot" }),
            "Live"
          ] })
        ] }),
        /* @__PURE__ */ r("div", { className: "bc-theme-editor-spacer" }),
        /* @__PURE__ */ m("div", { className: "bc-theme-editor-actions", children: [
          /* @__PURE__ */ r(
            U,
            {
              variant: "outline",
              size: "sm",
              pill: !0,
              leftIcon: /* @__PURE__ */ r(st, { size: 14 }),
              onClick: I,
              children: "Settings"
            }
          ),
          /* @__PURE__ */ r(
            U,
            {
              variant: "ghost",
              size: "sm",
              leftIcon: /* @__PURE__ */ r(it, { size: 14 }),
              onClick: Y,
              children: "Exit Theme"
            }
          )
        ] })
      ] }),
      p && /* @__PURE__ */ m(
        oo,
        {
          onClose: () => c(!1),
          successMessage: x.successMessage,
          error: x.error,
          children: [
            /* @__PURE__ */ r(
              ft,
              {
                themeColors: g,
                isExpanded: w === "colors",
                onToggle: () => R("colors"),
                isLoading: x.isLoading,
                isAddingColor: x.isAddingColor,
                setIsAddingColor: x.setIsAddingColor,
                newColorKey: x.newColorKey,
                setNewColorKey: x.setNewColorKey,
                newColorValue: x.newColorValue,
                setNewColorValue: x.setNewColorValue,
                onAddColor: x.handleAddColor,
                onUpdateColor: x.handleUpdateColor,
                onRenameColor: x.handleRenameColor,
                onDeleteColor: x.handleDeleteColor
              }
            ),
            /* @__PURE__ */ r(
              ro,
              {
                themeFonts: k,
                isExpanded: w === "fonts",
                onToggle: () => R("fonts"),
                isLoading: x.isLoading,
                onDeleteFont: x.handleDeleteFont,
                onOpenFontPicker: () => S(!0)
              }
            ),
            /* @__PURE__ */ r(
              no,
              {
                themeIcons: b,
                isExpanded: w === "icons",
                onToggle: () => R("icons"),
                isLoading: x.isLoading,
                onDeleteIcon: x.handleDeleteIcon,
                onOpenIconPicker: () => O(!0)
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ r(
        io,
        {
          isOpen: T,
          onClose: () => S(!1),
          onSelect: D,
          isLoading: x.isLoading
        }
      ),
      /* @__PURE__ */ r(
        po,
        {
          isOpen: z,
          onClose: () => O(!1),
          onSelect: C,
          isLoading: x.isLoading
        }
      ),
      x.pendingDelete && /* @__PURE__ */ r(
        ke,
        {
          title: `Delete ${x.pendingDelete.type}`,
          message: `Are you sure you want to delete "${x.pendingDelete.key}"? This action cannot be undone.`,
          confirmLabel: "Delete",
          cancelLabel: "Cancel",
          onConfirm: x.confirmDelete,
          onCancel: x.cancelDelete,
          isLoading: x.isLoading
        }
      )
    ] })
  ] }) : /* @__PURE__ */ m(G, { children: [
    /* @__PURE__ */ r("style", { children: eo({ showSettings: p, viewMode: a, editorMode: o }) }),
    /* @__PURE__ */ m("div", { className: "bc-theme-editor-shell", children: [
      /* @__PURE__ */ m("div", { className: "bc-theme-editor-topbar", children: [
        /* @__PURE__ */ m("div", { className: "bc-theme-editor-logo", children: [
          /* @__PURE__ */ r("div", { className: "bc-theme-editor-logo-icon", children: /* @__PURE__ */ r(lt, { size: 18 }) }),
          /* @__PURE__ */ r("span", { className: "bc-theme-editor-logo-text", children: "Theme Editor" })
        ] }),
        /* @__PURE__ */ m("div", { className: "bc-theme-editor-theme-info", children: [
          /* @__PURE__ */ r("span", { className: "bc-theme-editor-theme-label", children: "Theme:" }),
          /* @__PURE__ */ r("span", { className: "bc-theme-editor-theme-id", children: s }),
          (u == null ? void 0 : u.isPublished) && /* @__PURE__ */ m("span", { className: "bc-theme-editor-live-indicator", children: [
            /* @__PURE__ */ r("span", { className: "bc-theme-editor-live-dot" }),
            "Live"
          ] })
        ] }),
        /* @__PURE__ */ m("div", { className: "bc-theme-editor-viewport-toggle", children: [
          /* @__PURE__ */ r(
            U,
            {
              variant: a === "desktop" ? "primary" : "icon",
              size: "sm",
              onClick: () => l("desktop"),
              "aria-label": "Desktop view",
              children: /* @__PURE__ */ r(yr, { size: 16 })
            }
          ),
          /* @__PURE__ */ r(
            U,
            {
              variant: a === "mobile" ? "primary" : "icon",
              size: "sm",
              onClick: () => l("mobile"),
              "aria-label": "Mobile view",
              children: /* @__PURE__ */ r(Br, { size: 16 })
            }
          )
        ] }),
        /* @__PURE__ */ r("div", { className: "bc-theme-editor-spacer" }),
        /* @__PURE__ */ m("div", { className: "bc-theme-editor-actions", children: [
          /* @__PURE__ */ r(
            U,
            {
              variant: "outline",
              size: "sm",
              pill: !0,
              leftIcon: /* @__PURE__ */ r(st, { size: 14 }),
              onClick: I,
              children: "Settings"
            }
          ),
          /* @__PURE__ */ r(
            U,
            {
              variant: "ghost",
              size: "sm",
              leftIcon: /* @__PURE__ */ r(it, { size: 14 }),
              onClick: Y,
              children: "Exit Theme"
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ r("div", { className: "bc-theme-editor-preview", children: /* @__PURE__ */ r("div", { className: "bc-theme-editor-preview-container", children: /* @__PURE__ */ r("div", { className: "bc-theme-editor-iframe-wrapper", children: /* @__PURE__ */ r(
        "iframe",
        {
          ref: d,
          className: "bc-theme-editor-iframe",
          src: window.location.href,
          onLoad: L,
          title: "Theme Preview"
        }
      ) }) }) }),
      p && /* @__PURE__ */ m(
        oo,
        {
          onClose: () => c(!1),
          successMessage: x.successMessage,
          error: x.error,
          children: [
            /* @__PURE__ */ r(
              ft,
              {
                themeColors: g,
                isExpanded: w === "colors",
                onToggle: () => R("colors"),
                isLoading: x.isLoading,
                isAddingColor: x.isAddingColor,
                setIsAddingColor: x.setIsAddingColor,
                newColorKey: x.newColorKey,
                setNewColorKey: x.setNewColorKey,
                newColorValue: x.newColorValue,
                setNewColorValue: x.setNewColorValue,
                onAddColor: x.handleAddColor,
                onUpdateColor: x.handleUpdateColor,
                onRenameColor: x.handleRenameColor,
                onDeleteColor: x.handleDeleteColor
              }
            ),
            /* @__PURE__ */ r(
              ro,
              {
                themeFonts: k,
                isExpanded: w === "fonts",
                onToggle: () => R("fonts"),
                isLoading: x.isLoading,
                onDeleteFont: x.handleDeleteFont,
                onOpenFontPicker: () => S(!0)
              }
            ),
            /* @__PURE__ */ r(
              no,
              {
                themeIcons: b,
                isExpanded: w === "icons",
                onToggle: () => R("icons"),
                isLoading: x.isLoading,
                onDeleteIcon: x.handleDeleteIcon,
                onOpenIconPicker: () => O(!0)
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ r(
        io,
        {
          isOpen: T,
          onClose: () => S(!1),
          onSelect: D,
          isLoading: x.isLoading
        }
      ),
      /* @__PURE__ */ r(
        po,
        {
          isOpen: z,
          onClose: () => O(!1),
          onSelect: C,
          isLoading: x.isLoading
        }
      ),
      x.pendingDelete && /* @__PURE__ */ r(
        ke,
        {
          title: `Delete ${x.pendingDelete.type}`,
          message: `Are you sure you want to delete "${x.pendingDelete.key}"? This action cannot be undone.`,
          confirmLabel: "Delete",
          cancelLabel: "Cancel",
          onConfirm: x.confirmDelete,
          onCancel: x.cancelDelete,
          isLoading: x.isLoading
        }
      )
    ] })
  ] });
}, Go = (e) => ({
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700
})[e] || 500, ni = (e) => {
  const t = new Date(e), n = (/* @__PURE__ */ new Date()).getTime() - t.getTime(), a = Math.floor(n / (1e3 * 60 * 60 * 24));
  return a === 0 ? "Today" : a === 1 ? "Yesterday" : a < 7 ? `${a} days ago` : t.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric"
  });
}, ai = ({
  conversation: e,
  isActive: t,
  onSelect: o,
  state: n,
  resolveColor: a
}) => {
  const [l, d] = N(!1);
  return /* @__PURE__ */ m(
    "button",
    {
      onClick: () => o(e.conversationId),
      onMouseEnter: () => d(!0),
      onMouseLeave: () => d(!1),
      style: {
        width: "100%",
        textAlign: "left",
        padding: `${n.itemPaddingY}px ${n.itemPaddingX}px`,
        backgroundColor: a(t || l ? n.itemBgColorHover : n.itemBgColor),
        border: "none",
        cursor: "pointer",
        transition: "background-color 0.15s ease",
        borderRadius: "5px",
        display: "block"
      },
      children: [
        /* @__PURE__ */ r(
          "div",
          {
            style: {
              fontSize: `${n.itemTitleFontSize}px`,
              fontWeight: Go(n.itemTitleFontWeight),
              color: a(n.itemTitleColor),
              lineHeight: "24px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "-webkit-box",
              WebkitLineClamp: n.itemTitleLineClamp,
              WebkitBoxOrient: "vertical"
            },
            children: e.title || e.preview
          }
        ),
        n.showTimestamp && /* @__PURE__ */ r(
          "div",
          {
            style: {
              fontSize: `${n.timestampFontSize}px`,
              color: a(n.timestampColor),
              marginTop: `${n.timestampMarginTop}px`
            },
            children: ni(e.lastUpdated)
          }
        )
      ]
    }
  );
}, qi = ({
  conversations: e,
  isLoading: t = !1,
  error: o = null,
  onSelect: n,
  currentConversationId: a,
  widgetId: l = "conversation-history",
  displayName: d = "Conversation History",
  initialState: p = {},
  showHeader: c = !1,
  headerTitle: u = "Chat History",
  onClose: s,
  emptyMessage: g = "No conversations yet"
}) => /* @__PURE__ */ r(
  Jn,
  {
    widgetId: l,
    displayName: d,
    initialState: p,
    children: (y, k) => /* @__PURE__ */ m(
      "div",
      {
        style: {
          display: "flex",
          flexDirection: "column",
          height: "100%",
          backgroundColor: k(y.drawerBgColor)
        },
        children: [
          c && /* @__PURE__ */ m(
            "div",
            {
              style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: `${y.headerPaddingY}px ${y.headerPaddingX}px`,
                borderBottom: "1px solid #e5e7eb",
                flexShrink: 0
              },
              children: [
                /* @__PURE__ */ r(
                  "span",
                  {
                    style: {
                      fontSize: `${y.headerTitleFontSize}px`,
                      fontWeight: Go(y.headerTitleFontWeight),
                      color: k(y.headerTitleColor)
                    },
                    children: u
                  }
                ),
                s && /* @__PURE__ */ r(
                  ii,
                  {
                    onClick: s,
                    color: k(y.headerIconColor),
                    hoverColor: k(y.headerIconColorHover),
                    hoverBgColor: k(y.headerIconBgColorHover)
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ m(
            "div",
            {
              style: {
                flex: 1,
                overflowY: "auto",
                padding: `${y.itemPaddingY}px ${y.itemPaddingX}px`
              },
              children: [
                t && /* @__PURE__ */ r(
                  "div",
                  {
                    style: {
                      display: "flex",
                      justifyContent: "center",
                      padding: `${y.emptyStatePadding}px`
                    },
                    children: /* @__PURE__ */ r(li, { color: k(y.emptyStateColor) })
                  }
                ),
                !t && o && /* @__PURE__ */ r(
                  "div",
                  {
                    style: {
                      backgroundColor: k(y.errorBgColor),
                      color: k(y.errorTextColor),
                      fontSize: `${y.errorFontSize}px`,
                      padding: `${y.errorPadding}px`,
                      borderRadius: `${y.errorBorderRadius}px`
                    },
                    children: o
                  }
                ),
                !t && !o && e.length === 0 && /* @__PURE__ */ r(
                  "div",
                  {
                    style: {
                      textAlign: "center",
                      padding: `${y.emptyStatePadding}px`,
                      fontSize: `${y.emptyStateFontSize}px`,
                      color: k(y.emptyStateColor)
                    },
                    children: g
                  }
                ),
                !t && !o && e.map((f) => /* @__PURE__ */ r(
                  ai,
                  {
                    conversation: f,
                    isActive: f.conversationId === a,
                    onSelect: n,
                    state: y,
                    resolveColor: k
                  },
                  f.conversationId
                ))
              ]
            }
          )
        ]
      }
    )
  }
), ii = ({
  onClick: e,
  color: t,
  hoverColor: o,
  hoverBgColor: n
}) => {
  const [a, l] = N(!1);
  return /* @__PURE__ */ r(
    "button",
    {
      onClick: e,
      onMouseEnter: () => l(!0),
      onMouseLeave: () => l(!1),
      "aria-label": "Close",
      style: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "28px",
        height: "28px",
        borderRadius: "6px",
        border: "none",
        cursor: "pointer",
        backgroundColor: a ? n : "transparent",
        transition: "background-color 0.15s ease"
      },
      children: /* @__PURE__ */ m(
        "svg",
        {
          width: "16",
          height: "16",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: a ? o : t,
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          children: [
            /* @__PURE__ */ r("line", { x1: "18", y1: "6", x2: "6", y2: "18" }),
            /* @__PURE__ */ r("line", { x1: "6", y1: "6", x2: "18", y2: "18" })
          ]
        }
      )
    }
  );
}, li = ({ color: e }) => /* @__PURE__ */ m(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    style: {
      animation: "bc-history-spin 1s linear infinite"
    },
    children: [
      /* @__PURE__ */ r("style", { children: `
          @keyframes bc-history-spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        ` }),
      /* @__PURE__ */ r(
        "circle",
        {
          cx: "12",
          cy: "12",
          r: "10",
          stroke: e,
          strokeWidth: "3",
          strokeLinecap: "round",
          strokeDasharray: "32",
          strokeDashoffset: "12"
        }
      )
    ]
  }
);
export {
  U as Button,
  Ri as BuyBoxWidget,
  Hi as ChainOfThoughtWidget,
  ki as ChatInput,
  Ti as ConciergeHeaderWidget,
  Jn as ConversationHistoryWidget,
  Bi as ConversationStartersWidget,
  ji as DailyDealsWidget,
  wi as ELEMENT_GROUPS,
  wo as EditPanel,
  Wi as FeaturedProductWidget,
  Ei as FloatingButtonWidget,
  zi as FollowUpQueriesWidget,
  Fi as HeaderWidget,
  qi as HistoryList,
  vi as MessageBubbleWidget,
  Oi as ProductCardCarouselWidget,
  Yi as ProductComparisonWidget,
  Li as PurchaseHistoryWidget,
  Ui as RetailerIconWidget,
  $i as RewardOpportunitiesWidget,
  Xi as RewardPillWidget,
  Mi as SearchQueryPillWidget,
  Di as StoreLocatorWidget,
  Ai as SuggestionListWidget,
  Qi as SurveyCard,
  Gi as SurveysWidget,
  Ji as TextBox,
  Zi as ThemeManager,
  Ii as TrendingCardWidget,
  Si as TypingIndicatorWidget,
  Ni as VariantPickerWidget,
  Ae as WIDGET_THEME_QUERY_KEY,
  Pi as WelcomeScreenWidget,
  K as WidgetWrapper,
  hi as calculateRewardPercent,
  sn as clearThemeParams,
  dn as clearUrlParams,
  i as colors,
  M as customColor,
  gi as formatDate,
  mi as formatMoney,
  ui as formatRelativeTime,
  bi as getFontWeightValue,
  ln as getThemeParams,
  _r as isColorValue,
  an as saveThemeParams,
  yi as slugify,
  cn as syncUrlToStorage,
  P as themeColor,
  fi as truncateText,
  xi as updateUrlParams,
  So as useEditMode,
  Ci as useResolveColor,
  nt as useThemeColors,
  Mo as useThemeFonts,
  Ao as useThemeIcons,
  zn as useWidgetConfig,
  Fn as useWidgetEdit,
  q as useWidgetEditable,
  Se as useWidgetTheme,
  we as useWidgetThemeParams
};
//# sourceMappingURL=index.js.map
